<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader :loading="!flagNav" transition="scale-transition" max-height="64"
        type="table-heading">
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ $t("PlayGround") }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title">
              <v-tooltip location="bottom" offset-x>
                <template #activator="{ props }">
                  <v-icon
                    v-bind="props"
                    :color="NavbarBtnColorTheme
                      ? `#${NavbarBtnColorTheme}`
                      : '#5179ef'"
                    size="24"
                  >
                    mdi-information-slab-circle-outline
                  </v-icon>
                </template>
                <div class="text-body-2">
                  <!-- uncomment any lines you need -->
                  <!-- <p class="mb-0">:userid (request MS Team ID)</p> -->
                  <p class="mb-0">:clearmemory (clear short memory)</p>
                  <p class="mb-0">:memory (show short memory)</p>
                  <p class="mb-0">:lastmemory (show last memory of last conversation)</p>
                  <!-- <p class="mb-0">:model (show all model)</p> -->
                </div>
              </v-tooltip>
              <v-icon v-on:click="OpenFullStream" v-if="roleId == 0 || roleId == 1" :style="'color: #' + (NavbarBtnColorTheme != null || NavbarBtnColorTheme != undefined ?
                NavbarBtnColorTheme : '5179ef')"
                style=" cursor: pointer; font-size: medium; margin-left: 12px; padding: 10px; margin-right: 5px;">mdi-vector-arrange-above</v-icon>

              <v-app-bar-nav-icon style="cursor: pointer;" :style="'color: #' + (NavbarBtnColorTheme != null || NavbarBtnColorTheme != undefined ?
                NavbarBtnColorTheme : '5179ef')"
                v-on:click="SetPopup = !SetPopup"></v-app-bar-nav-icon>
            </v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>
      <v-row
        style=" position: sticky; width: -webkit-fill-available; padding-right: 12px; margin-top: 0px; height:auto;"
        align-auto>
        <v-col v-if="SetPopup" class="mr-0" style="max-width: 300px; background-color: white; margin: 12px;
            box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
            border-radius: 8px; margin-bottom: 25px; overflow-y: auto; " :style="{ maxHeight: maxHeight + 'px' }">
          <v-row>
            <v-col>
              <label style="font-weight: bold;">Parameters</label>
            </v-col>
          </v-row>
          <v-row style="margin-top:0px; padding-top:0px;">
            <v-col cols="6" style="padding-top: 0px;">
              <label style="font-size: 12px;">Time Delay Model A</label>
            </v-col>

            <v-col cols="6" style="padding-top: 0px;">
              <label style="font-size: 12px;">Time Delay Model B</label>
            </v-col>
          </v-row>
          <v-row style="margin-top: 0px;">
            <v-col cols="6" style="padding-top: 0px;">
              <v-text-field 
                class="modern-number-field" 
                v-model="configLeft.typingSpeed"
                variant="outlined"
                density="compact"
                type="number" 
                min="0"
                hide-details
                :color="selectedColor"
                style="padding-top: 0px;">
                <template v-slot:prepend-inner>
                  <v-icon size="small" :color="selectedColor" class="mr-1">
                    mdi-timer-outline
                  </v-icon>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="6" style="padding-top: 0px;">
              <v-text-field 
                class="modern-number-field" 
                v-model="configRight.typingSpeed"
                variant="outlined"
                density="compact"
                type="number" 
                min="0"
                hide-details
                :color="selectedColor"
                style="padding-top: 0px;">
                <template v-slot:prepend-inner>
                  <v-icon size="small" :color="selectedColor" class="mr-1">
                    mdi-timer-outline
                  </v-icon>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row style="display: flex; align-items: center;margin-top: 10px;" v-if="configLeft.model != '' && configLeft.model != null">
            <v-col class="col-8" style=" padding-top: 0px;">
              <label style="font-weight: bold;">Log Model A</label>
            </v-col>
            <v-col class="col-4" style=" padding-top: 0px;text-align: end;padding-right: 5px;">
              <v-btn 
                v-if="LOG_STATUS_LEFT == false" 
                @click="LOG_STATUS_LEFT = true; LOG_STATUS_RIGHT = false;"
                variant="flat"
                icon
                size="small"
                class="log-toggle-button"
                :style="{ color: selectedColor }">
                <v-icon size="18">mdi-chevron-down</v-icon>
                <v-tooltip activator="parent" location="top">
                  Expand Log Model A
                </v-tooltip>
              </v-btn>

              <v-btn 
                v-else 
                @click="LOG_STATUS_LEFT = false"
                variant="flat"
                icon
                size="small" 
                class="log-toggle-button"
                :style="{ color: selectedColor }">
                <v-icon size="18">mdi-chevron-up</v-icon>
                <v-tooltip activator="parent" location="top">
                  Collapse Log Model A
                </v-tooltip>
              </v-btn>
            </v-col>
          </v-row>
          <div v-if="LOG_STATUS_LEFT == true"
            style="border: 1px solid;     border-radius: 5px;    padding: 12px; padding-top: 0px;">
            <!-- prompt -->
            <v-row style="margin-top: 0px;">
              <v-col style="margin-top: 0px;">
                <label style="font-size: 12px;">System Message</label>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style=" padding-top: 0px;">
                <v-textarea class="Log_text_textarea" v-model="DataLogLeft.Prompt" outlined readonly
                  rows="2"></v-textarea>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style="margin-top: 0px;">
                <label style="font-size: 12px;">Knowledge</label>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style=" padding-top: 0px;">
                <v-textarea class="Log_text_textarea" v-model="DataLogLeft.Vector" outlined readonly
                  rows="2"></v-textarea>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style="margin-top: 0px;">
                <label style="font-size: 12px;">SQL Query</label>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style=" padding-top: 0px;">
                <v-textarea class="Log_text_textarea" v-model="DataLogLeft.ReplySQL" outlined readonly
                  rows="2"></v-textarea>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style="margin-top: 0px;">
                <label style="font-size: 12px;">SQL Query Result</label>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style=" padding-top: 0px;">
                <v-textarea class="Log_text_textarea" v-model="DataLogLeft.ReplyDataSelect" outlined readonly
                  rows="2"></v-textarea>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style="margin-top: 0px;">
                <label style="font-size: 12px;">Intent Flow</label>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style=" padding-top: 0px;">
                <v-textarea class="Log_text_textarea" v-model="DataLogLeft.FlowActionIntent" outlined readonly
                  rows="2"></v-textarea>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style="margin-top: 0px;">
                <label style="font-size: 12px;">Memory</label>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style=" padding-top: 0px;">
                <v-textarea class="Log_text_textarea" v-model="DataLogLeft.Memory" outlined readonly
                  rows="2"></v-textarea>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style="margin-top: 0px;">
                <label style="font-size: 12px;font-weight: bold;">LLMs Model</label>
              </v-col>
            </v-row>
            <div style="border: 1px solid;    border-radius: 5px;    padding: 12px;">
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">ModelID : {{ DataLogLeft.GPT_Model.modelId }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">ModelName : {{ DataLogLeft.GPT_Model.modelName }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">Provider : {{ DataLogLeft.GPT_Model.Provider }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">Model : {{ DataLogLeft.GPT_Model.model }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">SystemMessage</label>
                  <v-textarea class="Log_text_textarea" v-model="DataLogLeft.GPT_Model.promptTemplate" outlined
                    readonly rows="2"></v-textarea>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">KnowledgeDocuments</label>
                  <v-textarea class="Log_text_textarea" v-model="DataLogLeft.GPT_Model.vectordbName" outlined
                    readonly rows="2"></v-textarea>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">Extension : {{ DataLogLeft.GPT_Model.extension }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">Description : {{ DataLogLeft.GPT_Model.description }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">Gender : {{ DataLogLeft.GPT_Model.gender }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">TopN_Chunks : {{ DataLogLeft.GPT_Model.topVDB }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">Internet : {{ DataLogLeft.GPT_Model.internet }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">Feedback : {{ DataLogLeft.GPT_Model.feedback }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">HistoryCount : {{ DataLogLeft.GPT_Model.historyCount }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">HistoryMinute : {{ DataLogLeft.GPT_Model.historyMinute }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">Temperature : {{ DataLogLeft.GPT_Model.temperature }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">Top_P : {{ DataLogLeft.GPT_Model.topP }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">Frequency_Penalty : {{ DataLogLeft.GPT_Model.frequency_penalty
                  }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">Presence_Penalty : {{ DataLogLeft.GPT_Model.presence_penalty
                  }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">Stop_Sequence : {{ DataLogLeft.GPT_Model.Stop }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">MaxTokensResponse : {{ DataLogLeft.GPT_Model.maxTokens }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">IsStream : {{ DataLogLeft.GPT_Model.isStream }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">Endpoint </label>
                  <v-textarea class="Log_text_textarea" v-model="DataLogLeft.GPT_Model.EndpointURL" outlined
                    readonly rows="2"></v-textarea>
                </v-col>
              </v-row>
            </div>
            <v-row style="margin-top: 0px;">
              <v-col style="margin-top: 0px;">
                <label style="font-size: 12px;">{{ $t('UserQuery') }} : {{ DataLogLeft.TextVector }}</label>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style="margin-top: 0px;">
                <label style="font-size: 12px;">{{ $t('OrgVectorSearch') }} : {{ DataLogLeft.Text }}</label>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style="margin-top: 0px;">
                <label style="font-size: 12px;">{{ $t('ModVectorSearch') }} : {{ DataLogLeft.Translate ?? "-" }}</label>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style="margin-top: 0px;">
                <label style="font-size: 12px;">Vector Cosine</label>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style=" padding-top: 0px;">
                <v-textarea class="Log_text_textarea" v-model="DataLogLeft.VectorCoise" outlined readonly
                  rows="2"></v-textarea>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style="margin-top: 0px;">
                <label style="font-size: 12px;">Private Memory</label>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style=" padding-top: 0px;">
                <v-textarea class="Log_text_textarea" v-model="DataLogLeft.Private_Memory" outlined readonly
                  rows="2"></v-textarea>
              </v-col>
            </v-row>
          </div>

          <v-row style="display: flex; align-items: center;margin-top: 10px;" v-if="configRight.model != '' && configRight.model != null">
            <v-col class="col-8" style=" padding-top: 0px;">
              <label style="font-weight: bold;">Log Model B</label>
            </v-col>
            <v-col class="col-4" style=" padding-top: 0px;text-align: end;justify-content: center; padding-right: 5px;">
              <v-btn 
                v-if="LOG_STATUS_RIGHT == false" 
                @click="LOG_STATUS_RIGHT = true; LOG_STATUS_LEFT = false;"
                variant="flat"
                icon
                size="small"
                class="log-toggle-button"
                :style="{ color: selectedColor }">
                <v-icon size="18">mdi-chevron-down</v-icon>
                <v-tooltip activator="parent" location="top">
                  Expand Log Model B
                </v-tooltip>
              </v-btn>

              <v-btn 
                v-else 
                @click="LOG_STATUS_RIGHT = false"
                variant="flat"
                icon
                size="small"
                class="log-toggle-button active"
                :style="{ color: selectedColor }">
                <v-icon size="18">mdi-chevron-up</v-icon>
                <v-tooltip activator="parent" location="top">
                  Collapse Log Model B
                </v-tooltip>
              </v-btn>
            </v-col>
          </v-row>
          <div v-if="LOG_STATUS_RIGHT == true"
            style="border: 1px solid;     border-radius: 5px;    padding: 12px; padding-top: 0px;">
            <!-- prompt -->
            <v-row style="margin-top: 0px;">
              <v-col style="margin-top: 0px;">
                <label style="font-size: 12px;">System Message</label>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style=" padding-top: 0px;">
                <v-textarea class="Log_text_textarea" v-model="DataLogRight.Prompt" outlined readonly
                  rows="2"></v-textarea>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style="margin-top: 0px;">
                <label style="font-size: 12px;">Knowledge</label>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style=" padding-top: 0px;">
                <v-textarea class="Log_text_textarea" v-model="DataLogRight.Vector" outlined readonly
                  rows="2"></v-textarea>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style="margin-top: 0px;">
                <label style="font-size: 12px;">SQL Query</label>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style=" padding-top: 0px;">
                <v-textarea class="Log_text_textarea" v-model="DataLogRight.ReplySQL" outlined readonly
                  rows="2"></v-textarea>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style="margin-top: 0px;">
                <label style="font-size: 12px;">SQL Query Result</label>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style=" padding-top: 0px;">
                <v-textarea class="Log_text_textarea" v-model="DataLogRight.ReplyDataSelect" outlined readonly
                  rows="2"></v-textarea>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style="margin-top: 0px;">
                <label style="font-size: 12px;">Intent Flow</label>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style=" padding-top: 0px;">
                <v-textarea class="Log_text_textarea" v-model="DataLogRight.FlowActionIntent" outlined readonly
                  rows="2"></v-textarea>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style="margin-top: 0px;">
                <label style="font-size: 12px;">Memory</label>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style=" padding-top: 0px;">
                <v-textarea class="Log_text_textarea" v-model="DataLogRight.Memory" outlined readonly
                  rows="2"></v-textarea>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style="margin-top: 0px;">
                <label style="font-size: 12px;font-weight: bold;">LLMs Model</label>
              </v-col>
            </v-row>
            <div style="border: 1px solid;    border-radius: 5px;    padding: 12px;">
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">ModelID : {{ DataLogRight.GPT_Model.modelId }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">ModelName : {{ DataLogRight.GPT_Model.modelName }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">Provider : {{ DataLogRight.GPT_Model.Provider }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">Model : {{ DataLogRight.GPT_Model.model }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">SystemMessage</label>
                  <v-textarea class="Log_text_textarea" v-model="DataLogRight.GPT_Model.promptTemplate" outlined
                    readonly rows="2"></v-textarea>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">KnowledgeDocuments</label>
                  <v-textarea class="Log_text_textarea" v-model="DataLogRight.GPT_Model.vectordbName" outlined
                    readonly rows="2"></v-textarea>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">Extension : {{ DataLogRight.GPT_Model.extension }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">Description : {{ DataLogRight.GPT_Model.description }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">Gender : {{ DataLogRight.GPT_Model.gender }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">TopN_Chunks : {{ DataLogRight.GPT_Model.topVDB }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">Internet : {{ DataLogRight.GPT_Model.internet }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">Feedback : {{ DataLogRight.GPT_Model.feedback }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">HistoryCount : {{ DataLogRight.GPT_Model.historyCount }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">HistoryMinute : {{ DataLogRight.GPT_Model.historyMinute }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">Temperature : {{ DataLogRight.GPT_Model.temperature }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">Top_P : {{ DataLogRight.GPT_Model.topP }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">Frequency_Penalty : {{ DataLogRight.GPT_Model.frequency_penalty
                  }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">Presence_Penalty : {{ DataLogRight.GPT_Model.presence_penalty
                  }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">Stop_Sequence : {{ DataLogRight.GPT_Model.Stop }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">MaxTokensResponse : {{ DataLogRight.GPT_Model.maxTokens }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">IsStream : {{ DataLogRight.GPT_Model.isStream }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">Endpoint </label>
                  <v-textarea class="Log_text_textarea" v-model="DataLogRight.GPT_Model.EndpointURL" outlined
                    readonly rows="2"></v-textarea>
                </v-col>
              </v-row>
            </div>
            <v-row style="margin-top: 0px;">
              <v-col style="margin-top: 0px;">
                <label style="font-size: 12px;">{{ $t('UserQuery') }} : {{ DataLogRight.TextVector }}</label>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style="margin-top: 0px;">
                <label style="font-size: 12px;">{{ $t('OrgVectorSearch') }} : {{ DataLogRight.Text }}</label>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style="margin-top: 0px;">
                <label style="font-size: 12px;">{{ $t('ModVectorSearch') }} : {{ DataLogRight.Translate ?? "-"
                }}</label>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style="margin-top: 0px;">
                <label style="font-size: 12px;">Vector Cosine</label>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style=" padding-top: 0px;">
                <v-textarea class="Log_text_textarea" v-model="DataLogRight.VectorCoise" outlined readonly
                  rows="2"></v-textarea>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style="margin-top: 0px;">
                <label style="font-size: 12px;">Private Memory</label>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col style=" padding-top: 0px;">
                <v-textarea class="Log_text_textarea" v-model="DataLogRight.Private_Memory" outlined readonly
                  rows="2"></v-textarea>
              </v-col>
            </v-row>
          </div>

          <div v-if="Topic_STATUS == true" style="    padding: 0px; ">
            <v-row id="toppic_list_id"
              style="margin-top: 0px;    overflow-x: hidden;    overflow-y: auto;    height: calc(100vh - 330px); min-height: 29vh;display: block;">
              <v-col class="col-12" v-for="(iTopic, indexTopic) in listTopic"
                :key="iTopic.topicID" style="    padding-top: 0px; padding-bottom: 5px; ">
                <v-card v-show="iTopic.status == true" style="cursor:pointer;">
                  <v-card-title class="  white--text" style="    padding: 5px;padding-left: 10px; "
                    :style="'background-color:' + (Log_History_TopicID == iTopic.topicID ? '#004e8c' : '#ff4646')">
                    <span style="width: 88%;">
                      <v-text-field class="Cls_Text_field_TopicName " :id="'TopicId_' + iTopic.topicID" outlined dense
                        v-model="iTopic.topicName"
                        v-on:blur="iTopic.status = false; RenameTopicStream(iTopic.topicID, iTopic.keyTopic, iTopic.topicName, indexTopic, null)"
                        v-on:keyup="keyupKeyRename(e)"
                        v-on:keyup.enter="iTopic.status = false; RenameTopicStream(iTopic.topicID, iTopic.keyTopic, iTopic.topicName, indexTopic, null)"></v-text-field>
                    </span>
                    <v-menu bottom left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn dark icon v-bind="attrs" v-on="on" style=" width: 11%;    height: 25px;   ">
                          <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item link
                          v-on:click="RenameClick(iTopic, 'TopicId_' + iTopic.topicID)">
                          <v-list-item-title>Rename</v-list-item-title>
                        </v-list-item>
                        <v-list-item link
                          v-on:click="DeleteTopicStream(iTopic.topicID, indexTopic)">
                          <v-list-item-title>Delete chat</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-card-title>
                </v-card>
                <v-card v-show="iTopic.status != true" style="cursor:pointer;"
                  v-on:click="Click_History_List(iTopic.topicID, iTopic.topicName, iTopic.topicModelID, iTopic.topicModelID_long, iTopic.keyTopic);">
                  <v-card-title class="white--text" style="    padding: 5px;padding-left: 10px; "
                    :style="'background-color:' + (Log_History_TopicID == iTopic.topicID ? '#004e8c' : '#ff4646')">
                    <v-tooltip top open-delay="150">
                      <template v-slot:activator="{ on }">
                        <span v-on="on"
                          style=" font-size: 15px;white-space: nowrap;width: 88%;overflow: hidden;text-overflow: ellipsis;">
                          {{ iTopic.topicName }}
                        </span>
                      </template>
                      <span> {{ iTopic.topicName }}</span>
                    </v-tooltip>
                    <v-menu bottom left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn dark icon v-bind="attrs" v-on="on" style=" width: 11%;    height: 25px;   ">
                          <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item link
                          v-on:click="RenameClick(iTopic, 'TopicId_' + iTopic.topicID)">
                          <v-list-item-title>Rename</v-list-item-title>
                        </v-list-item>
                        <v-list-item link
                          v-on:click="DeleteTopicStream(iTopic.topicID, iTopic.keyTopic, indexTopic)">
                          <v-list-item-title>Delete chat</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-card-title>
                </v-card>
              </v-col>
            </v-row>
          </div>

          <div v-if="false" style=" padding: 0px; ">
            <v-col class="col-12" v-for="(iTopic, indexTopic) in listTopic"
              :key="iTopic.topicID" style="  padding: 0px 0px 5px 0px; ">
              <v-card v-show="iTopic.status == true" style="cursor:pointer;">
                <v-card-title class="  white--text" style="    padding: 5px;padding-left: 10px; "
                  :style="'background-color:' + (Log_History_TopicID == iTopic.topicID ? '#004e8c' : '#ff4646')">
                  <span style="width: 88%;">
                    <v-text-field class="Cls_Text_field_TopicName " :id="'TopicId_' + iTopic.topicID" outlined dense
                      v-model="iTopic.topicName"
                      v-on:blur="iTopic.status = false; RenameTopicStream(iTopic.topicID, iTopic.keyTopic, iTopic.topicName, null)"
                      v-on:keyup.enter="iTopic.status = false; RenameTopicStream(iTopic.topicID, iTopic.keyTopic, iTopic.topicName, null)"></v-text-field>
                  </span>
                  <v-menu bottom left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn dark icon v-bind="attrs" v-on="on" style=" width: 11%;    height: 25px;   ">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item link
                        v-on:click="RenameClick(iTopic, 'TopicId_' + iTopic.topicID)">
                        <v-list-item-title>Rename</v-list-item-title>
                      </v-list-item>
                      <v-list-item link
                        v-on:click="DeleteTopicStream(iTopic.topicID, indexTopic)">
                        <v-list-item-title>Delete chat</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-card-title>
              </v-card>
              <v-card v-show="iTopic.status != true" style="cursor:pointer;"
                v-on:click="Click_History_List(iTopic.topicID, iTopic.topicName, iTopic.topicModelID, iTopic.topicModelID_long, iTopic.keyTopic);">
                <v-card-title class="  white--text" style="    padding: 5px;padding-left: 10px; "
                  :style="'background-color:' + (Log_History_TopicID == iTopic.topicID ? '#004e8c' : '#ff4646')">
                  <v-tooltip top open-delay="150">
                    <template v-slot:activator="{ on }">
                      <span v-on="on"
                        style=" font-size: 15px;white-space: nowrap;width: 88%;overflow: hidden;text-overflow: ellipsis;">
                        {{ iTopic.topicName }}
                      </span>
                    </template>
                    <span> {{ iTopic.topicName }}</span>
                  </v-tooltip>
                  <v-menu bottom left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn dark icon v-bind="attrs" v-on="on" style=" width: 11%;    height: 25px;   ">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item link
                        v-on:click="RenameClick(iTopic, 'TopicId_' + iTopic.topicID)">
                        <v-list-item-title>Rename</v-list-item-title>
                      </v-list-item>
                      <v-list-item link
                        v-on:click="DeleteTopicStream(iTopic.topicID, indexTopic)">
                        <v-list-item-title>Delete chat</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-card-title>
              </v-card>
            </v-col>
          </div>
        </v-col>
        <v-col class="pb-0 pr-0" :style="SetPopup ? { maxWidth: '80%' } : { maxWidth: '100%' }">
          <!-- style="height: 560px;" -->
          <v-card id="chatSide" class="card2 d-flex flex-column px-0 mb-5" style="height: auto;">
            <v-row class="px-4" style="flex: none !important;"><v-col cols="6" class="px-4"><label class="px-3">Model
                  A</label></v-col><v-col cols="6" class="px-4"><label>Model B</label></v-col></v-row>
            <div class="d-flex flex-wrap flex-row px-4" ref="ModelRef">
              <div class="d-flex flex-shrink-1 px-4" style="flex-basis:50%; gap:12px;">
                <v-autocomplete 
                  ref="model" 
                  label="Model name" 
                  :items="listDDModelDisplayName"
                  :item-title="getItemModelNameText" 
                  hide-details 
                  v-if="configLeft.typeUpdate == true"
                  item-value="modelDisplayID"
                  @update:model-value="savechange($event, 'Left')"
                  variant="outlined" 
                  v-model="configLeft.modelDisplay" 
                  density="compact">
                  <template v-slot:append-inner>
                    <v-tooltip location="top" max-width="300px">
                      <template v-slot:activator="{ props }">
                        <v-icon 
                          size="x-small" 
                          v-bind="props">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{ 'select for compare your model' }}</span>
                    </v-tooltip>
                  </template>
                </v-autocomplete>
                <v-text-field 
                  density="compact" 
                  variant="outlined" 
                  hide-details 
                  label="Model name" 
                  v-model="configLeft.modelName" 
                  v-else>
                </v-text-field>
                <v-tooltip location="top" v-if="configLeft.model == '' || configLeft.model == null">
                  <template v-slot:activator="{ props }">
                    <v-btn 
                      icon 
                      variant="text" 
                      v-bind="props" 
                      class="text-primary" 
                      @click="CreateDialog('Left')">
                      <v-icon>mdi-plus-circle-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Create</span>
                </v-tooltip>
                <v-tooltip location="top" v-else>
                  <template v-slot:activator="{ props }">
                    <v-btn 
                      icon 
                      variant="text" 
                      v-bind="props" 
                      class="text-primary" 
                      @click="EditDialog('Left')">
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit</span>
                </v-tooltip>
                <v-tooltip location="top">
                  <template v-slot:activator="{ props }">
                    <v-btn 
                      icon 
                      variant="text" 
                      :disabled="configLeft.model == '' || configLeft.model == null" 
                      v-bind="props"
                      class="text-primary" 
                      @click="dialogSave = true; DialogSide = 'Left'">
                      <v-icon>mdi-content-save</v-icon>
                    </v-btn>
                  </template>
                  <span>Save</span>
                </v-tooltip>

                <v-tooltip location="top">
                  <template v-slot:activator="{ props }">
                    <v-btn 
                      icon 
                      variant="text" 
                      :disabled="configLeft.model == '' || configLeft.model == null" 
                      v-bind="props"
                      class="text-error" 
                      @click="ClearModel('Left');">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </template>
                  <span>Clear model</span>
                </v-tooltip>
              </div>
              <div class="d-flex flex-shrink-1 px-4 align-center justify-end" style="flex-basis:50%; gap:12px;">
                <v-autocomplete 
                  ref="model" 
                  label="Model name" 
                  :items="listDDModelDisplayName"
                  :item-title="getItemModelNameText" 
                  hide-details 
                  v-if="configRight.typeUpdate == true"
                  item-value="modelDisplayID"
                  @update:model-value="savechange($event, 'Right')"
                  variant="outlined" 
                  v-model="configRight.modelDisplay" 
                  density="compact">
                  <template v-slot:append-inner>
                    <v-tooltip location="top" max-width="300px">
                      <template v-slot:activator="{ props }">
                        <v-icon 
                          size="x-small" 
                          v-bind="props">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{ 'select for compare your model' }}</span>
                    </v-tooltip>
                  </template>
                </v-autocomplete>
                <v-text-field 
                  density="compact" 
                  variant="outlined" 
                  hide-details 
                  label="Model name" 
                  v-model="configRight.modelName" 
                  v-else>
                </v-text-field>

                <v-tooltip location="top" v-if="configRight.model == '' || configRight.model == null">
                  <template v-slot:activator="{ props }">
                    <v-btn 
                      icon 
                      variant="text" 
                      v-bind="props" 
                      class="text-primary " 
                      @click="CreateDialog('Right')">
                      <v-icon>mdi-plus-circle-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Create</span>
                </v-tooltip>
                <v-tooltip location="top" v-else>
                  <template v-slot:activator="{ props }">
                    <v-btn 
                      icon 
                      variant="text" 
                      v-bind="props" 
                      class="text-primary" 
                      @click="EditDialog('Right')">
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit</span>
                </v-tooltip>

                <v-tooltip location="top">
                  <template v-slot:activator="{ props }">
                    <v-btn 
                      icon 
                      variant="text" 
                      :disabled="configRight.model == '' || configRight.model == null" 
                      v-bind="props"
                      class="text-primary" 
                      @click="dialogSave = true; DialogSide = 'Right'">
                      <v-icon>mdi-content-save</v-icon>
                    </v-btn>
                  </template>
                  <span>Save</span>
                </v-tooltip>

                <v-tooltip location="top">
                  <template v-slot:activator="{ props }">
                    <v-btn 
                      icon 
                      variant="text" 
                      :disabled="configRight.model == '' || configRight.model == null" 
                      v-bind="props"
                      class="text-error" 
                      @click="ClearModel('Right');">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </template>
                  <span>Clear model</span>
                </v-tooltip>
              </div>
            </div>


            <div class="d-flex flex-wrap flex-row px-4 pt-4" ref="ConfigPromtAndParametersRef">
              <div class="d-flex flex-column flex-shrink-1 px-4" style="flex-basis:50%; gap:12px; max-width: 50%;" ref="LeftConfig">
                <v-row class="d-flex flex-row flex-shrink-1">
                  <v-col>
                    <v-expansion-panels accordion v-model="panelLeft">
                      <v-expansion-panel>
                        <v-expansion-panel-title>
                          <template v-slot:actions>
                            <v-icon class="icon" icon="mdi-chevron-down"></v-icon>
                          </template>
                          <span class="header">Configuration A</span>
                        </v-expansion-panel-title>
                        <v-expansion-panel-text>
                          <v-row class="ma-0 pt-0">
                            <v-col class="mt-0 pt-0">
                              <label class="modern-label">User Id</label>
                            </v-col>
                          </v-row>
                          <v-row style="margin-top: 0px;" class="ma-0">
                            <v-col style="padding-top: 0px;">
                              <v-text-field 
                                class="modern-config-field" 
                                variant="outlined" 
                                density="compact" 
                                v-model="configLeft.User_Id"
                                hide-details 
                                style="padding-top: 0px;">
                                <template v-slot:prepend-inner>
                                  <v-icon size="small" color="primary" class="mr-1">
                                    mdi-account-outline
                                  </v-icon>
                                </template>
                              </v-text-field>
                            </v-col>
                          </v-row>
                          
                          <v-row class="flex mx-0 pt-0" justify="center" style="align-content: start;">
                            <v-col class="ma-0 pa-0" cols="12">
                              <v-textarea 
                                id="PromptTemplate" 
                                label="Prompt template"
                                v-model="configLeft.promptTemplate" 
                                :rules="[validatePrompt(configLeft.promptTemplate)]"
                                variant="outlined" 
                                counter 
                                auto-grow
                                height="180px" 
                                rows="10" 
                                required
                                class="modern-textarea">
                                <template v-slot:prepend-inner>
                                  <v-icon size="small" color="primary" class="mr-1">
                                    mdi-text-box-outline
                                  </v-icon>
                                </template>
                              </v-textarea>
                            </v-col>
                            
                            <v-row style="align-content: start;">
                              <v-col class="pa-1" cols="3" sm="12" :md="SetPopup ? 12 : 6" :lg="SetPopup ? 6 : 3">
                                <v-text-field 
                                  label="Temperature*" 
                                  v-model="configLeft.temperature" 
                                  density="compact" 
                                  variant="outlined"
                                  @keypress="isNumber($event)" 
                                  :rules="[validateInput0_1(configLeft.temperature)]"
                                  required
                                  class="modern-parameter-field">
                                  <template v-slot:prepend-inner>
                                    <v-icon size="small" color="primary" class="mr-1">
                                      mdi-thermometer
                                    </v-icon>
                                  </template>
                                  <template v-slot:append-inner>
                                    <v-tooltip location="top">
                                      <template v-slot:activator="{ props }">
                                        <v-icon 
                                          size="x-small" 
                                          v-bind="props"
                                          color="grey-darken-1">
                                          mdi-information-outline
                                        </v-icon>
                                      </template>
                                      <span>Controls randomness: 0 = focused, 1 = creative</span>
                                    </v-tooltip>
                                  </template>
                                </v-text-field>
                              </v-col>
                              
                              <v-col class="pa-1" cols="3" sm="12" :md="SetPopup ? 12 : 6" :lg="SetPopup ? 6 : 3">
                                <v-text-field 
                                  label="Top p*" 
                                  v-model="configLeft.topP" 
                                  density="compact" 
                                  variant="outlined" 
                                  required
                                  :disabled="configLeft.provider == 'Anthropic'" 
                                  @keypress="isNumber($event)"
                                  :rules="[validateInput0_1(configLeft.topP)]"
                                  class="modern-parameter-field">
                                  <template v-slot:prepend-inner>
                                    <v-icon size="small" color="primary" class="mr-1">
                                      mdi-percent
                                    </v-icon>
                                  </template>
                                  <template v-slot:append-inner>
                                    <v-tooltip location="top">
                                      <template v-slot:activator="{ props }">
                                        <v-icon 
                                          size="x-small" 
                                          v-bind="props"
                                          color="grey-darken-1">
                                          mdi-information-outline
                                        </v-icon>
                                      </template>
                                      <span>Nucleus sampling parameter</span>
                                    </v-tooltip>
                                  </template>
                                </v-text-field>
                              </v-col>
                              
                              <v-col class="pa-1" sm="12" :md="SetPopup ? 12 : 6" :lg="SetPopup ? 6 : 3">
                                <v-text-field 
                                  label="Frequency penalty"
                                  :disabled="configLeft.provider == 'Anthropic'" 
                                  v-model="configLeft.frequencyPenalty"
                                  @keypress="isNumber($event)" 
                                  density="compact" 
                                  variant="outlined"
                                  :rules="[validateInput0_2(configLeft.frequencyPenalty)]"
                                  class="modern-parameter-field">
                                  <template v-slot:prepend-inner>
                                    <v-icon size="small" color="primary" class="mr-1">
                                      mdi-repeat-off
                                    </v-icon>
                                  </template>
                                  <template v-slot:append-inner>
                                    <v-tooltip location="top">
                                      <template v-slot:activator="{ props }">
                                        <v-icon 
                                          size="x-small" 
                                          v-bind="props"
                                          color="grey-darken-1">
                                          mdi-information-outline
                                        </v-icon>
                                      </template>
                                      <span>Reduces repetition of frequent tokens</span>
                                    </v-tooltip>
                                  </template>
                                </v-text-field>
                              </v-col>
                              
                              <v-col class="pa-1" cols="3" sm="12" :md="SetPopup ? 12 : 6" :lg="SetPopup ? 6 : 3">
                                <v-text-field 
                                  label="Presence penalty" 
                                  :disabled="configLeft.provider == 'Anthropic'"
                                  v-model="configLeft.presencePenalty" 
                                  @keypress="isNumber($event)" 
                                  density="compact" 
                                  variant="outlined"
                                  :rules="[validateInput0_2(configLeft.presencePenalty)]"
                                  class="modern-parameter-field">
                                  <template v-slot:prepend-inner>
                                    <v-icon size="small" color="primary" class="mr-1">
                                      mdi-minus-circle-outline
                                    </v-icon>
                                  </template>
                                  <template v-slot:append-inner>
                                    <v-tooltip location="top">
                                      <template v-slot:activator="{ props }">
                                        <v-icon 
                                          size="x-small" 
                                          v-bind="props"
                                          color="grey-darken-1">
                                          mdi-information-outline
                                        </v-icon>
                                      </template>
                                      <span>Encourages new topics and ideas</span>
                                    </v-tooltip>
                                  </template>
                                </v-text-field>
                              </v-col>
                            </v-row>
                          </v-row>
                        </v-expansion-panel-text>
                      </v-expansion-panel>
                    </v-expansion-panels>
                    <div class="d-flex flex-shrink-1 pb-0 pt-4" style="flex-basis:50%; gap:12px;" id="LeftChat">
                      <div class="d-flex flex-column pa-4 rounded-lg overflow-y-auto" style="width: 100%;"
                        :style="panelLeft == 0 ? 'max-height: calc(-425px + 50vh); height: calc(-425px + 50vh); border: 3px solid' + selectedColor : 'max-height: 50vh; height:50vh; border: 3px solid' + selectedColor"
                        ref="LeftChat">
                        <div v-for="(item, index) in listMessageLeft" v-bind:key="index">
                          <div class="d-flex flex-column justify-end">
                            <div class="float-right">
                              <div style="float: right; height: 35px; width: 35px; border-radius: 50%;
                                          text-align: center;  background-color: white; 
                                          margin-top: 10px; margin-left: 15px;">
                                <v-icon style="font-size: 30px;" :style="'color:' + selectedColor + ';'">
                                  mdi-account</v-icon>
                              </div>
                              <div style="float: right; margin-top:8px">
                                <label style="font-size: 16px; ">You</label>
                              </div>
                            </div>
                            <div class="float-right">
                              <label class="rounded-lg rounded-tr-0" style="line-break: anywhere; 
                              padding: 16px 20px;
                              font-size: 16px; font-weight: 400; color: #71717A; float: right;
                              line-height: 22px; white-space: pre-line; width: fit-content; 
                              min-height: 54px; max-width: 80%;">{{ item.messageUser }}</label>
                            </div>
                          </div>

                          <div class="d-flex flex-column justify-start">
                            <div class="float-left">
                              <div style="float: left; height: 35px; width: 35px; border-radius: 50%;
                                          text-align: center;  background-color: white; 
                                          margin-top: 10px; margin-right: 15px;">
                                <v-icon v-if="!isImgIconChat" style="font-size: 30px;"
                                  :style="'color:' + selectedColor + ';'">{{ ChatbotIcon != null
                                    ?
                                    ChatbotIcon : 'mdi-robot-outline' }}</v-icon>
                                <v-img v-else style="height: 34px; width: 34px; border-radius: 50%;"
                                  :src="IconChat" />
                              </div>
                              <div style="float: left; margin-top:8px">
                                <label style="font-size: 16px;">{{ ChatbotName }}</label>
                              </div>
                            </div>
                            <div class="float-left">
                              <div v-if="item.status_Process == 'Process'" style=" background: rgb(249, 249, 249);  border-radius: 8px; 
                                    box-shadow: rgba(0, 0, 0, 0.14) 0px 2px 4px, rgba(0, 0, 0, 0.12) 0px 0px 2px;
                                        font-size: 16px;    font-weight: 400;    float: left;    width: 175px;">
                                <div style="padding-top: 10px;    padding-left: 10px;"> Finding answer ...</div>
                                <div style="padding: 10px;">
                                  <v-progress-linear indeterminate color="rgb(0, 120, 212)"
                                    class="mb-0"></v-progress-linear>
                                </div>
                              </div>

                              <div v-else-if="item.status_Process == 'Send_Message' || item.status_Process == 'END'"
                                style="line-break: anywhere;
                                padding: 16px 20px; border-radius: 8px;
                                font-weight: 400; color: #71717A; float: left;
                                line-height: 22px; white-space: pre-line; width: fit-content;
                                min-height: 54px; max-width: 80%;" @click="botMessageClick(item.messageBot)">
                                <!-- <MarkdownIt id="V_markDown" :anchor-attributes="anchorAttrs" :source="item.messageBot"
                                  style="color: #71717A;font-size: 16px; ">
                                </MarkdownIt> -->
                                <MarkdownRenderer :content="item.messageBot"/>
                              </div>
                              <div v-else style="line-break: anywhere;
                                padding: 16px 20px; background: rgb(249,249,249);
                                border-radius: 8px;font-weight: 400;
                                line-height: 22px; white-space:  pre-line; 
                                width: fit-content; float: left;">
                                <!-- <MarkdownIt id="V_markDown" :anchor-attributes="anchorAttrs" :source="item.messageBot"
                                  style="color: #71717A;font-size: 16px; ">
                                </MarkdownIt> -->
                                <MarkdownRenderer :content="item.messageBot"/>
                                <span> ...{{ item.status_Process }}</span>
                              </div>
                            </div>


                          </div>
                        </div>
                        <div ref="endLeft"></div>
                      </div>
                    </div>
                  </v-col>
                </v-row>

              </div>
              <!-- --------------------------------------------------------------------------------------------------------- -->
              <div class="d-flex flex-column flex-shrink-1 px-4" style="flex-basis:50%; gap:12px; max-width: 50%" ref="RightConfig">
                <v-row class="d-flex flex-row flex-shrink-1">
                  <v-col>
                    <v-expansion-panels accordion v-model="panelRight">
                      <v-expansion-panel>
                        <v-expansion-panel-title>
                          <template v-slot:actions>
                            <v-icon class="icon" icon="mdi-chevron-down"></v-icon>
                          </template>
                          <span class="header">Configuration B</span>
                        </v-expansion-panel-title>
                        <v-expansion-panel-text>
                          <v-row class="ma-0 pt-0">
                            <v-col class="mt-0 pt-0">
                              <label class="modern-label">User Id</label>
                            </v-col>
                          </v-row>
                          <v-row style="margin-top: 0px;" class="ma-0">
                            <v-col style="padding-top: 0px;">
                              <v-text-field 
                                class="modern-config-field" 
                                variant="outlined" 
                                density="compact" 
                                v-model="configRight.User_Id"
                                hide-details 
                                style="padding-top: 0px;">
                                <template v-slot:prepend-inner>
                                  <v-icon size="small" color="primary" class="mr-1">
                                    mdi-account-outline
                                  </v-icon>
                                </template>
                              </v-text-field>
                            </v-col>
                          </v-row>
                          
                          <v-row class="flex mx-0 pt-0" justify="center" style="align-content: start;">
                            <v-col class="ma-0 pa-0" cols="12">
                              <v-textarea 
                                id="PromptTemplate" 
                                label="Prompt template"
                                v-model="configRight.promptTemplate" 
                                :rules="[validatePrompt(configRight.promptTemplate)]"
                                variant="outlined" 
                                counter 
                                auto-grow
                                height="180px" 
                                rows="10" 
                                required
                                class="modern-textarea">
                                <template v-slot:prepend-inner>
                                  <v-icon size="small" color="primary" class="mr-1">
                                    mdi-text-box-outline
                                  </v-icon>
                                </template>
                              </v-textarea>
                            </v-col>
                            
                            <v-row style="align-content: start;">
                              <v-col class="pa-1" cols="3" sm="12" :md="SetPopup ? 12 : 6" :lg="SetPopup ? 6 : 3">
                                <v-text-field 
                                  label="Temperature*" 
                                  v-model="configRight.temperature" 
                                  density="compact" 
                                  variant="outlined"
                                  @keypress="isNumber($event)" 
                                  :rules="[validateInput0_1(configRight.temperature)]"
                                  required
                                  class="modern-parameter-field">
                                  <template v-slot:prepend-inner>
                                    <v-icon size="small" color="primary" class="mr-1">
                                      mdi-thermometer
                                    </v-icon>
                                  </template>
                                  <template v-slot:append-inner>
                                    <v-tooltip location="top">
                                      <template v-slot:activator="{ props }">
                                        <v-icon 
                                          size="x-small" 
                                          v-bind="props"
                                          color="grey-darken-1">
                                          mdi-information-outline
                                        </v-icon>
                                      </template>
                                      <span>Controls randomness: 0 = focused, 1 = creative</span>
                                    </v-tooltip>
                                  </template>
                                </v-text-field>
                              </v-col>
                              
                              <v-col class="pa-1" cols="3" sm="12" :md="SetPopup ? 12 : 6" :lg="SetPopup ? 6 : 3">
                                <v-text-field 
                                  label="Top p*" 
                                  v-model="configRight.topP" 
                                  density="compact" 
                                  variant="outlined" 
                                  required
                                  :disabled="configRight.provider == 'Anthropic'" 
                                  @keypress="isNumber($event)"
                                  :rules="[validateInput0_1(configRight.topP)]"
                                  class="modern-parameter-field">
                                  <template v-slot:prepend-inner>
                                    <v-icon size="small" color="primary" class="mr-1">
                                      mdi-percent
                                    </v-icon>
                                  </template>
                                  <template v-slot:append-inner>
                                    <v-tooltip location="top">
                                      <template v-slot:activator="{ props }">
                                        <v-icon 
                                          size="x-small" 
                                          v-bind="props"
                                          color="grey-darken-1">
                                          mdi-information-outline
                                        </v-icon>
                                      </template>
                                      <span>Nucleus sampling parameter</span>
                                    </v-tooltip>
                                  </template>
                                </v-text-field>
                              </v-col>
                              
                              <v-col class="pa-1" cols="3" sm="12" :md="SetPopup ? 12 : 6" :lg="SetPopup ? 6 : 3">
                                <v-text-field 
                                  label="Frequency penalty"
                                  :disabled="configRight.provider == 'Anthropic'" 
                                  v-model="configRight.frequencyPenalty"
                                  @keypress="isNumber($event)" 
                                  density="compact" 
                                  variant="outlined"
                                  :rules="[validateInput0_2(configRight.frequencyPenalty)]"
                                  class="modern-parameter-field">
                                  <template v-slot:prepend-inner>
                                    <v-icon size="small" color="primary" class="mr-1">
                                      mdi-repeat-off
                                    </v-icon>
                                  </template>
                                  <template v-slot:append-inner>
                                    <v-tooltip location="top">
                                      <template v-slot:activator="{ props }">
                                        <v-icon 
                                          size="x-small" 
                                          v-bind="props"
                                          color="grey-darken-1">
                                          mdi-information-outline
                                        </v-icon>
                                      </template>
                                      <span>Reduces repetition of frequent tokens</span>
                                    </v-tooltip>
                                  </template>
                                </v-text-field>
                              </v-col>
                              
                              <v-col class="pa-1" cols="3" sm="12" :md="SetPopup ? 12 : 6" :lg="SetPopup ? 6 : 3">
                                <v-text-field 
                                  label="Presence penalty" 
                                  :disabled="configRight.provider == 'Anthropic'"
                                  v-model="configRight.presencePenalty" 
                                  @keypress="isNumber($event)" 
                                  density="compact" 
                                  variant="outlined"
                                  :rules="[validateInput0_2(configRight.presencePenalty)]"
                                  class="modern-parameter-field">
                                  <template v-slot:prepend-inner>
                                    <v-icon size="small" color="primary" class="mr-1">
                                      mdi-minus-circle-outline
                                    </v-icon>
                                  </template>
                                  <template v-slot:append-inner>
                                    <v-tooltip location="top">
                                      <template v-slot:activator="{ props }">
                                        <v-icon 
                                          size="x-small" 
                                          v-bind="props"
                                          color="grey-darken-1">
                                          mdi-information-outline
                                        </v-icon>
                                      </template>
                                      <span>Encourages new topics and ideas</span>
                                    </v-tooltip>
                                  </template>
                                </v-text-field>
                              </v-col>
                            </v-row>
                          </v-row>
                        </v-expansion-panel-text>
                      </v-expansion-panel>
                    </v-expansion-panels>
                    <div class="d-flex flex-shrink-1 pb-0 pt-4" style="flex-basis:50%; gap:12px;" id="RightChat">
                      <div class="d-flex flex-column pa-4 rounded-lg overflow-y-auto" style="width: 100%;"
                        :style="panelRight == 0 ? 'max-height: calc(-425px + 50vh); height: calc(-425px + 50vh); border: 3px solid' + selectedColor : 'max-height: 50vh; height: 50vh; border: 3px solid' + selectedColor"
                        ref="RightChat">
                        <!-- :style="'border: 3px solid' + selectedColor +';'" ref="RightChat"> -->
                        <div v-for="(item, index) in listMessageRight" v-bind:key="index">
                          <div class="d-flex flex-column justify-end">
                            <div class="float-right">
                              <div style="float: right; height: 35px; width: 35px; border-radius: 50%;
                                          text-align: center;  background-color: white; 
                                          margin-top: 10px; margin-left: 15px;">
                                <v-icon style="font-size: 30px;" :style="'color:' + selectedColor + ';'">
                                  mdi-account</v-icon>
                              </div>
                              <div style="float: right; margin-top:8px">
                                <label style="font-size: 16px;">You</label>
                              </div>
                            </div>
                            <div class="float-right">
                              <label class="rounded-lg rounded-tr-0" style="line-break: anywhere; 
                              padding: 16px 20px;
                              font-size: 16px; font-weight: 400; color: #71717A; float: right;
                              line-height: 22px; white-space: pre-line; width: fit-content; 
                              min-height: 54px; max-width: 80%;">{{ item.messageUser }}</label>
                            </div>
                          </div>

                          <div class="d-flex flex-column justify-start">
                            <div class="float-left">
                              <div style="float: left; height: 35px; width: 35px; border-radius: 50%;
                                          text-align: center;  background-color: white; 
                                          margin-top: 10px; margin-right: 15px;">
                                <v-icon v-if="!isImgIconChat" style="font-size: 30px;"
                                  :style="'color:' + selectedColor + ';'">{{ ChatbotIcon != null
                                    ?
                                    ChatbotIcon : 'mdi-robot-outline' }}</v-icon>
                                <v-img v-else style="height: 34px; width: 34px; border-radius: 50%;"
                                  :src="IconChat" />
                              </div>
                              <div style="float: left; margin-top:8px">
                                <label style="font-size: 16px;">{{ ChatbotName }}</label>
                              </div>
                            </div>
                            <div class="float-left">
                              <div v-if="item.status_Process == 'Process'" style=" background: rgb(249, 249, 249);  border-radius: 8px; 
                                    box-shadow: rgba(0, 0, 0, 0.14) 0px 2px 4px, rgba(0, 0, 0, 0.12) 0px 0px 2px;
                                        font-size: 16px;    font-weight: 400;    float: left;    width: 175px;">
                                <div style="padding-top: 10px;    padding-left: 10px;"> Finding answer ...</div>
                                <div style="padding: 10px;">
                                  <v-progress-linear indeterminate color="rgb(0, 120, 212)"
                                    class="mb-0"></v-progress-linear>
                                </div>
                              </div>

                              <div v-else-if="item.status_Process == 'Send_Message' || item.status_Process == 'END'"
                                style="line-break: anywhere;
                                padding: 16px 20px; border-radius: 8px;
                                font-weight: 400; color: #71717A; float: left;
                                line-height: 22px; white-space: pre-line; width: fit-content;
                                min-height: 54px; max-width: 80%;" @click="botMessageClick(item.messageBot)">
                                <!-- <MarkdownIt id="V_markDown" :anchor-attributes="anchorAttrs" :source="item.messageBot"
                                  style="color: #71717A;font-size: 16px; ">
                                </MarkdownIt> -->
                                <MarkdownRenderer :content="item.messageBot"/>
                              </div>
                              <div v-else style="line-break: anywhere;
                                padding: 16px 20px; background: rgb(249,249,249);
                                border-radius: 8px; font-weight: 400;
                                line-height: 22px; white-space:  pre-line; 
                                width: fit-content; float: left;">
                                <!-- <MarkdownIt id="V_markDown" :anchor-attributes="anchorAttrs" :source="item.messageBot"
                                  style="color: #71717A;font-size: 16px; ">
                                </MarkdownIt> -->
                                <MarkdownRenderer :content="item.messageBot"/>
                                <span> ...{{ item.status_Process }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div ref="endRight"></div>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </div>

            <div class="d-flex flex-wrap flex-row px-4" style="height: auto;" ref="ChatRef">

            </div>


            <div class="d-flex flex-wrap flex-row px-4" ref="TextRef">
              <div class="d-flex flex-shrink-1 px-4" style="flex-basis:100%;">
                <v-textarea 
                  ref="RefMessageData" 
                  class="custom-chat-textarea" 
                  style="margin-top: 16px !important;"
                  v-model="messageData" 
                  :color="selectedColor" 
                  background-color="transparent"
                  placeholder="Type your message here... (Shift + Enter for new line)" 
                  variant="outlined"
                  rounded="lg"
                  rows="1"
                  v-on:keydown.enter.shift="Key_Ctrl_Flag = true" 
                  v-on:keyup.enter.shift="Shift_Enter_MessageData"
                  @keydown.enter.exact.prevent="SendMessage('Enter'); Key_Ctrl_Flag = false;" 
                  :maxlength="maxCharacter" 
                  counter 
                  auto-grow
                  hide-details>
                  
                  <template v-slot:prepend-inner>
                    <div class="d-flex align-center">
                      <v-icon 
                        :color="selectedColor" 
                        size="20"
                        class="mr-2">
                        mdi-message-text-outline
                      </v-icon>
                    </div>
                  </template>

                  <template v-slot:append-inner>
                    <div class="d-flex align-center gap-2">
                      <!-- Send Button -->
                      <v-btn
                        v-if="messageData.length > 0 && (
                          (listMessageLeft.length > 0 ?
                            listMessageLeft[listMessageLeft.length - 1].status_Process == 'Stop' ||
                            listMessageLeft[listMessageLeft.length - 1].status_Process == 'END' ||
                            listMessageLeft[listMessageLeft.length - 1].status_Process == 'Error' : true)
                          &&
                          (listMessageRight.length > 0 ?
                            listMessageRight[listMessageRight.length - 1].status_Process == 'Stop' ||
                            listMessageRight[listMessageRight.length - 1].status_Process == 'END' ||
                            listMessageRight[listMessageRight.length - 1].status_Process == 'Error' : true))
                        "
                        icon
                        variant="flat"
                        size="small"
                        :color="selectedColor"
                        class="send-button"
                        @click="SendMessage('click')">
                        <v-icon size="18" :color="selectedColor">mdi-send</v-icon>
                        <v-tooltip activator="parent" location="top">
                          Send message
                        </v-tooltip>
                      </v-btn>
                      
                      <!-- Stop Button -->
                      <v-btn 
                        v-else-if="(listMessageLeft.length > 0 ?
                          listMessageLeft[listMessageLeft.length - 1].status_Process == 'Process' ||
                          listMessageLeft[listMessageLeft.length - 1].status_Process == 'Send_Message' ||
                          listMessageLeft[listMessageLeft.length - 1].status_Process == 'VoiceStart' : false)
                          ||
                          (listMessageRight.length > 0 ?
                            listMessageRight[listMessageRight.length - 1].status_Process == 'Process' ||
                            listMessageRight[listMessageRight.length - 1].status_Process == 'Send_Message' ||
                            listMessageRight[listMessageRight.length - 1].status_Process == 'VoiceStart' : false)
                        " 
                        v-on:click="StopMessage" 
                        icon
                        variant="flat"
                        size="small"
                        class="stop-button">
                        <v-icon size="18" :color="selectedColor">mdi-stop-circle-outline</v-icon>
                        <v-tooltip activator="parent" location="top">
                          Stop generation
                        </v-tooltip>
                      </v-btn>
                    </div>
                  </template>
                  
                  <template v-slot:append>
                    <div class="d-flex align-center ml-2">
                      <!-- Clear Button -->
                      <v-btn 
                        icon
                        variant="text"
                        size="small"
                        v-on:click="Clear_listMessage" 
                        :disabled="(listMessageLeft.length == 0 || (listMessageLeft.length > 0 &&
                          (listMessageLeft[listMessageLeft.length - 1].status_Process == 'Process' ||
                            listMessageLeft[listMessageLeft.length - 1].status_Process == 'Send_Message' ||
                            listMessageLeft[listMessageLeft.length - 1].status_Process == 'VoiceStart'))) &&
                          (listMessageRight.length == 0 || (listMessageRight.length > 0 &&
                            (listMessageRight[listMessageRight.length - 1].status_Process == 'Process' ||
                              listMessageRight[listMessageRight.length - 1].status_Process == 'Send_Message' ||
                              listMessageRight[listMessageRight.length - 1].status_Process == 'VoiceStart')))"
                        class="clear-button">
                        <v-icon 
                          size="18"
                          :color="(listMessageLeft.length == 0 || (listMessageLeft.length > 0 &&
                            (listMessageLeft[listMessageLeft.length - 1].status_Process == 'Process' ||
                              listMessageLeft[listMessageLeft.length - 1].status_Process == 'Send_Message' ||
                              listMessageLeft[listMessageLeft.length - 1].status_Process == 'VoiceStart'))) &&
                            (listMessageRight.length == 0 || (listMessageRight.length > 0 &&
                              (listMessageRight[listMessageRight.length - 1].status_Process == 'Process' ||
                                listMessageRight[listMessageRight.length - 1].status_Process == 'Send_Message' ||
                                listMessageRight[listMessageRight.length - 1].status_Process == 'VoiceStart')))
                              ? 'grey-lighten-2' : 'grey-darken-1'">
                          mdi-broom
                        </v-icon>
                        <v-tooltip activator="parent" location="top">
                          Clear conversation
                        </v-tooltip>
                      </v-btn>
                    </div>
                  </template>
                </v-textarea>
              </div>
              <div style="width: 100%; display: flex; justify-content: end;">
                <span style="font-size: 12px;color: #71717A;margin-bottom: 1px;">{{ messageData.length }} / {{ maxCharacter }}</span>
              </div>
              <div style="width: 100%;">
                <span style="font-size: 12px;color: #71717A;margin-bottom: 1%;display: flex;justify-content: center;">AI
                  can
                  make mistakes. Please double-check responses.</span>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <div v-if="alertDialog"
      style="position: fixed; top: 16px; left: 50%; transform: translateX(-50%); z-index: 1000; animation: fadeDialogUp 2s ease-out;">
      <v-alert color="green" type="success" dismissible @click:close="alertDialog = false">
        The image is downloading...
      </v-alert>
    </div>

    <v-dialog v-model="CreateDialogV" width="80vw">
      <v-card>
        <v-flex justify-content-center>
          <ModelManagement style="width: 100%;" :editAction="configEdit.typeUpdate" :LLmsModel="configEdit"
            :modelID="$route.query.id" :GetDDModel="isParam" :page="'Playground Create'" @is-event="isemitEvent" />
        </v-flex>
      </v-card>
    </v-dialog>
    <v-dialog v-model="EditDialogV" width="80vw">
      <v-card>
        <v-flex justify-content-center>
          <ModelManagement style="width: 100%;" :editAction="configEdit.typeUpdate" :LLmsModel="configEdit"
            :modelID="$route.query.id" :GetDDModel="isParam" :page="'Playground Edit'" @is-event="isemitEvent" />
        </v-flex>
      </v-card>
    </v-dialog>
      <v-dialog v-model="showImage" max-width="1000">
        <v-card style="
        height: 85vh;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: transparent;
        box-shadow: none;
        overflow: hidden;
      ">
      <v-img :src="dialogImage" contain style="
          width: 100%;
          height: 100%;
          object-fit: contain;
        " />
        </v-card>
        <div style="position: fixed; bottom: 16px; left: 50%; transform: translateX(-50%);
            display: flex; justify-content: center; gap: 8px; z-index: 1000; opacity: 0; 
            animation: fadeUp 0.3s ease forwards 0.3s;">
          <input type="file" webkitdirectory directory id="folderPicker" style="display: none;">
          
          <div class="downloadImgBtn" style="background-color:#faa91b;" @click="downloadImage">
            <v-icon color="white">mdi-download</v-icon>
          </div>
          <div class="downloadImgBtn" style="background-color:#FF4444;" fab @click="showImage = false">
            <v-icon color="white">mdi-close</v-icon>
          </div>
        </div>
      </v-dialog>

    <v-dialog v-model="dialogSave" persistent width="480">
      <v-card>
        <v-card-title>
          <p class="headline" style="color: #1d4f81">
            {{ DialogSide == 'Left' ? (configLeft.typeUpdate != true ? 'Create' : 'Update')
              : (configRight.typeUpdate != true ? 'Create' : 'Update')
            }} your model</p>
        </v-card-title>
        <v-card-text>
          Please confirm to
          {{ DialogSide == 'Left' ? (configLeft.typeUpdate != true ? 'create' : 'update')
            : (configRight.typeUpdate != true ? 'create' : 'update')
          }} your model
        </v-card-text>
        <v-card-actions style="justify-content: end;">
          <v-btn color="blue darken-1" text @click="dialogSave = false">{{ $t('close') }}</v-btn>
          <v-btn color="blue darken-1" text @click="Save(DialogSide)">{{ $t('save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="dialog">
      <v-dialog v-model="dialog" persistent width="300">
        <v-card color="#1976D2" dark>
          <v-card-text class="white--text">
            Loading Please Wait...
            <v-progress-linear indeterminate color="#FAA91B" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>
  </div>
</template>
<script>
import dateUtils from '../plugins/date-utils';
import moment from 'moment';
import LogTrace from '@/api/function.js';
// import VueMarkdown from 'vue-markdown-v2';
import MarkdownRenderer from '@/components/MarkedMarkdown.vue'
// import MarkdownIt from '@/components/MarkedMarkdown.vue'
import ModelManagement from '@/components/ModelManagement.vue';
import Cookies from "js-cookie";
import { useDisplay } from 'vuetify'
import { useGoTo } from 'vuetify';
// 2. เรียกใช้ useGoTo เพื่อเอาฟังก์ชัน goTo มาใช้งาน

const API_BASE_URL = import.meta.env?.VITE_APP_API
export default {
  mixins: [LogTrace],
  inject: ['flagNav', 'Status_Error', 'Time_Delay', 'IconChat', 'ChatbotName', 'colorThemeChat'
  , 'SetPopup', 'NavbarBtnColorTheme', 'ModelFirst', 'TopicName', 'listTopic'
  , 'Click_History_List', 'DeleteTopicStream',  'RenameClick', 'Log_History_TopicID'
  , 'RenameTopicStream', 'keyupKeyRename', 'auth_token', 'KeyTopic'
  , 'TopicModelID', 'TopicModelID_long', 'StatusKeyRename', 'GetModelFirst_Value'
  , 'Log_History_ID', 'Log_History_Take', 'GetModelFirst', 'isImgIconChat', 'ChatbotIcon' ,'FontColorTitle','SubNavbarBackGround'],
  name: 'TestComponentPlayGround',
  components: {
    MarkdownRenderer,
    ModelManagement
  },
  setup() {
    // ใช้ useDisplay เพื่อเข้าถึง breakpoint
    const goTo = useGoTo()
    const display = useDisplay()
    return { display, goTo }
  },
  data() {
    return {
      leftCharacter: 0,
      rightCharacter: 0,
      maxCharacter: 200000,
      // Topic management for Left and Right chat
      topicIDLeft: null,
      topicIDRight: null,
      keyTopicLeft: null,
      keyTopicRight: null,
      alertDialog: false,
      showImage: false,
      dialogImage: '',
      roleId: Cookies.get('roleId'),
      code: '',
      lineNumbers: true,
      expiryDate: '',
      rememberMe: false,
      dialog: false,
      forgotpassword: false,
      erroralert: false,
      successalert: false,
      successMessage: '',
      errorMessage: '',
      show1: false,
      Email: '',
      today: null,
      tab: null,
      showToken: false,
      selectVersion: { title: 'Versioned API v0', value: 'v0' },
      versions: [
        { title: 'Versioned API v0', value: 'v0' },
        { title: 'Versioned API v1', value: 'v1' },
      ],
      nowDate: new Date().toISOString().slice(0, 10),
      date: new Date(),
      menuCustomeDate: false,
      ListDate: [
        { title: '30 Days', value: 30 },
        { title: '60 Days', value: 60 },
        { title: '90 Days', value: 90 },
        { title: '120 Days', value: 120 }
      ],
      DateSelected: 30,
      endDate: null,
      showPass: false,
      flagAdd: false,
      addItem: {
        tokenName: '',
        eMail: '',
        endDate: '',
        apI_Key: ''
      },
      options: {},
      searchTotalTable: 0,
      itemsPerPage: 10,
      totalTable: 0,
      isFirst: true,
      id: 0,
      rules: {
        required: (value) => !!value || 'Required.',
      },

      dialogSave: false,
      DialogSide: '',
      DDVector: [],
      DDGroupReplace: [],
      DDProvider: [
        'Azure',
        'Google'
      ],
      listDataIntegration: [],
      listSqlExtract: [],
      listDDIntentGroup: [],
      DDMinute: [
        {
          name: '2',
          value: -2,
        },
        {
          name: '10',
          value: -10,
        },
        {
          name: '30',
          value: -30,
        },
        {
          name: '60',
          value: -60,
        },
        {
          name: '720',
          value: -720,
        },
        {
          name: '1440',
          value: -1440,
        },
      ],
      DDModel: [
        {
          provider: 'Azure',
          model: 'gpt-35-turbo-chat',
          maxPrompt: 4000,
        },
        {
          provider: 'Azure',
          model: 'gpt-35-turbo-16k',
          maxPrompt: 8000,
        },
        {
          provider: 'Azure',
          model: 'gpt-4',
          maxPrompt: 6000,
        },
        {
          provider: 'Azure Postgresql',
          model: 'gpt-35-postgresql',
          maxPrompt: 4000,
        },
        {
          provider: 'Azure Postgresql',
          model: 'gpt-35-16k-postgresql',
          maxPrompt: 8000,
        },
        {
          provider: 'Azure Postgresql',
          model: 'gpt-4-postgresql',
          maxPrompt: 6000,
        },
        {
          provider: 'Azure Internet',
          model: 'gpt-35-Internet',
          maxPrompt: 4000,
        },
        {
          provider: 'Azure Internet',
          model: 'gpt-35-16k-Internet',
          maxPrompt: 8000,
        },
        {
          provider: 'Azure Internet',
          model: 'gpt-4-Internet',
          maxPrompt: 6000,
        },
        {
          provider: 'Azure News',
          model: 'gpt-35-turbo-chat',
          maxPrompt: 4000,
        },
        {
          provider: 'Azure News',
          model: 'gpt-35-turbo-16k',
          maxPrompt: 8000,
        },
        {
          provider: 'Azure News',
          model: 'gpt-4',
          maxPrompt: 6000,
        },
      ],
      DDModelShow: [],
      DDGender: [
        {
          id: 'm',
          name: 'Male',
        },
        {
          id: 'f',
          name: 'Female',
        },
      ],
      listDDModelDisplayName: [],
      listDDModel: [],
      listDDProvider: [],

      valid: null,
      CreateAndEditDialog: false,
      EditDialogV: false,
      CreateDialogV: false,
      selectedColor: '#FFA41E',
      panelLeft: null,
      panelRight: null,
      Topic_STATUS: false,
      LOG_STATUS_LEFT: false,
      LOG_STATUS_RIGHT: false,
      DataLogLeft: {
        Prompt: "",
        Vector: "",
        ReplySQL: "",
        ReplyDataSelect: "",
        Memory: "",
        Translate: "",
        FlowActionIntent: "",
        GPT_Model: {
          modelId: "",
          modelName: "",
          Provider: "",
          model: "",
          extension: "",
          description: "",
          promptTemplate: "",
          gender: "",
          vectordbName: "",
          topVDB: "",
          productTopVDB: "",
          productCosine: "",
          internet: "",
          feedback: "",
          historyCount: "",
          historyMinute: "",
          temperature: "",
          topP: "",
          frequency_penalty: "",
          presence_penalty: "",
          Stop: "",
          maxTokens: "",
          isStream: "",
          EndpointURL: "",
          loadingBarFlag: false,
          loadingBarDuration: 0,
          forbiddenWord: [""],
        },
        Text: "",
        TextVector: "",
        VectorCoise: "",
        Private_Memory: "",
      },
      DataLogRight: {
        Prompt: "",
        Vector: "",
        ReplySQL: "",
        ReplyDataSelect: "",
        Memory: "",
        Translate: "",
        FlowActionIntent: "",
        GPT_Model: {
          modelId: "",
          modelName: "",
          Provider: "",
          model: "",
          extension: "",
          description: "",
          promptTemplate: "",
          gender: "",
          vectordbName: "",
          topVDB: "",
          productTopVDB: "",
          productCosine: "",
          internet: "",
          feedback: "",
          historyCount: "",
          historyMinute: "",
          temperature: "",
          topP: "",
          frequency_penalty: "",
          presence_penalty: "",
          Stop: "",
          maxTokens: "",
          isStream: "",
          EndpointURL: "",
          loadingBarFlag: false,
          loadingBarDuration: 0,
          forbiddenWord: [""],
        },
        Text: "",
        TextVector: "",
        VectorCoise: "",
        Private_Memory: "",
      },
      anchorAttrs: {
        target: '_blank',
        rel: 'noopener noreferrer nofollow'
      },
      panel: false,
      configEdit: {
        // StatusforUpdate
        typeUpdate: false,
        side: '',
        User_Id: '',

        // Default
        typeLLM: 0,
        modelId: 0,
        modelDisplay: null,
        modelNameDisplay: null,
        modelName: "",
        provider: "",
        model: "",
        extension: null,
        description: null,
        gender: "m",
        versioning: 1,
        typingSpeed: 40,
        maximumChatInput: 200000,
        isStream: true,
        IsBypass: null,
        isFeedback: null,
        isPublish: true,
        isAllowImage: null,
        fileUploadLimit: null,

        // Vector
        vectordbName: [],
        groupReplaceID: [],
        productGroupID: [],
        topVDB: null,
        Cosine: null,
        productTopVDB: null,
        productCosine: null,
        LenChainMassage: null,
        TimeSecondChainMassage: null,
        IsChainMassage: null,

        // Memory History 
        historyCount: 2,
        historyMinute: 10,
        Len_ShortMemory: 200,
        IsLongTerm_Memory: false,

        // Advance
        temperature: 0,
        topP: 0,
        frequencyPenalty: null,
        presence_penalty: null,
        maxTokens: null,
        stop: null,

        // Data Integration
        DataIntegrationID: null,
        SqlModelID: null,
        promptSqlNoData: null,
        IntentGroupID: null,
        promptTemplate: "",

        //Line Config 
        loadingBarFlag: false,
        loadingBarDuration: 0,
        forbiddenWord: [""],
        isShowNameUserMonitor: false,
        monitorLineUserID: null,
        monitorSocialID: null,

        //GuardRail
        guardRailModelID: null,

        //enableTime
        enableTime: null,
        timeZone: null,
        reasoningEffort: null,
      },
      configLeft: {
        // StatusforUpdate
        typeUpdate: true,
        side: 'Left',
        User_Id: '',

        // Default
        typeLLM: 0,
        modelId: 0,
        modelDisplay: null,
        modelNameDisplay: null,
        modelName: "",
        provider: "",
        model: "",
        EndPointURL: null,
        API_Key: null,
        extension: null,
        description: null,
        gender: "m",
        versioning: 1,
        typingSpeed: 40,
        maximumChatInput: 200000,
        isStream: true,
        IsBypass: null,
        isFeedback: null,
        isPublish: true,
        isAllowImage: null,
        fileUploadLimit: null,

        // Vector
        vectordbName: [],
        groupReplaceID: [],
        productGroupID: [],
        topVDB: null,
        Cosine: null,
        productTopVDB: null,
        productCosine: null,
        LenChainMassage: null,
        TimeSecondChainMassage: null,
        IsChainMassage: null,

        // Memory History 
        historyCount: 2,
        historyMinute: 10,
        Len_ShortMemory: 200,
        IsLongTerm_Memory: false,

        // Advance
        temperature: 0,
        topP: 0,
        frequencyPenalty: null,
        presencePenalty: null,
        maxTokens: null,
        stop: null,

        // Data Integration
        DataIntegrationID: null,
        SqlModelID: null,
        promptSqlNoData: null,
        IntentGroupID: null,
        promptTemplate: "",

        //Line Config 
        loadingBarFlag: false,
        loadingBarDuration: 0,
        forbiddenWord: [""],
        isShowNameUserMonitor: false,
        monitorLineUserID: null,
        monitorSocialID: null,

        //GuardRail
        guardRailModelID: null,

        //enableTime
        enableTime: null,
        timeZone: null,
      },
      configRight: {
        // StatusforUpdate
        typeUpdate: true,
        side: 'Right',
        User_Id: '',

        // Default
        modelId: 0,
        modelDisplay: null,
        modelNameDisplay: null,
        modelName: "",
        provider: "",
        model: "",
        EndPointURL: null,
        API_Key: null,
        extension: null,
        description: null,
        gender: "",
        versioning: 1,
        typingSpeed: 40,
        maximumChatInput: 200000,
        isStream: true,
        IsBypass: null,
        isFeedback: null,
        isPublish: true,
        isAllowImage: null,
        fileUploadLimit: null,

        // Vector
        vectordbName: [],
        groupReplaceID: [],
        productGroupID: [],
        topVDB: null,
        Cosine: null,
        productTopVDB: null,
        productCosine: null,
        LenChainMassage: null,
        TimeSecondChainMassage: null,
        IsChainMassage: null,

        // Memory History 
        historyCount: 2,
        historyMinute: 10,
        Len_ShortMemory: 200,
        IsLongTerm_Memory: false,

        // Advance
        temperature: 0,
        topP: 0,
        frequencyPenalty: null,
        presencePenalty: null,
        maxTokens: null,
        stop: null,

        // Data Integration
        DataIntegrationID: null,
        SqlModelID: null,
        promptSqlNoData: null,
        IntentGroupID: null,
        promptTemplate: "",

        //Line Config 
        loadingBarFlag: false,
        loadingBarDuration: 0,
        forbiddenWord: [""],
        isShowNameUserMonitor: false,
        monitorLineUserID: null,
        monitorSocialID: null,

        //GuardRail
        guardRailModelID: null,

        //enableTime
        enableTime: null,
        timeZone: null,
      },
      listMessageLeft: [],
      listMessageRight: [],
      messageData: "",
      CountScroll: 0,
      MaxCountScroll: 15,
      messageResLeft: [],
      messageResRight: [],
      Count_messageResLeft: 0,
      Count_messageResRight: 0,
      StatusProLeft: false,
      StatusProRight: false,
      messageRunLeft: "",
      messageRunRight: "",
      messageImageLeft: "",
      messageImageRight: "",
      Stop_Flag_Left: false,
      Stop_Flag_Right: false,


      Flag_Start: false,
      parameterURL: [],
      Key_Ctrl_Flag: false,
      maxLengthChar: null,
      SessionID: null,
      isParam: "",
      isPage: "",
      maxHeight: 0,
      personalInfoToken: null,
    };
  },
  mounted: function () {
    this.SessionID = this.GetUuidv4_Fun();
    this.updateHeight();
    this.GetDate();
    this.GetUuidv4();

    this.GetModel();
    // this.GetlistDDGPTModelIsPublish();
    this.GetDDGroupReplaceDB();
    this.GetDDLDataIntegration();
    this.GetIntentGroup();
    this.GetModelData();
    this.GetProviderData();
    this.GetDDVectorName();
    this.Themecolor();
  },
  computed: {
    ColorThemeChat() {
      return this.colorThemeChat;
    },
    getEndDate() {
      let endDate = new Date(this.date.getFullYear() + 1, this.date.getMonth(), this.date.getDate() + 1);
      return endDate.toISOString().slice(0, 10)
    },
    mdAndUp() {
      return this.display.mdAndUp.value
    },
    smAndUp() {
      return this.display.smAndUp.value
    }
  },
  watch: {
    colorThemeChat: {
      handler(newVal) {
        this.selectedColor = `#${newVal}`;
      },
      immediate: true
    },
    ColorThemeChat(newVal) {
      this.selectedColor = `#${newVal}`;
      
    },
    options: {
      handler() {
        this.GetAPIData();
      },
      deep: true,
    },
    LOG_STATUS_LEFT() {
      this.updateHeight();
    },
    LOG_STATUS_RIGHT() {
      this.updateHeight();
    },
    "SetPopup": function () {
      this.updateHeight();
    }
    // searchModel(val) {
    //   this.GetModel(val);
    // },
  },
  methods: {
    botMessageClick(e) {
      const imageRegex = /!\[.*?\]\((.*?)\)/;
      const match = e.match(imageRegex);
      if (match) {
        this.dialogImage = match[1]; // extracted URL
        this.showImage = true;
      }
    },
    downloadImage() {
      let self = this;
      if (!this.dialogImage) return;
      self.alertDialog = true;
      this.closeDownloadDialog();
      self.$call.DownloadChatImage(
        this.dialogImage,
        null,
        async (dataResponse) => {
          const blob = new Blob([dataResponse], { type: "image/png" });
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = function () {
            const link = document.createElement("a");
            link.href = reader.result; // ใช้ Data URL
            link.download = "downloaded-image.png";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          };
          self.dialog_version = false;
          self.loading = false;
        },
        (errorResource) => {
          self.loading = false;
          self.isSearch = false;
          self.dialog_version = false;
          console.error(errorResource);
        }
      );
    },
    closeImage() {
      this.showImage = false;
      this.dialogImage = '';
    },
    closeDownloadDialog() {
      setTimeout(() => {
        this.alertDialog = false;
      }, 3000);
    },
    updateHeight() {
      this.$nextTick(() => {
        const chatSide = document.getElementById('chatSide');
        if (chatSide) {
          this.maxHeight = chatSide.clientHeight;
        }
      });
    },
    Themecolor() {
      this.selectedColor = this.colorThemeChat != null ? `#${this.colorThemeChat}` : '#FFA41E';
    },
    savechange(val, side) {
      var temp = this.listDDModelDisplayName.find((e) => (e.modelDisplayID === val))?.id;
      if (temp == null || temp == undefined || temp == "") {
        if(val != null && val != undefined && val != ""){
          this.GetByID(val, side);
        } else {
          this.ClearModel(side);
        }
      }else {
        this.GetByID(temp, side);
      }
    },
    OpenFullStream() {
      let self = this;
      if (self.auth_token == "" || self.auth_token == null) {
        try {
          self.auth_token = "";
          self.$call.GetTokenFullStream({}, (response) => {
            if (response.status == 0 && response.data.status) {
              self.auth_token = response.data.data;
              self.Time_Delay = response.data.timeDelay;
              let routeData = self.$router.resolve({ name: 'FullStream', query: { auth_token: self.auth_token, userId: null } });
              window.open(routeData.href, '_blank');
            }
            else {
              alert(response.data.data.textError)
            }
          },
            () => {
              alert("เฝิดข้อผิดพลาด")
            }
          );
        }
        catch {
          alert("เฝิดข้อผิดพลาด")
        }
      }
      else {
        let routeData = self.$router.resolve({ name: 'FullStream', query: { auth_token: self.auth_token, userId: null } });
        window.open(routeData.href, '_blank');
      }
    },


    validateEmail(email) {
      // eslint-disable-next-line no-useless-escape
      let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      return re.test(email) || 'invalid email';
    },

    convertDateToString2(date, seperator = '-') {
      return dateUtils.getStringFromDatePickFormatDatePick2(moment(date).toDate(), seperator);
    },
    Add() {
      this.flagAdd = true;
      this.radios = 'CustomeSelectDate'
      this.dialogRenew = true;

      this.tokenName = '';
      this.email = '';
      this.EndDate = this.nowDate;
      this.addItem.endDate = this.nowDate;
    },

    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }

      this.today = dd + '/' + mm + '/' + yyyy;
    },
    copyClipboard(index, side) {
      let text = document.createElement('textarea')
      text.value = side == "left" ? this.items[this.tab].scriptAndParam[index].script : this.items[this.tab].example[index].codeEx;
      text.focus();
      document.body.appendChild(text);
      text.select();
      // navigator.clipboard.writeText(text);
      document.execCommand('copy');
      text.parentNode.removeChild(text);
    },
    ClipboardAPIKey(index) {
      let text = this.items[this.tab].dataResponse[index].apI_Key;
      navigator.clipboard.writeText(text);
    },

    ChatRef_ScrollIntoView() {
      var self = this;
      // if (self.$refs.ChatRef && self.CountScroll >= self.MaxCountScroll &&
      //   Math.round(self.$refs.LeftChat.scrollTop + self.$refs.LeftChat.clientHeight) <= self.$refs.LeftChat.scrollHeight) {
      //   self.$refs.LeftChat.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' });
      //   // self.$refs.RightChat.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' });
      //   self.CountScroll = 0;
      // }
      // self.CountScroll++
      this.goTo(self.$refs.endLeft, { container: this.$refs.LeftChat, easing: 'linear', duration: 600 });
      this.goTo(self.$refs.endRight, { container: this.$refs.RightChat, easing: 'linear', duration: 600 });
    },
    GetUuidv4() {
      let self = this;
      // if (self.$root.User_Id == null || self.$root.User_Id == undefined || self.$root.User_Id == "") {
      let UuidL = self.GetUuidv4_Fun();
      let UuidR = self.GetUuidv4_Fun();
      // self.$root.User_Id = Uuid;
      // self.$root.User_Id = Uuid; 
      self.configLeft.User_Id = UuidL;
      self.configRight.User_Id = UuidR;
      // }
    },
    GetUuidv4_Fun() {
      let Uuid = "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
      return Uuid;
    },


    async SendMessage(K_in) {
      let self = this;
      let notUseCommand = [":model", ":set", ":userid", ":delete"]
      if (notUseCommand.filter((e) => (self.messageData.toLowerCase().includes(e.toLowerCase()))).length > 0) {
        self.messageData = "";
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('Command is not support for this page'),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
      // if (K_in == 'Enter') {
      //   if (self.Key_Ctrl_Flag == true) {
      //     if ((self.configLeft.model == '' || self.configLeft.model == null) && (self.configRight.model == '' || self.configRight.model == null)) {
      //       return;
      //     }
      //     return;
      //   }
      //   let _point = (self.$refs.RefMessageData.$refs.input.selectionStart - 1);
      //   if (self.messageData.length > 0 && self.messageData[_point] == "\n") {
      //     self.messageData = self.messageData.slice(0, _point) + self.messageData.slice(_point + 1);
      //   }
      // }
      if ((self.configLeft.model == '' || self.configLeft.model == null) && (self.configRight.model == '' || self.configRight.model == null)) {
        return;
      }

      //Left start
      if (self.listMessageLeft.length > 0 &&
        self.listMessageLeft[self.listMessageLeft.length - 1].status_Process == 'END'
        && self.listMessageLeft[self.listMessageLeft.length - 1].messageBot != null
        && self.listMessageLeft[self.listMessageLeft.length - 1].messageBot.length < self.messageResLeft.length) {
        self.Count_messageResLeft = 0;
        self.StatusProLeft = true;
        self.listMessageLeft[self.listMessageLeft.length - 1].messageBot = self.messageResLeft;
        self.messageResLeft[self.messageResLeft.length - 1] = "";
        setTimeout(() => {
          self.CountScroll = self.MaxCountScroll;
          self.ChatRef_ScrollIntoView();
        }, 5);
      }


      //Right start
      if (self.listMessageRight.length > 0 &&
        self.listMessageRight[self.listMessageRight.length - 1].status_Process == 'END'
        && self.listMessageRight[self.listMessageRight.length - 1].messageBot != null
        && self.listMessageRight[self.listMessageRight.length - 1].messageBot.length < self.messageResRight.length) {
        self.Count_messageResRight = 0;
        self.StatusProRight = true;
        self.listMessageRight[self.listMessageRight.length - 1].messageBot = self.messageResRight;
        self.messageResRight = "";
        setTimeout(() => {
          self.CountScroll = self.MaxCountScroll;
          self.ChatRef_ScrollIntoView();
        }, 5);

      }
        if (self.messageData == "") {
          return;
        }
      if ((self.messageData == "" || (self.listMessageLeft.length > 0 &&
        (self.listMessageLeft[self.listMessageLeft.length - 1].status_Process != 'END'
          && self.listMessageLeft[self.listMessageLeft.length - 1].status_Process != 'Error'
          && self.listMessageLeft[self.listMessageLeft.length - 1].status_Process != 'Stop'))) &&

        (self.messageData == "" || (self.listMessageRight.length > 0 &&
          (self.listMessageRight[self.listMessageRight.length - 1].status_Process != 'END'
            && self.listMessageRight[self.listMessageRight.length - 1].status_Process != 'Error'
            && self.listMessageRight[self.listMessageRight.length - 1].status_Process != 'Stop')))) {
        return;
      }


      let _messageData = self.messageData;
      self.messageData = "";
      if (self.configLeft.model != '' && self.configLeft.model != null) {
        self.listMessageLeft.push({
          messageUser: _messageData,
          messageBot: '',
          status_Process: 'Process'
        })
      }
      if (self.configRight.model != '' && self.configRight.model != null) {
        self.listMessageRight.push({
          messageUser: _messageData,
          messageBot: '',
          status_Process: 'Process'
        })
      }

      // Generate keyTopic if not exists (for first message in conversation)
      if (self.configLeft.model != '' && self.configLeft.model != null && !self.keyTopicLeft) {
        self.keyTopicLeft = self.GetUuidv4_Fun();
      }
      if (self.configRight.model != '' && self.configRight.model != null && !self.keyTopicRight) {
        self.keyTopicRight = self.GetUuidv4_Fun();
      }

      setTimeout(() => {
        self.CountScroll = self.MaxCountScroll;
        self.ChatRef_ScrollIntoView();
      }, 5);

      let dataPostLeft = {
        "events": [
          {
            "replyToken": "dummyToken",
            "type": "message",
            "timestamp": 1462629479859,
            "fullStream": false,
            "stream": true,
            "SessionID": self.SessionID,
            "source": {
              "type": "users",
              "userId": self.configLeft.User_Id,
              // "groupModel": self.parameterURL.groupmodel
            },

            "message": {
              "id": "325708",
              "type": "text",
              "topicID": self.topicIDLeft,
              "keyTopic": self.keyTopicLeft,
              "text": _messageData
            },
            "PersonalInfoToken": self.personalInfoToken,
            configPlayground: {
              // Default
              "typeLLM": self.configLeft.typeLLM == 1 ? 'GuardRail' : 'Bot',
              "ModelDisplay": self.configLeft.modelDisplay,
              "ModelNameDisplay": self.configLeft.modelNameDisplay,//self.configLeft.modelName,
              "ModelName": self.configLeft.modelName, //self.configLeft.modelNameDisplay,
              "Provider": self.configLeft.provider,
              "APIVersion": self.configLeft.APIVersion,
              "Model": self.configLeft.model.split('|').length > 1 ? self.configLeft.model.split('|')[0] : self.configLeft.model,
              "EndPointURL": self.configLeft.EndPointURL,
              "API_Key": self.configLeft.API_Key,

              "Extension": self.configLeft.extension,
              "Description": self.configLeft.description,
              "gender": self.configLeft.gender,
              "Versioning": self.configLeft.versioning,
              "TypingSpeed": self.configLeft.typingSpeed,
              "maximumChatInput": self.configLeft.maximumChatInput,
              "IsStream": self.configLeft.isStream,
              // "IsBypass" : self.configLeft.IsBypass,
              "IsFeedback": self.configLeft.isFeedback,
              "IsPublish": self.configLeft.isPublish,
              "isAllowImage": self.configLeft.isAllowImage,
              "fileUploadLimit": self.configLeft.fileUploadLimit,

              // Vector
              "vectordbName": self.configLeft.vectordbName == null || JSON.stringify(self.configLeft.vectordbName) == "[]" ? null : JSON.stringify(self.configLeft.vectordbName),
              "groupReplaceID": self.configLeft.groupReplaceID == null || JSON.stringify(self.configLeft.groupReplaceID) == "[]" ? null : JSON.stringify(self.configLeft.groupReplaceID),
              "productGroupID": self.configLeft.productGroupID == null || JSON.stringify(self.configLeft.productGroupID) == "[]" ? null : JSON.stringify(self.configLeft.productGroupID),
              "TopVDB": self.configLeft.topVDB,
              "Cosine": self.configLeft.Cosine,
              "productTopVDB": self.configLeft.productTopVDB,
              "productCosine": self.configLeft.productCosine,
              
              "LenChainMassage": self.configLeft.LenChainMassage,
              "TimeSecondChainMassage": self.configLeft.TimeSecondChainMassage,
              "IsChainMassage": self.configLeft.IsChainMassage,

              // Memory History 
              "HistoryCount": self.configLeft.historyCount,
              "HistoryMinute": self.configLeft.historyMinute > 0 ? -self.configLeft.historyMinute : self.configLeft.historyMinute,
              "Len_ShortMemory": self.configLeft.Len_ShortMemory,
              "IsLongTerm_Memory": self.configLeft.IsLongTerm_Memory,

              // Advance
              "temperature": self.configLeft.temperature,
              "top_p": self.configLeft.topP,
              "frequency_penalty": self.configLeft.frequencyPenalty,
              "presence_penalty": self.configLeft.presencePenalty,
              "max_tokens": self.configLeft.maxTokens,
              "Stop": self.configLeft.stop,

              // Data Integration
              "DataIntegrationID": self.configLeft.DataIntegrationID,
              "SqlModelID": self.configLeft.SqlModelID,
              "promptSqlNoData": self.configLeft.promptSqlNoData,
              "IntentGroupID": self.configLeft.IntentGroupID,
              "promptTemplate": self.configLeft.promptTemplate,
              "flowGroupID": self.configLeft.flowGroupID,

              //Line Config 
              "loadingBarFlag": self.configLeft.loadingBarFlag,
              "loadingBarDuration": self.configLeft.loadingBarDuration,
              //"forbiddenWord": self.ConfigLeft.forbiddenWord,

              //GuradRail
              "guardRailModelID": self.configLeft.guardRailModelID,

              //Image generation
              "modelType": self.configLeft.modelType,
              "styleImage": self.configLeft.styleImage,
              "resFormatImage": self.configLeft.resFormatImage,
              "quality": self.configLeft.quality,
              "resolution": self.configLeft.resolution,

              //enableTime
              "timeZone": self.configLeft.enableTime ? self.configLeft.timeZone : null,
            }
          }
        ]
      };

      let dataPostRight = {
        "events": [
          {
            "replyToken": "dummyToken",
            "type": "message",
            "timestamp": 1462629479859,
            "fullStream": false,
            "stream": true,
            "SessionID": self.SessionID,
            "source": {
              "type": "users",
              "userId": self.configRight.User_Id,
              // "groupModel": self.parameterURL.groupmodel
            },

            "message": {
              "id": "325708",
              "type": "text",
              "topicID": self.topicIDRight,
              "keyTopic": self.keyTopicRight,
              "text": _messageData
            },
            "PersonalInfoToken": self.personalInfoToken,
            configPlayground: {
              // Default
              "typeLLM": self.configRight.typeLLM == 1 ? 'GuardRail' : 'Bot',
              "ModelDisplay": self.configRight.modelDisplay,
              "ModelNameDisplay": self.configRight.modelNameDisplay,//self.configRight.modelName,
              "ModelName": self.configRight.modelName, //self.configRight.modelNameDisplay,
              "Provider": self.configRight.provider,
              "APIVersion": self.configRight.APIVersion,
              "Model": self.configRight.model.split('|').length > 1 ? self.configRight.model.split('|')[0] : self.configRight.model,
              "EndPointURL": self.configRight.EndPointURL,
              "API_Key": self.configRight.API_Key,

              "Extension": self.configRight.extension,
              "Description": self.configRight.description,
              "gender": self.configRight.gender,
              "Versioning": self.configRight.versioning,
              "TypingSpeed": self.configRight.typingSpeed,
              "maximumChatInput": self.configRight.maximumChatInput,
              "IsStream": self.configRight.isStream,
              // "IsBypass" : self.configRight.IsBypass,
              "IsFeedback": self.configRight.isFeedback,
              "IsPublish": self.configRight.isPublish,
              "isAllowImage": self.configRight.isAllowImage,
              "fileUploadLimit": self.configRight.fileUploadLimit,

              // Vector
              "vectordbName": self.configRight.vectordbName == null || JSON.stringify(self.configRight.vectordbName) == "[]" ? null : JSON.stringify(self.configRight.vectordbName),
              "groupReplaceID": self.configRight.groupReplaceID == null || JSON.stringify(self.configRight.groupReplaceID) == "[]" ? null : JSON.stringify(self.configRight.groupReplaceID),
              "productGroupID": self.configRight.productGroupID == null || JSON.stringify(self.configRight.productGroupID) == "[]" ? null : JSON.stringify(self.configRight.productGroupID),
              "TopVDB": self.configRight.topVDB,
              "Cosine": self.configRight.Cosine,
              "productTopVDB": self.configRight.productTopVDB,
              "productCosine": self.configRight.productCosine,
              "LenChainMassage": self.configRight.LenChainMassage,
              "TimeSecondChainMassage": self.configRight.TimeSecondChainMassage,
              "IsChainMassage": self.configRight.IsChainMassage,

              // Memory History 
              "HistoryCount": self.configRight.historyCount,
              "HistoryMinute": self.configRight.historyMinute > 0 ? -self.configRight.historyMinute : self.configRight.historyMinute,
              "Len_ShortMemory": self.configRight.Len_ShortMemory,
              "IsLongTerm_Memory": self.configRight.IsLongTerm_Memory,

              // Advance
              "temperature": self.configRight.temperature,
              "top_p": self.configRight.topP,
              "frequency_penalty": self.configRight.frequencyPenalty,
              "presence_penalty": self.configRight.presencePenalty,
              "max_tokens": self.configRight.maxTokens,
              "Stop": self.configRight.stop,

              // Data Integration
              "DataIntegrationID": self.configRight.DataIntegrationID,
              "SqlModelID": self.configRight.SqlModelID,
              "promptSqlNoData": self.configRight.promptSqlNoData,
              "IntentGroupID": self.configRight.IntentGroupID,
              "promptTemplate": self.configRight.promptTemplate,
              "flowGroupID": self.configRight.flowGroupID,

              //Line Config 
              "loadingBarFlag": self.configRight.loadingBarFlag,
              "loadingBarDuration": self.configRight.loadingBarDuration,
              //"forbiddenWord": self.ConfigRight.forbiddenWord,

              //GuradRail
              "guardRailModelID": self.configRight.guardRailModelID,

              //Image generation
              "modelType": self.configRight.modelType,
              "styleImage": self.configRight.styleImage,
              "resFormatImage": self.configRight.resFormatImage,
              "quality": self.configRight.quality,
              "resolution": self.configRight.resolution,

              //enableTime
              "timeZone": self.configRight.enableTime ? self.configRight.timeZone : null,
            }
          }
        ]
      };

      self.Stop_Flag_Left = false;
      self.StatusProLeft = true;
      self.Count_messageResLeft = 0;
      self.messageResLeft = "";

      self.Stop_Flag_Right = false;
      self.StatusProRight = true;
      self.Count_messageResRight = 0;
      self.messageResRight = "";

      self.Axios_Controller = new AbortController();

      let ConfigLeft = {
        signal: self.Axios_Controller.signal,
        onUploadProgress: () => {
          self.Text_RunLeft();
        },
        onDownloadProgress: progressEvent => {
          const xhr = (progressEvent.target == undefined ? progressEvent.event.target : progressEvent.target);
          try {
            const { responseText } = xhr
            if (self.listMessageLeft[self.listMessageLeft.length - 1].messageBot == "" || self.listMessageLeft[self.listMessageLeft.length - 1].messageBot == '<span class="blinking-cursor" style="">|</span>') {
              try {
                // self.GetLogStreamLeft(_messageData);
              } catch {
                self.DataLogLeft = {
                  Prompt: "",
                  Vector: "",
                  ReplySQL: "",
                  ReplyDataSelect: "",
                  Memory: "",
                  Translate: "",
                  FlowActionIntent: "",
                  GPT_Model: {
                    modelId: "",
                    modelName: "",
                    Provider: "",
                    model: "",
                    extension: "",
                    description: "",
                    promptTemplate: "",
                    gender: "",
                    vectordbName: "",
                    productGroupID: "",
                    topVDB: "",
                    productTopVDB: "",
                    productCosine: "",
                    Cosine:"",
                    internet: "",
                    feedback: "",
                    historyCount: "",
                    historyMinute: "",
                    temperature: "",
                    topP: "",
                    frequency_penalty: "",
                    presence_penalty: "",
                    stop: "",
                    maxTokens: "",
                    isStream: "",
                    EndpointURL: "",
                    loadingBarFlag: false,
                    loadingBarDuration: 0,
                    //forbiddenWord: [],
                  },
                  Text: "",
                  VectorCoise: "",
                  Private_Memory: ""
                };
              }
            }

            self.listMessageLeft[self.listMessageLeft.length - 1].status_Process = "Send_Message";

            let _responseText_Left = responseText.replaceAll("data: [DONE]", "");
            if(_responseText_Left.indexOf("|Products|[") != -1){
              var tempJson = _responseText_Left.split("|Products|");
              _responseText_Left = tempJson[0];
              self.products = JSON.parse(tempJson[1]);
            }

            /* eslint-disable */
            _responseText_Left = _responseText_Left.replace(/(?:\\\\n|\\\n|\\n|\r\n|\r|\n)/g, "\n");
            _responseText_Left = _responseText_Left.replace(/(?:      \n|     \n|    \n|   \n|  \n| \n)/g, "\n");
            _responseText_Left = _responseText_Left.replace(/(?:\n      ```|\n     ```|\n    ```|\n   ```|\n  ```|\n ```)/g, "\n```");
            _responseText_Left = _responseText_Left.replace(/(?:\n```\n```\n\n)/g, "\n<||End||>\n<||EndMarkdown||>\n\n");
            _responseText_Left = _responseText_Left.replace(/(?:\n```\n\n)/g, "\n<||End||>\n\n");
            _responseText_Left = _responseText_Left.replace(/(?:\n```\n```python|\n   ```\n   ```python)/g, "\n<||StarMarkdown||>\n<||StarPython||>");
            _responseText_Left = _responseText_Left.replace(/(?:\n```\n```javascript|\n   ```\n   ```javascript)/g, "\n<||StarMarkdown||>\n<||StarJavascript||>");
            _responseText_Left = _responseText_Left.replace(/(?:\n```\n)/g, "\n<||StarAll||>\n");
            _responseText_Left = _responseText_Left.replace(/(?:\n```python)/g, "\n<||StarPython||>");
            _responseText_Left = _responseText_Left.replace(/(?:\n```javascript)/g, "\n<||StarJavascript||>");
            _responseText_Left = _responseText_Left.replace(/(?:\n```markdown)/g, "\n<||StarMarkdown||>");

            let Sp_RT = _responseText_Left.split("<||");


            for (let I_Sp_RT = 0; I_Sp_RT < Sp_RT.length; I_Sp_RT++) {
              let Sp_Value = Sp_RT[I_Sp_RT].split("||>");
              if (I_Sp_RT >= 1 && Sp_Value.length > 1) {
                let Sp_Value_Old = Sp_RT[I_Sp_RT - 1].split("||>");
                if (Sp_Value[0].indexOf("End") != -1) {
                  for (let II_Sp_RT = I_Sp_RT - 1; II_Sp_RT > 0; II_Sp_RT--) {
                    try {
                      let Sp_Value_Old_Loop = Sp_RT[II_Sp_RT].split("||>");
                      if (Sp_Value_Old.length > 1 && Sp_Value_Old_Loop.length > 1) {
                        if (Sp_Value[0].indexOf("End") != -1 && Sp_Value_Old[0].indexOf("Star") != -1) {
                          let re_SVO = Sp_Value_Old[0].replace("Star", "End");
                          Sp_RT[I_Sp_RT] = Sp_RT[I_Sp_RT].replace("End||>", re_SVO + "||>");
                          break;
                        }
                        else if (Sp_Value[0].indexOf("End") != -1 && Sp_Value_Old[0].indexOf("End") != -1
                          && Sp_Value_Old_Loop[0].indexOf("Star") != -1 &&
                          Sp_Value_Old_Loop[0].indexOf(Sp_Value_Old[0].replace("End", "Star")) == -1
                        ) {

                          let re_SVO = Sp_Value_Old_Loop[0].replace("Star", "End");
                          Sp_RT[I_Sp_RT] = Sp_RT[I_Sp_RT].replace("End||>", re_SVO + "||>");
                          break;
                        }
                      }
                    } catch (e) {
                      // let ddd = 0;
                    }
                  }
                }
                else if (((I_Sp_RT + 1) < Sp_RT.length) && Sp_Value[0].indexOf("StarAll") != -1) {
                  let Sp_Value_New = Sp_RT[I_Sp_RT + 1].split("||>");
                  if (Sp_Value_Old[0].indexOf("Star") != -1
                    && Sp_Value_New.length > 1 && Sp_Value_New[0].indexOf("Star") != -1) {
                    let re_SVO = Sp_Value_Old[0].replace("Star", "End");
                    Sp_RT[I_Sp_RT] = Sp_RT[I_Sp_RT].replace("StarAll||>", re_SVO + "||>");
                  }
                }
              }
              if (I_Sp_RT == Sp_RT.length - 1) {
                for (let Iii_Sp_RT = 0; Iii_Sp_RT < Sp_RT.length; Iii_Sp_RT++) {
                  if (Sp_RT[Iii_Sp_RT].indexOf("||>") != -1) {
                    Sp_RT[Iii_Sp_RT] = "<||" + Sp_RT[Iii_Sp_RT];
                  }
                }
                _responseText_Left = Sp_RT.join("");
              }
              _responseText_Left = _responseText_Left.replaceAll("<||StarMarkdown||>", "\n`````\n");
              _responseText_Left = _responseText_Left.replaceAll("<||EndMarkdown||>", "`````\n");
              _responseText_Left = _responseText_Left.replaceAll("<||StarAll||>", "```");
              _responseText_Left = _responseText_Left.replaceAll("<||EndAll||>", "```");
              _responseText_Left = _responseText_Left.replaceAll("<||StarJavascript||>", "```javascript");
              _responseText_Left = _responseText_Left.replaceAll("<||EndJavascript||>", "```");
              _responseText_Left = _responseText_Left.replaceAll("<||StarPython||>", "```python");
              _responseText_Left = _responseText_Left.replaceAll("<||EndPython||>", "```");
              _responseText_Left = _responseText_Left.replaceAll("<||Star||>", "```");
              _responseText_Left = _responseText_Left.replaceAll("<||End||>", "```");
            }
            _responseText_Left = _responseText_Left.replace(/(?:\\n\\n|\n\n)/g, "\n");
            _responseText_Left = _responseText_Left.replace(/(?:\\\```|\\```|\```)/g, "<||TextMarkdown||>");
            _responseText_Left = _responseText_Left.replace(/(?:\\\`|\\`)/g, "\\`");
            _responseText_Left = _responseText_Left.replaceAll("<||TextMarkdown||>", "\```");
            _responseText_Left = _responseText_Left.replaceAll("(```", "(\\```");
            _responseText_Left = _responseText_Left.replaceAll("(``", "(\\``");
            _responseText_Left = _responseText_Left.replaceAll("(`", "(\\`");
            _responseText_Left = _responseText_Left.replaceAll("` ` `", "`` ` ``");

            if (_responseText_Left.indexOf("<!DOCTYPE html>") == 0 && _responseText_Left.indexOf("```html\n<!DOCTYPE html>") == -1
              && _responseText_Left.indexOf("```\n<!DOCTYPE html>") == -1 && _responseText_Left.indexOf("<style>" != -1)) {
              let Sp_responseTextStart_Left = _responseText_Left.split("<style>");
              let Sp_responseTextEnd_Left = Sp_responseTextStart_Left[1].split("</style>");
              if (Sp_responseTextEnd_Left.length > 0) {
                Sp_responseTextEnd_Left[0] = Sp_responseTextEnd_Left[0].replaceAll("}\n", "}\n  #V_markDown ");
              }
              _responseText_Left = Sp_responseTextStart_Left[0] + "<style> #V_markDown " + Sp_responseTextEnd_Left[0] +
                (Sp_responseTextEnd_Left.length > 1 ? " </style> " + Sp_responseTextEnd_Left[1] : "")
            }
            if (_responseText_Left.indexOf("|Text|*Streaming:true*|") != -1) {
              _responseText_Left = _responseText_Left.replaceAll("|Text|*Streaming:true*|", "");
              self.listMessageLeft[self.listMessageLeft.length - 1].messageBot = _responseText_Left;
              self.messageResLeft = _responseText_Left;
              self.messageResLeft = "";
              self.Count_messageResLeft = 0;
              self.StatusProLeft = false;
            }
            else if (_responseText_Left.indexOf("|Text|*Streaming:false*|") != -1) {
              _responseText_Left = _responseText_Left.replaceAll("|Text|*Streaming:false*|", "");
              self.listMessageLeft[self.listMessageLeft.length - 1].messageBot = _responseText_Left;
              self.messageResLeft = _responseText_Left;
              self.messageResLeft = "";
              self.Count_messageResLeft = 0;
              self.StatusProLeft = false;
            }
            else {
              self.messageResLeft = _responseText_Left;
              self.StatusProLeft = true;
            }

          } catch (e) {
            self.DataLogLeft = {
              Prompt: "",
              Vector: "",
              ReplySQL: "",
              ReplyDataSelect: "",
              Memory: "",
              Translate: "",
              FlowActionIntent: "",
              GPT_Model: {
                modelId: "",
                modelName: "",
                Provider: "",
                model: "",
                extension: "",
                description: "",
                promptTemplate: "",
                gender: "",
                vectordbName: "",
                productGroupID: "",
                topVDB: "",
                Cosine: "",
                productTopVDB: "",
                productCosine: "",
                internet: "",
                feedback: "",
                historyCount: "",
                historyMinute: "",
                temperature: "",
                topP: "",
                frequency_penalty: "",
                presence_penalty: "",
                stop: "",
                maxTokens: "",
                isStream: "",
                EndpointURL: "",
                loadingBarFlag: false,
                loadingBarDuration: 0,
                //forbiddenWord: [],
              },
              Text: "",
              VectorCoise: "",
              Private_Memory: ""
            };
            console.log(e)
          }
        },
        maxRedirects: 0 // avoid buffering the entire stream
      }

      let ConfigRight = {
        signal: self.Axios_Controller.signal,
        onUploadProgress: () => {
          self.Text_RunRight();
        },
        onDownloadProgress: progressEvent => {
          const xhr = (progressEvent.target == undefined ? progressEvent.event.target : progressEvent.target);
          try {
            const { responseText } = xhr

            if (self.listMessageRight[self.listMessageRight.length - 1].messageBot == "" || self.listMessageRight[self.listMessageRight.length - 1].messageBot == '<span class="blinking-cursor" style="">|</span>') {
              try {
                // self.GetLogStreamRight(_messageData);
              } catch {
                self.DataLogRight = {
                  Prompt: "",
                  Vector: "",
                  ReplySQL: "",
                  ReplyDataSelect: "",
                  Memory: "",
                  Translate: "",
                  FlowActionIntent: "",
                  GPT_Model: {
                    modelId: "",
                    modelName: "",
                    Provider: "",
                    model: "",
                    extension: "",
                    description: "",
                    promptTemplate: "",
                    gender: "",
                    vectordbName: "",
                    productGroupID: "",
                    topVDB: "",
                    Cosine: "",
                    productTopVDB: "",
                    productCosine: "",
                    internet: "",
                    feedback: "",
                    historyCount: "",
                    historyMinute: "",
                    temperature: "",
                    topP: "",
                    frequency_penalty: "",
                    presence_penalty: "",
                    stop: "",
                    maxTokens: "",
                    isStream: "",
                    EndpointURL: ""
                  },
                  Text: "",
                  VectorCoise: "",
                  Private_Memory: ""
                };
              }
            }


            self.listMessageRight[self.listMessageRight.length - 1].status_Process = "Send_Message";
            let _responseText_Right = responseText.replaceAll("data: [DONE]", "");
            if(_responseText_Right.indexOf("|Products|[") != -1){
              var tempJson = _responseText_Right.split("|Products|");
              _responseText_Right = tempJson[0];
              self.products = JSON.parse(tempJson[1]);
            }

            /* eslint-disable */
            _responseText_Right = _responseText_Right.replace(/(?:\\\\n|\\\n|\\n|\r\n|\r|\n)/g, "\n");
            _responseText_Right = _responseText_Right.replace(/(?:      \n|     \n|    \n|   \n|  \n| \n)/g, "\n");
            _responseText_Right = _responseText_Right.replace(/(?:\n      ```|\n     ```|\n    ```|\n   ```|\n  ```|\n ```)/g, "\n```");
            _responseText_Right = _responseText_Right.replace(/(?:\n```\n```\n\n)/g, "\n<||End||>\n<||EndMarkdown||>\n\n");
            _responseText_Right = _responseText_Right.replace(/(?:\n```\n\n)/g, "\n<||End||>\n\n");
            _responseText_Right = _responseText_Right.replace(/(?:\n```\n```python|\n   ```\n   ```python)/g, "\n<||StarMarkdown||>\n<||StarPython||>");
            _responseText_Right = _responseText_Right.replace(/(?:\n```\n```javascript|\n   ```\n   ```javascript)/g, "\n<||StarMarkdown||>\n<||StarJavascript||>");
            _responseText_Right = _responseText_Right.replace(/(?:\n```\n)/g, "\n<||StarAll||>\n");
            _responseText_Right = _responseText_Right.replace(/(?:\n```python)/g, "\n<||StarPython||>");
            _responseText_Right = _responseText_Right.replace(/(?:\n```javascript)/g, "\n<||StarJavascript||>");
            _responseText_Right = _responseText_Right.replace(/(?:\n```markdown)/g, "\n<||StarMarkdown||>");

            let Sp_RTR = _responseText_Right.split("<||");


            for (let I_Sp_RTR = 0; I_Sp_RTR < Sp_RTR.length; I_Sp_RTR++) {
              let Sp_ValueR = Sp_RTR[I_Sp_RTR].split("||>");
              if (I_Sp_RTR >= 1 && Sp_ValueR.length > 1) {
                let Sp_Value_OldR = Sp_RTR[I_Sp_RTR - 1].split("||>");
                if (Sp_ValueR[0].indexOf("End") != -1) {
                  for (let II_Sp_RTR = I_Sp_RTR - 1; II_Sp_RTR > 0; II_Sp_RTR--) {
                    try {
                      let Sp_Value_Old_LoopR = Sp_RTR[II_Sp_RTR].split("||>");
                      if (Sp_Value_OldR.length > 1 && Sp_Value_Old_LoopR.length > 1) {
                        if (Sp_ValueR[0].indexOf("End") != -1 && Sp_Value_OldR[0].indexOf("Star") != -1) {
                          let re_SVO_R = Sp_Value_OldR[0].replace("Star", "End");
                          Sp_RTR[I_Sp_RTR] = Sp_RTR[I_Sp_RTR].replace("End||>", re_SVO_R + "||>");
                          break;
                        }
                        else if (Sp_ValueR[0].indexOf("End") != -1 && Sp_Value_OldR[0].indexOf("End") != -1
                          && Sp_Value_Old_LoopR[0].indexOf("Star") != -1 &&
                          Sp_Value_Old_LoopR[0].indexOf(Sp_Value_OldR[0].replace("End", "Star")) == -1
                        ) {

                          let re_SVO_R = Sp_Value_Old_LoopR[0].replace("Star", "End");
                          Sp_RTR[I_Sp_RTR] = Sp_RTR[I_Sp_RTR].replace("End||>", re_SVO_R + "||>");
                          break;
                        }
                      }
                    } catch (e) {
                      // let ddd = 0;
                    }
                  }
                }
                else if (((I_Sp_RTR + 1) < Sp_RTR.length) && Sp_ValueR[0].indexOf("StarAll") != -1) {
                  let Sp_Value_New_R = Sp_RTR[I_Sp_RTR + 1].split("||>");
                  if (Sp_Value_OldR[0].indexOf("Star") != -1
                    && Sp_Value_New_R.length > 1 && Sp_Value_New_R[0].indexOf("Star") != -1) {
                    let re_SVO_R = Sp_Value_OldR[0].replace("Star", "End");
                    Sp_RTR[I_Sp_RTR] = Sp_RTR[I_Sp_RTR].replace("StarAll||>", re_SVO_R + "||>");
                  }
                }
              }
              if (I_Sp_RTR == Sp_RTR.length - 1) {
                for (let Iii_Sp_RT_R = 0; Iii_Sp_RT_R < Sp_RTR.length; Iii_Sp_RT_R++) {
                  if (Sp_RTR[Iii_Sp_RT_R].indexOf("||>") != -1) {
                    Sp_RTR[Iii_Sp_RT_R] = "<||" + Sp_RTR[Iii_Sp_RT_R];
                  }
                }
                _responseText_Right = Sp_RTR.join("");
              }
              _responseText_Right = _responseText_Right.replaceAll("<||StarMarkdown||>", "\n`````\n");
              _responseText_Right = _responseText_Right.replaceAll("<||EndMarkdown||>", "`````\n");
              _responseText_Right = _responseText_Right.replaceAll("<||StarAll||>", "```");
              _responseText_Right = _responseText_Right.replaceAll("<||EndAll||>", "```");
              _responseText_Right = _responseText_Right.replaceAll("<||StarJavascript||>", "```javascript");
              _responseText_Right = _responseText_Right.replaceAll("<||EndJavascript||>", "```");
              _responseText_Right = _responseText_Right.replaceAll("<||StarPython||>", "```python");
              _responseText_Right = _responseText_Right.replaceAll("<||EndPython||>", "```");
              _responseText_Right = _responseText_Right.replaceAll("<||Star||>", "```");
              _responseText_Right = _responseText_Right.replaceAll("<||End||>", "```");
            }
            _responseText_Right = _responseText_Right.replace(/(?:\\n\\n|\n\n)/g, "\n");
            _responseText_Right = _responseText_Right.replace(/(?:\\\```|\\```|\```)/g, "<||TextMarkdown||>");
            _responseText_Right = _responseText_Right.replace(/(?:\\\`|\\`)/g, "\\`");
            _responseText_Right = _responseText_Right.replaceAll("<||TextMarkdown||>", "\```");
            _responseText_Right = _responseText_Right.replaceAll("(```", "(\\```");
            _responseText_Right = _responseText_Right.replaceAll("(``", "(\\``");
            _responseText_Right = _responseText_Right.replaceAll("(`", "(\\`");
            _responseText_Right = _responseText_Right.replaceAll("` ` `", "`` ` ``");

            if (_responseText_Right.indexOf("<!DOCTYPE html>") == 0 && _responseText_Right.indexOf("```html\n<!DOCTYPE html>") == -1
              && _responseText_Right.indexOf("```\n<!DOCTYPE html>") == -1 && _responseText_Right.indexOf("<style>" != -1)) {
              let Sp_responseTextStart_Right = _responseText_Right.split("<style>");
              let Sp_responseTextEnd_Right = Sp_responseTextStart_Right[1].split("</style>");
              if (Sp_responseTextEnd_Right.length > 0) {
                Sp_responseTextEnd_Right[0] = Sp_responseTextEnd_Right[0].replaceAll("}\n", "}\n  #V_markDown ");
              }
              _responseText_Right = Sp_responseTextStart_Right[0] + "<style> #V_markDown " + Sp_responseTextEnd_Right[0] +
                (Sp_responseTextEnd_Right.length > 1 ? " </style> " + Sp_responseTextEnd_Right[1] : "")
            }
            if (_responseText_Right.indexOf("|Text|*Streaming:true*|") != -1) {
              _responseText_Right = _responseText_Right.replaceAll("|Text|*Streaming:true*|", "");
              self.listMessageRight[self.listMessageRight.length - 1].messageBot = _responseText_Right;
              self.messageResRight = _responseText_Right;
              self.messageResRight = "";
              self.Count_messageResRight = 0;
              self.StatusProRight = false;
            }
            else if (_responseText_Right.indexOf("|Text|*Streaming:false*|") != -1) {
              _responseText_Right = _responseText_Right.replaceAll("|Text|*Streaming:false*|", "");
              self.listMessageRight[self.listMessageRight.length - 1].messageBot = _responseText_Right;
              self.messageResRight = _responseText_Right;
              self.messageResRight = "";
              self.Count_messageResRight = 0;
              self.StatusProRight = false;
            }
            else {
              self.messageResRight = _responseText_Right;
              self.StatusProRight = true;
            }

          } catch (e) {
            self.DataLogRight = {
              Prompt: "",
              Vector: "",
              ReplySQL: "",
              ReplyDataSelect: "",
              Memory: "",
              Translate: "",
              FlowActionIntent: "",
              GPT_Model: {
                modelId: "",
                modelName: "",
                Provider: "",
                model: "",
                extension: "",
                description: "",
                promptTemplate: "",
                gender: "",
                vectordbName: "",
                productGroupID: "",
                topVDB: "",
                Cosine: "",
                productTopVDB: "",
                productCosine: "",
                internet: "",
                feedback: "",
                historyCount: "",
                historyMinute: "",
                temperature: "",
                topP: "",
                frequency_penalty: "",
                presence_penalty: "",
                stop: "",
                maxTokens: "",
                isStream: "",
                EndpointURL: ""
              },
              Text: "",
              VectorCoise: "",
              Private_Memory: ""
            };
            console.log(e)
          }
        },
        maxRedirects: 0 // avoid buffering the entire stream
      }
      var chatLeftPersonalInfo = false;
      var chatRightPersonalInfo = false;

      let promise1;
      let promise2;
      if ((self.configLeft.model != '' && self.configLeft.model != null)) {
        // API LeftChat
        promise1 = new Promise((resolve, reject) => {
          self.$call.ChatPlayGroundStreamPOST(dataPostLeft, ConfigLeft, () => {
            if(self.listMessageLeft[self.listMessageLeft.length - 1].messageBot == "**#Personal Information**") //that.personalInfoToken
            {
              chatLeftPersonalInfo = true;
              self.listMessageLeft[self.listMessageLeft.length - 1].status_Process = "Process";
              resolve(chatLeftPersonalInfo);
            }
            else
            {
              if(_messageData.trim() == ":clearhistory")
              {
                self.ClearChatModel('Left');
                return;
              }
              
              self.StatusProLeft = false;
              self.successalert = true;

              self.listMessageLeft[self.listMessageLeft.length - 1].status_Process = "END";
              self.GetLogStreamLeft(_messageData);
              setTimeout(() => {
                self.CountScroll = self.MaxCountScroll;
                self.ChatRef_ScrollIntoView();
              }, 5);
              resolve(chatLeftPersonalInfo);
            }
          }, (_response) => {
            self.erroralert = true;
            if (self.listMessageLeft.length == 0) {
            }
            else if (self.Stop_Flag_Left == true && self.listMessageLeft.length > 0) {
              self.listMessageLeft[self.listMessageLeft.length - 1].status_Process = "Stop";
            }
            else {
              self.StatusProLeft = false;
              self.Count_messageResLeft = 0;
              self.messageData = "";
              if (self.listMessageLeft.length > 0 && self.listMessageLeft[self.listMessageLeft.length - 1].messageBot.length < self.messageResLeft.length) {
                self.listMessageLeft[self.listMessageLeft.length - 1].messageBot = (self.messageResLeft + "<br />Error something went wrong ...");
              }
              else {
                self.listMessageLeft[self.listMessageLeft.length - 1].messageBot += "Error something went wrong ...";
              }
              self.messageResLeft = "";
              self.listMessageLeft[self.listMessageLeft.length - 1].status_Process = "Error";
            }
            self.Stop_Flag_Left = false;
            console.log("Error : " + _response);
            setTimeout(() => {
              self.CountScroll = self.MaxCountScroll;
              self.ChatRef_ScrollIntoView();
            }, 5);
            reject(chatLeftPersonalInfo);
          });
        });
      }

      // setTimeout(() => {
      if ((self.configRight.model != '' && self.configRight.model != null)) {
        // API RightChat
        promise2 = new Promise((resolve, reject) => {
          self.$call.ChatPlayGroundStreamPOST(dataPostRight, ConfigRight, () => {
            if(self.listMessageRight[self.listMessageRight.length - 1].messageBot == "**#Personal Information**") //that.personalInfoToken
            {
              chatRightPersonalInfo = true;
              self.listMessageRight[self.listMessageRight.length - 1].status_Process = "Process";
              resolve(chatRightPersonalInfo);
            }
            else
            {
              if(_messageData.trim() == ":clearhistory")
              {
                self.ClearChatModel('Right');
                return;
              }
              self.StatusProRight = false;
              self.successalert = true;

              self.listMessageRight[self.listMessageRight.length - 1].status_Process = "END";
              self.GetLogStreamRight(_messageData);
              setTimeout(() => {
                self.CountScroll = self.MaxCountScroll;
                self.ChatRef_ScrollIntoView();
              }, 5);
              resolve(chatRightPersonalInfo);
            }
          }, (_response) => {
            self.erroralert = true;
            if (self.listMessageRight.length == 0) {
            }
            else if (self.Stop_Flag_Right == true && self.listMessageRight.length > 0) {
              self.listMessageRight[self.listMessageRight.length - 1].status_Process = "Stop";
            }
            else {
              self.StatusProRight = false;
              self.Count_messageResRight = 0;
              self.messageData = "";
              if (self.listMessageRight.length > 0 && self.listMessageRight[self.listMessageRight.length - 1].messageBot.length < self.messageResRight.length) {
                self.listMessageRight[self.listMessageRight.length - 1].messageBot = (self.messageResRight + "<br />Error something went wrong ...");
              }
              else {
                self.listMessageRight[self.listMessageRight.length - 1].messageBot += "Error something went wrong ...";
              }
              self.messageResRight = "";
              self.listMessageRight[self.listMessageRight.length - 1].status_Process = "Error";
            }
            self.Stop_Flag_Right = false;
            console.log("Error : " + _response);
            setTimeout(() => {
              self.CountScroll = self.MaxCountScroll;
              self.ChatRef_ScrollIntoView();
            }, 5);
            reject(chatRightPersonalInfo);
          });
        });
      }

      // รอให้ทั้งสอง Promise เสร็จ
      if ((self.configLeft.model != '' && self.configLeft.model != null) && (self.configRight.model != '' && self.configRight.model != null)) {
        await Promise.all([promise1, promise2]);
      }
      else if ((self.configLeft.model != '' && self.configLeft.model != null)) {
        await Promise.all([promise1]);
      }
      else if ((self.configRight.model != '' && self.configRight.model != null)) {
        await Promise.all([promise2]);
      }

      //#region Personal Information
      let retry1 = new Promise(() => { });
      let retry2 = new Promise(() => { });

      if(chatLeftPersonalInfo || chatRightPersonalInfo)
      {
        window.open(`${API_BASE_URL}api/v0/SSO/SignInPersonalInfo`, "Popup", "width=850,height=750");

        const handleMessage = async function (event) {
          try {
            // ตรวจสอบข้อมูลจาก popup
            if (!event.data || !event.data.message) return;

            const data = event.data;
            self.personalInfoToken = data.message;
            // console.log("👤 Personal Information Token : ", self.personalInfoToken);

            // ส่งข้อมูลกลับไปยัง API
            // API LeftChat
            if (chatLeftPersonalInfo) {
              promise1
              .then((result) => {
                // console.log("👤 Personal Information : ", result);
              })
              .catch((error) => {
                // console.log("🐞 Personal Information : ", error);
              });

              let dataPostLeft = {
                "events": [
                  {
                    "replyToken": "dummyToken",
                    "type": "message",
                    "timestamp": 1462629479859,
                    "fullStream": false,
                    "stream": true,
                    "SessionID": self.SessionID,
                    "source": {
                      "type": "users",
                      "userId": self.configLeft.User_Id,
                      // "groupModel": self.parameterURL.groupmodel
                    },

                    "message": {
                      "id": "325708",
                      "type": "text",
                      "topicID": self.topicIDLeft,
                      "keyTopic": self.keyTopicLeft,
                      "text": _messageData
                    },
                    "PersonalInfoToken": self.personalInfoToken,
                    configPlayground: {
                      // Default
                      "typeLLM": self.configLeft.typeLLM == 1 ? 'GuardRail' : 'Bot',
                      "ModelDisplay": self.configLeft.modelDisplay,
                      "ModelNameDisplay": self.configLeft.modelNameDisplay,//self.configLeft.modelName,
                      "ModelName": self.configLeft.modelName, //self.configLeft.modelNameDisplay,
                      "Provider": self.configLeft.provider,
                      "APIVersion": self.configLeft.APIVersion,
                      "Model": self.configLeft.model.split('|').length > 1 ? self.configLeft.model.split('|')[0] : self.configLeft.model,
                      "EndPointURL": self.configLeft.EndPointURL,
                      "API_Key": self.configLeft.API_Key,

                      "Extension": self.configLeft.extension,
                      "Description": self.configLeft.description,
                      "gender": self.configLeft.gender,
                      "Versioning": self.configLeft.versioning,
                      "TypingSpeed": self.configLeft.typingSpeed,
                      "maximumChatInput": self.configLeft.maximumChatInput,
                      "IsStream": self.configLeft.isStream,
                      // "IsBypass" : self.configLeft.IsBypass,
                      "IsFeedback": self.configLeft.isFeedback,
                      "IsPublish": self.configLeft.isPublish,
                      "isAllowImage": self.configLeft.isAllowImage,
                      "fileUploadLimit": self.configLeft.fileUploadLimit,

                      // Vector
                      "vectordbName": self.configLeft.vectordbName == null || JSON.stringify(self.configLeft.vectordbName) == "[]" ? null : JSON.stringify(self.configLeft.vectordbName),
                      "groupReplaceID": self.configLeft.groupReplaceID == null || JSON.stringify(self.configLeft.groupReplaceID) == "[]" ? null : JSON.stringify(self.configLeft.groupReplaceID),
                      "productGroupID": self.configLeft.productGroupID == null || JSON.stringify(self.configLeft.productGroupID) == "[]" ? null : JSON.stringify(self.configLeft.productGroupID),
                      "TopVDB": self.configLeft.topVDB,
                      "Cosine": self.configLeft.Cosine,
                      "productTopVDB": self.configLeft.productTopVDB,
                      "productCosine": self.configLeft.productCosine,
                      
                      "LenChainMassage": self.configLeft.LenChainMassage,
                      "TimeSecondChainMassage": self.configLeft.TimeSecondChainMassage,
                      "IsChainMassage": self.configLeft.IsChainMassage,

                      // Memory History 
                      "HistoryCount": self.configLeft.historyCount,
                      "HistoryMinute": self.configLeft.historyMinute > 0 ? -self.configLeft.historyMinute : self.configLeft.historyMinute,
                      "Len_ShortMemory": self.configLeft.Len_ShortMemory,
                      "IsLongTerm_Memory": self.configLeft.IsLongTerm_Memory,

                      // Advance
                      "temperature": self.configLeft.temperature,
                      "top_p": self.configLeft.topP,
                      "frequency_penalty": self.configLeft.frequencyPenalty,
                      "presence_penalty": self.configLeft.presencePenalty,
                      "max_tokens": self.configLeft.maxTokens,
                      "Stop": self.configLeft.stop,

                      // Data Integration
                      "DataIntegrationID": self.configLeft.DataIntegrationID,
                      "SqlModelID": self.configLeft.SqlModelID,
                      "promptSqlNoData": self.configLeft.promptSqlNoData,
                      "IntentGroupID": self.configLeft.IntentGroupID,
                      "promptTemplate": self.configLeft.promptTemplate,

                      //Line Config 
                      "loadingBarFlag": self.configLeft.loadingBarFlag,
                      "loadingBarDuration": self.configLeft.loadingBarDuration,
                      //"forbiddenWord": self.ConfigLeft.forbiddenWord,

                      //GuradRail
                      "guardRailModelID": self.configLeft.guardRailModelID,

                      //Image generation
                      "modelType": self.configLeft.modelType,
                      "styleImage": self.configLeft.styleImage,
                      "resFormatImage": self.configLeft.resFormatImage,
                      "quality": self.configLeft.quality,
                      "resolution": self.configLeft.resolution,

                      //enableTime
                      "timeZone": self.configLeft.enableTime ? self.configLeft.timeZone : null,
                      "reasoningEffort": self.configLeft.reasoningEffort,
                    }
                  }
                ]
              };

              retry1 =
                self.$call.ChatPlayGroundStreamPOST(dataPostLeft, ConfigLeft, () => {
                  self.StatusProLeft = false;
                  self.successalert = true;
                  if(self.messageResLeft != "" && self.messageResLeft != null && self.messageResLeft != undefined)
                  {
                    self.listMessageLeft[self.listMessageLeft.length - 1].messageBot = self.messageResLeft;
                  }
                  self.listMessageLeft[self.listMessageLeft.length - 1].status_Process = "END";  
                  self.GetLogStreamLeft(_messageData);
                  setTimeout(() => {
                    self.CountScroll = self.MaxCountScroll;
                    self.ChatRef_ScrollIntoView();
                  }, 5);
                }, (_response) => {
                  console.log("retry1 -> Error : " + _response);
                  self.erroralert = true;
                  if (self.listMessageLeft.length == 0) {
                  }
                  else if (self.Stop_Flag_Left == true && self.listMessageLeft.length > 0) {
                    self.listMessageLeft[self.listMessageLeft.length - 1].status_Process = "Stop";
                  }
                  else {
                    self.StatusProLeft = false;
                    self.Count_messageResLeft = 0;
                    self.messageData = "";
                    if (self.listMessageLeft.length > 0 && self.listMessageLeft[self.listMessageLeft.length - 1].messageBot.length < self.messageResLeft.length) {
                      self.listMessageLeft[self.listMessageLeft.length - 1].messageBot = (self.messageResLeft + "<br />Error something went wrong ...");
                    }
                    else {
                      self.listMessageLeft[self.listMessageLeft.length - 1].messageBot += "Error something went wrong ...";
                    }
                    self.messageResLeft = "";
                    self.listMessageLeft[self.listMessageLeft.length - 1].status_Process = "Error";
                  }
                  self.Stop_Flag_Left = false;
                  setTimeout(() => {
                    self.CountScroll = self.MaxCountScroll;
                    self.ChatRef_ScrollIntoView();
                  }, 5);
                });
            }
            
            // API RightChat
            if(chatRightPersonalInfo) {
              promise2
              .then((result) => {
                // console.log("👤 Personal Information : ", result);
              })
              .catch((error) => {
                // console.log("🐞 Personal Information : ", error);
              });

              let dataPostRight = {
                "events": [
                  {
                    "replyToken": "dummyToken",
                    "type": "message",
                    "timestamp": 1462629479859,
                    "fullStream": false,
                    "stream": true,
                    "SessionID": self.SessionID,
                    "source": {
                      "type": "users",
                      "userId": self.configRight.User_Id,
                      // "groupModel": self.parameterURL.groupmodel
                    },

                    "message": {
                      "id": "325708",
                      "type": "text",
                      "topicID": self.topicIDRight,
                      "keyTopic": self.keyTopicRight,
                      "text": _messageData
                    },
                    "PersonalInfoToken": self.personalInfoToken,

                    configPlayground: {
                      // Default
                      "typeLLM": self.configRight.typeLLM == 1 ? 'GuardRail' : 'Bot',
                      "ModelDisplay": self.configRight.modelDisplay,
                      "ModelNameDisplay": self.configRight.modelNameDisplay,//self.configRight.modelName,
                      "ModelName": self.configRight.modelName, //self.configRight.modelNameDisplay,
                      "Provider": self.configRight.provider,
                      "APIVersion": self.configRight.APIVersion,
                      "Model": self.configRight.model.split('|').length > 1 ? self.configRight.model.split('|')[0] : self.configRight.model,
                      "EndPointURL": self.configRight.EndPointURL,
                      "API_Key": self.configRight.API_Key,

                      "Extension": self.configRight.extension,
                      "Description": self.configRight.description,
                      "gender": self.configRight.gender,
                      "Versioning": self.configRight.versioning,
                      "TypingSpeed": self.configRight.typingSpeed,
                      "maximumChatInput": self.configRight.maximumChatInput,
                      "IsStream": self.configRight.isStream,
                      // "IsBypass" : self.configRight.IsBypass,
                      "IsFeedback": self.configRight.isFeedback,
                      "IsPublish": self.configRight.isPublish,
                      "isAllowImage": self.configRight.isAllowImage,
                      "fileUploadLimit": self.configRight.fileUploadLimit,

                      // Vector
                      "vectordbName": self.configRight.vectordbName == null || JSON.stringify(self.configRight.vectordbName) == "[]" ? null : JSON.stringify(self.configRight.vectordbName),
                      "groupReplaceID": self.configRight.groupReplaceID == null || JSON.stringify(self.configRight.groupReplaceID) == "[]" ? null : JSON.stringify(self.configRight.groupReplaceID),
                      "productGroupID": self.configRight.productGroupID == null || JSON.stringify(self.configRight.productGroupID) == "[]" ? null : JSON.stringify(self.configRight.productGroupID),
                      "TopVDB": self.configRight.topVDB,
                      "Cosine": self.configRight.Cosine,
                      "productTopVDB": self.configRight.productTopVDB,
                      "productCosine": self.configRight.productCosine,
                      "LenChainMassage": self.configRight.LenChainMassage,
                      "TimeSecondChainMassage": self.configRight.TimeSecondChainMassage,
                      "IsChainMassage": self.configRight.IsChainMassage,

                      // Memory History 
                      "HistoryCount": self.configRight.historyCount,
                      "HistoryMinute": self.configRight.historyMinute > 0 ? -self.configRight.historyMinute : self.configRight.historyMinute,
                      "Len_ShortMemory": self.configRight.Len_ShortMemory,
                      "IsLongTerm_Memory": self.configRight.IsLongTerm_Memory,

                      // Advance
                      "temperature": self.configRight.temperature,
                      "top_p": self.configRight.topP,
                      "frequency_penalty": self.configRight.frequencyPenalty,
                      "presence_penalty": self.configRight.presencePenalty,
                      "max_tokens": self.configRight.maxTokens,
                      "Stop": self.configRight.stop,

                      // Data Integration
                      "DataIntegrationID": self.configRight.DataIntegrationID,
                      "SqlModelID": self.configRight.SqlModelID,
                      "promptSqlNoData": self.configRight.promptSqlNoData,
                      "IntentGroupID": self.configRight.IntentGroupID,
                      "promptTemplate": self.configRight.promptTemplate,

                      //Line Config 
                      "loadingBarFlag": self.configRight.loadingBarFlag,
                      "loadingBarDuration": self.configRight.loadingBarDuration,
                      //"forbiddenWord": self.ConfigRight.forbiddenWord,

                      //GuradRail
                      "guardRailModelID": self.configRight.guardRailModelID,

                      //Image generation
                      "modelType": self.configRight.modelType,
                      "styleImage": self.configRight.styleImage,
                      "resFormatImage": self.configRight.resFormatImage,
                      "quality": self.configRight.quality,
                      "resolution": self.configRight.resolution,

                      //enableTime
                      "timeZone": self.configRight.enableTime ? self.configRight.timeZone : null,
                      "reasoningEffort": self.configRight.reasoningEffort,
                    }
                  }
                ]
              };

              retry2 =
                self.$call.ChatPlayGroundStreamPOST(dataPostRight, ConfigRight, () => {
                  self.StatusProRight = false;
                  self.successalert = true;
                  self.listMessageRight[self.listMessageRight.length - 1].messageBot = self.messageResRight;
                  self.listMessageRight[self.listMessageRight.length - 1].status_Process = "END";
                  self.GetLogStreamRight(_messageData);
                  setTimeout(() => {
                    self.CountScroll = self.MaxCountScroll;
                    self.ChatRef_ScrollIntoView();
                  }, 5);
                }, (_response) => {
                  self.erroralert = true;
                  if (self.listMessageRight.length == 0) {
                  }
                  else if (self.Stop_Flag_Right == true && self.listMessageRight.length > 0) {
                    self.listMessageRight[self.listMessageRight.length - 1].status_Process = "Stop";
                  }
                  else {
                    self.StatusProRight = false;
                    self.Count_messageResRight = 0;
                    self.messageData = "";
                    if (self.listMessageRight.length > 0 && self.listMessageRight[self.listMessageRight.length - 1].messageBot.length < self.messageResRight.length) {
                      self.listMessageRight[self.listMessageRight.length - 1].messageBot = (self.messageResRight + "<br />Error something went wrong ...");
                    }
                    else {
                      self.listMessageRight[self.listMessageRight.length - 1].messageBot += "Error something went wrong ...";
                    }
                    self.messageResRight = "";
                    self.listMessageRight[self.listMessageRight.length - 1].status_Process = "Error";
                  }
                  self.Stop_Flag_Right = false;
                  setTimeout(() => {
                    self.CountScroll = self.MaxCountScroll;
                    self.ChatRef_ScrollIntoView();
                  }, 5);
                });
            }

          } catch (error) {
            // console.log("🐞 ใน handleMessage:", error);
          } finally {
            // console.log("🛑 EventListener message");
            window.removeEventListener('message', handleMessage);
          }
        };

        // console.log("🧱 EventListener message");
        window.addEventListener('message', handleMessage);
      }

      if (chatLeftPersonalInfo && chatRightPersonalInfo) {
        await Promise.all([retry1, retry2]);
      }
      else if (chatLeftPersonalInfo) {
        await Promise.all([retry1]);
      }
      else if (chatRightPersonalInfo) {
        await Promise.all([retry2]);
      }
      //#endregion

      console.log("🏁 End");
    },


    Clear_listMessage() {
      try {
        var self = this;
        if ((self.listMessageLeft.length == 0 || (self.listMessageLeft.length > 0 &&
          (self.listMessageLeft[self.listMessageLeft.length - 1].status_Process == 'Process' ||
            self.listMessageLeft[self.listMessageLeft.length - 1].status_Process == 'Send_Message' ||
            self.listMessageLeft[self.listMessageLeft.length - 1].status_Process == 'VoiceStart'))) &&
          (self.listMessageRight.length == 0 || (self.listMessageRight.length > 0 &&
            (self.listMessageRight[self.listMessageRight.length - 1].status_Process == 'Process' ||
              self.listMessageRight[self.listMessageRight.length - 1].status_Process == 'Send_Message' ||
              self.listMessageRight[self.listMessageRight.length - 1].status_Process == 'VoiceStart')))) {
          return;
        }

        let dataPostLeft = {
          "events": [
            {
              "replyToken": "dummyToken",
              "type": "message",
              "timestamp": 1462629479859,
              "fullStream": false,
              "stream": true,
              "SessionID": self.SessionID,
              "source": {
                "type": "users",
                "userId": self.configLeft.User_Id,
                // "groupModel": self.parameterURL.groupmodel
              },

              "message": {
                "id": "325708",
                "type": "text",
                "topicID": self.topicIDLeft,
                "keyTopic": self.keyTopicLeft,
                "text": ":clearhistory"
              },

              configPlayground: {
                // Default

                "ModelDisplay": self.configLeft.modelDisplay,
                "ModelNameDisplay": self.configLeft.modelNameDisplay, //self.configLeft.modelName,
                "ModelName": self.configLeft.modelName, //self.configLeft.modelNameDisplay,
                "Provider": self.configLeft.provider,
                "Model": self.configLeft.model,
                "EndPointURL": self.configLeft.EndPointURL,
                "API_Key": self.configLeft.API_Key,
                "Extension": self.configLeft.extension,
                "Description": self.configLeft.description,
                "gender": self.configLeft.gender,
                "Versioning": self.configLeft.versioning,
                "TypingSpeed": self.configLeft.typingSpeed,
                "maximumChatInput": self.configLeft.maximumChatInput,
                "IsStream": self.configLeft.isStream,
                // "IsBypass" : self.configLeft.IsBypass,
                "IsFeedback": self.configLeft.isFeedback,
                "IsPublish": self.configLeft.isPublish,
                "isAllowImage": self.configLeft.isAllowImage,
                "fileUploadLimit": self.configLeft.fileUploadLimit,

                // Vector
                "vectordbName": JSON.stringify(self.configLeft.vectordbName),
                "groupReplaceID": JSON.stringify(self.configLeft.groupReplaceID),
                "productGroupID": JSON.stringify(self.configLeft.productGroupID),
                "TopVDB": self.configLeft.topVDB,
                "Cosine": self.configLeft.Cosine,
                "productTopVDB": self.configLeft.productTopVDB,
                "productCosine": self.configLeft.productCosine,
                "LenChainMassage": self.configLeft.LenChainMassage,
                "TimeSecondChainMassage": self.configLeft.TimeSecondChainMassage,
                "IsChainMassage": self.configLeft.IsChainMassage,

                // Memory History 
                "HistoryCount": self.configLeft.historyCount,
                "HistoryMinute": self.configLeft.historyMinute > 0 ? -self.configLeft.historyMinute : self.configLeft.historyMinute,
                "Len_ShortMemory": self.configLeft.Len_ShortMemory,
                "IsLongTerm_Memory": self.configLeft.IsLongTerm_Memory,

                // Advance
                "temperature": self.configLeft.temperature,
                "top_p": self.configLeft.topP,
                "frequency_penalty": self.configLeft.frequencyPenalty,
                "presence_penalty": self.configLeft.presencePenalty,
                "max_tokens": self.configLeft.maxTokens,
                "Stop": self.configLeft.stop,

                // Data Integration
                "DataIntegrationID": self.configLeft.DataIntegrationID,
                "SqlModelID": self.configLeft.SqlModelID,
                "promptSqlNoData": self.configLeft.promptSqlNoData,
                "IntentGroupID": self.configLeft.IntentGroupID,
                "promptTemplate": self.configLeft.promptTemplate,

                //Line Config 
                "loadingBarFlag": self.configLeft.loadingBarFlag,
                "loadingBarDuration": self.configLeft.loadingBarDuration,
                //"forbiddenWord": self.ConfigLeft.forbiddenWord,

                //enableTime
                "timeZone": self.configLeft.enableTime ? self.configLeft.timeZone : null,
              }
            }
          ]
        };

        let dataPostRight = {
          "events": [
            {
              "replyToken": "dummyToken",
              "type": "message",
              "timestamp": 1462629479859,
              "fullStream": false,
              "stream": true,
              "SessionID": self.SessionID,
              "source": {
                "type": "users",
                "userId": self.configRight.User_Id,
              },

              "message": {
                "id": "325708",
                "type": "text",
                "topicID": self.topicIDRight,
                "keyTopic": self.keyTopicRight,
                "text": ":clearhistory"
              },

              configPlayground: {
                // Default
                "ModelDisplay": self.configRight.modelDisplay,
                "ModelNameDisplay": self.configRight.modelNameDisplay, //self.configRight.modelName,
                "ModelName": self.configRight.modelName, //self.configRight.modelNameDisplay,
                "Provider": self.configRight.provider,
                "Model": self.configRight.model,
                "EndPointURL": self.configRight.EndPointURL,
                "API_Key": self.configRight.API_Key,
                "Extension": self.configRight.extension,
                "Description": self.configRight.description,
                "gender": self.configRight.gender,
                "Versioning": self.configRight.versioning,
                "TypingSpeed": self.configRight.typingSpeed,
                "maximumChatInput": self.configRight.maximumChatInput,
                "IsStream": self.configRight.isStream,
                // "IsBypass" : self.configRight.IsBypass,
                "IsFeedback": self.configRight.isFeedback,
                "IsPublish": self.configRight.isPublish,
                "isAllowImage": self.configRight.isAllowImage,
                "fileUploadLimit": self.configRight.fileUploadLimit,

                // Vector
                "vectordbName": JSON.stringify(self.configRight.vectordbName),
                "groupReplaceID": JSON.stringify(self.configRight.groupReplaceID),
                "productGroupID": JSON.stringify(self.configRight.productGroupID),
                "TopVDB": self.configRight.topVDB,
                "Cosine": self.configRight.Cosine,
                "productTopVDB": self.configLeft.productTopVDB,
                "productCosine": self.configLeft.productCosine,
                "LenChainMassage": self.configRight.LenChainMassage,
                "TimeSecondChainMassage": self.configRight.TimeSecondChainMassage,
                "IsChainMassage": self.configRight.IsChainMassage,

                // Memory History 
                "HistoryCount": self.configRight.historyCount,
                "HistoryMinute": self.configRight.historyMinute > 0 ? -self.configRight.historyMinute : self.configRight.historyMinute,
                "Len_ShortMemory": self.configRight.Len_ShortMemory,
                "IsLongTerm_Memory": self.configRight.IsLongTerm_Memory,

                // Advance
                "temperature": self.configRight.temperature,
                "top_p": self.configRight.topP,
                "frequency_penalty": self.configRight.frequencyPenalty,
                "presence_penalty": self.configRight.presencePenalty,
                "max_tokens": self.configRight.maxTokens,
                "Stop": self.configRight.stop,

                // Data Integration
                "DataIntegrationID": self.configRight.DataIntegrationID,
                "SqlModelID": self.configRight.SqlModelID,
                "promptSqlNoData": self.configRight.promptSqlNoData,
                "IntentGroupID": self.configRight.IntentGroupID,
                "promptTemplate": self.configRight.promptTemplate,

                //Line Config 
                "loadingBarFlag": self.configRight.loadingBarFlag,
                "loadingBarDuration": self.configRight.loadingBarDuration,
                // "forbiddenWord": self.ConfigRight.forbiddenWord,

                //enableTime
                "timeZone": self.configRight.enableTime ? self.configRight.timeZone : null,
              }
            }
          ]
        };


        // API LeftChat
        if ((self.configLeft.model != '' && self.configLeft.model != null)) {
          let ConfigLeft = {
            onUploadProgress: () => {
              console.log("onUploadProgress");
            },
            onDownloadProgress: () => {
              console.log("onDownloadProgress");
            },
            maxRedirects: 0 // avoid buffering the entire stream
          }
          self.$call.ChatPlayGroundStreamPOST(dataPostLeft, ConfigLeft, () => {
            // self.ClearModel('Left');
            self.messageData = "";
            self.listMessageLeft = [];
            self.messageResLeft = "";
            self.Count_messageResLeft = 0;
            self.StatusProLeft = false;
            self.DataLogLeft = {
              Prompt: "",
              Vector: "",
              ReplySQL: "",
              ReplyDataSelect: "",
              Memory: "",
              Translate: "",
              FlowActionIntent: "",
              GPT_Model: {
                modelId: "",
                modelName: "",
                Provider: "",
                model: "",
                extension: "",
                description: "",
                promptTemplate: "",
                gender: "",
                vectordbName: "",
                productGroupID: "",
                topVDB: "",
                Cosine: "",
                productTopVDB: "",
                productCosine: "",
                internet: "",
                feedback: "",
                historyCount: "",
                historyMinute: "",
                temperature: "",
                topP: "",
                frequency_penalty: "",
                presence_penalty: "",
                stop: "",
                maxTokens: "",
                isStream: "",
                EndpointURL: ""
              },
              Text: "",
              VectorCoise: "",
              Private_Memory: ""
            };
          }, () => { });
        }
        // API RightChat
        if ((self.configRight.model != '' && self.configRight.model != null)) {
          let ConfigRight = {
            onUploadProgress: () => {
              console.log("onUploadProgress");
            },
            onDownloadProgress: () => {
              console.log("onDownloadProgress");
            },
            maxRedirects: 0 // avoid buffering the entire stream
          }
          self.$call.ChatPlayGroundStreamPOST(dataPostRight, ConfigRight, () => {
            // self.ClearModel('Right');
            self.messageData = "";
            self.listMessageRight = [];
            self.messageResRight = "";
            self.Count_messageResRight = 0;
            self.StatusProRight = false;
            self.DataLogRight = {
              Prompt: "",
              Vector: "",
              ReplySQL: "",
              ReplyDataSelect: "",
              Memory: "",
              Translate: "",
              FlowActionIntent: "",
              GPT_Model: {
                modelId: "",
                modelName: "",
                Provider: "",
                model: "",
                extension: "",
                description: "",
                promptTemplate: "",
                gender: "",
                productGroupID: "",
                topVDB: "",
                Cosine: "",
                productTopVDB: "",
                productCosine: "",
                internet: "",
                feedback: "",
                historyCount: "",
                historyMinute: "",
                temperature: "",
                topP: "",
                frequency_penalty: "",
                presence_penalty: "",
                stop: "",
                maxTokens: "",
                isStream: "",
                EndpointURL: ""
              },
              Text: "",
              VectorCoise: "",
              Private_Memory: ""
            };
          }, () => { });
        }
      } catch (ex) { console.log(ex) }
    },

    Text_RunLeft() {

      let self = this;

      self.TimeOutText_Run = setTimeout(() => {
        if (self.listMessageLeft.length == 0) {
          self.StopMessageLeft();
          return;
        }
        if (self.Count_messageResLeft >= self.messageResLeft.length && self.StatusProLeft == false) {
          setTimeout(() => {
            self.CountScroll = self.MaxCountScroll;
            self.ChatRef_ScrollIntoView();
          }, 5);
        }
        if (self.Count_messageResLeft < self.messageResLeft.length || self.StatusProLeft == true) {
          if (self.listMessageLeft[self.listMessageLeft.length - 1].messageBot.length > 0 && self.listMessageLeft[self.listMessageLeft.length - 1].messageBot.substring(self.listMessageLeft[self.listMessageLeft.length - 1].messageBot.length - 47, self.listMessageLeft[self.listMessageLeft.length - 1].messageBot.length) == '<span class="blinking-cursor" style="">|</span>') {
            self.listMessageLeft[self.listMessageLeft.length - 1].messageBot = self.listMessageLeft[self.listMessageLeft.length - 1].messageBot.substring(0, self.listMessageLeft[self.listMessageLeft.length - 1].messageBot.length - 47);
          }
          if (self.Count_messageResLeft < self.messageResLeft.length) {
            if (self.messageResLeft.length > (self.Count_messageResLeft + 5) && self.messageResLeft[self.Count_messageResLeft] == "<") {
              if (self.messageResLeft[self.Count_messageResLeft] + self.messageResLeft[self.Count_messageResLeft + 1] + self.messageResLeft[self.Count_messageResLeft + 2]
                + self.messageResLeft[self.Count_messageResLeft + 3] + self.messageResLeft[self.Count_messageResLeft + 4] + self.messageResLeft[self.Count_messageResLeft + 5]
                == "<br />") {
                self.listMessageLeft[self.listMessageLeft.length - 1].messageBot += "<br />";
                self.Count_messageResLeft += 5;
              }
              else if (self.messageResLeft[self.Count_messageResLeft] == "<") {
                self.listMessageLeft[self.listMessageLeft.length - 1].messageBot += self.messageResLeft[self.Count_messageResLeft];
              }
              else {
                self.listMessageLeft[self.listMessageLeft.length - 1].messageBot += self.messageResLeft[self.Count_messageResLeft];
              }
            } else if ((self.messageResLeft[self.Count_messageResLeft] + self.messageResLeft[self.Count_messageResLeft + 1] + self.messageResLeft[self.Count_messageResLeft + 2]
              + self.messageResLeft[self.Count_messageResLeft + 3] + self.messageResLeft[self.Count_messageResLeft + 4] + self.messageResLeft[self.Count_messageResLeft + 5]
              + self.messageResLeft[self.Count_messageResLeft + 6] + self.messageResLeft[self.Count_messageResLeft + 7] == "![Image]") || self.messageImageLeft != "") {
              let count = 0;
              for (let index = self.Count_messageResLeft; index < self.messageResLeft.length; index++) {
                const element = self.messageResLeft[index];
                self.messageImageLeft += element;
                count++;
                if (element == ")") {
                  break;
                }
              }
              if (self.messageResLeft[self.Count_messageResLeft + (count - 1)] == ")") {
                self.listMessageLeft[self.listMessageLeft.length - 1].messageBot += self.messageImageLeft;
                self.messageImageLeft = "";
              }
              self.Count_messageResLeft += count - 1;
            }
            else {
              self.listMessageLeft[self.listMessageLeft.length - 1].messageBot += self.messageResLeft[self.Count_messageResLeft];
              self.messageImageLeft = "";
            }
            self.Count_messageResLeft++;
            self.ChatRef_ScrollIntoView();
          }
          self.listMessageLeft[self.listMessageLeft.length - 1].messageBot += `<span class="blinking-cursor" style="">|</span>`;
          if (self.Count_messageResLeft == self.messageResLeft.length && self.listMessageLeft[self.listMessageLeft.length - 1].status_Process == "END") {
            if (self.listMessageLeft[self.listMessageLeft.length - 1].messageBot.length > 0 && self.listMessageLeft[self.listMessageLeft.length - 1].messageBot.substring(self.listMessageLeft[self.listMessageLeft.length - 1].messageBot.length - 47, self.listMessageLeft[self.listMessageLeft.length - 1].messageBot.length) == '<span class="blinking-cursor" style="">|</span>') {
              self.listMessageLeft[self.listMessageLeft.length - 1].messageBot = self.listMessageLeft[self.listMessageLeft.length - 1].messageBot.substring(0, self.listMessageLeft[self.listMessageLeft.length - 1].messageBot.length - 47);
            }
          }
          self.Text_RunLeft();
        }
      }, self.configLeft.typingSpeed);
    },
    Text_RunRight() {

      let self = this;

      self.TimeOutText_Run = setTimeout(() => {

        if (self.listMessageRight.length == 0) {
          self.StopMessageRight();
          return;
        }

        if (self.Count_messageResRight >= self.messageResRight.length && self.StatusProRight == false) {
          setTimeout(() => {
            self.CountScroll = self.MaxCountScroll;
            self.ChatRef_ScrollIntoView();
          }, 5);
        }
        if (self.Count_messageResRight < self.messageResRight.length || self.StatusProRight == true) {
          if (self.listMessageRight[self.listMessageRight.length - 1].messageBot.length > 0 && self.listMessageRight[self.listMessageRight.length - 1].messageBot.substring(self.listMessageRight[self.listMessageRight.length - 1].messageBot.length - 47, self.listMessageRight[self.listMessageRight.length - 1].messageBot.length) == '<span class="blinking-cursor" style="">|</span>') {
            self.listMessageRight[self.listMessageRight.length - 1].messageBot = self.listMessageRight[self.listMessageRight.length - 1].messageBot.substring(0, self.listMessageRight[self.listMessageRight.length - 1].messageBot.length - 47);
          }
          if (self.Count_messageResRight < self.messageResRight.length) {
            if (self.messageResRight.length > (self.Count_messageResRight + 5) && self.messageResLeft[self.Count_messageResRight] == "<") {
              if (self.messageResRight[self.Count_messageResRight] + self.messageResRight[self.Count_messageResRight + 1] + self.messageResRight[self.Count_messageResRight + 2]
                + self.messageResRight[self.Count_messageResRight + 3] + self.messageResRight[self.Count_messageResRight + 4] + self.messageResRight[self.Count_messageResRight + 5]
                == "<br />") {
                self.listMessageRight[self.listMessageRight.length - 1].messageBot += "<br />";
                self.Count_messageResRight += 5;
              }
              else if (self.messageResRight[self.Count_messageResRight] == "<") {
                self.listMessageRight[self.listMessageRight.length - 1].messageBot += self.messageResRight[self.Count_messageResRight];
              }
              else {
                self.listMessageRight[self.listMessageRight.length - 1].messageBot += self.messageResRight[self.Count_messageResRight];
              }
            } else if ((self.messageResRight[self.Count_messageResRight] + self.messageResRight[self.Count_messageResRight + 1] + self.messageResRight[self.Count_messageResRight + 2]
              + self.messageResRight[self.Count_messageResRight + 3] + self.messageResRight[self.Count_messageResRight + 4] + self.messageResRight[self.Count_messageResRight + 5]
              + self.messageResRight[self.Count_messageResRight + 6] + self.messageResRight[self.Count_messageResRight + 7] == "![Image]") || self.messageImageRight != "") {
              let count = 0;
              for (let index = self.Count_messageResRight; index < self.messageResRight.length; index++) {
                const element = self.messageResRight[index];
                self.messageImageRight += element;
                count++;
                if (element == ")") {
                  break;
                }
              }
              if (self.messageResRight[self.Count_messageResRight + (count - 1)] == ")") {
                self.listMessageRight[self.listMessageRight.length - 1].messageBot += self.messageImageRight;
                self.messageImageRight = "";
              }
              self.Count_messageResRight += count - 1;
            }
            else {
              self.listMessageRight[self.listMessageRight.length - 1].messageBot += self.messageResRight[self.Count_messageResRight];
              self.messageImageRight = "";
            }
            self.Count_messageResRight++;
            self.ChatRef_ScrollIntoView();
          }
          self.listMessageRight[self.listMessageRight.length - 1].messageBot += `<span class="blinking-cursor" style="">|</span>`;
          if (self.Count_messageResRight == self.messageResRight.length && self.listMessageRight[self.listMessageRight.length - 1].status_Process == "END") {
            if (self.listMessageRight[self.listMessageRight.length - 1].messageBot.length > 0 && self.listMessageRight[self.listMessageRight.length - 1].messageBot.substring(self.listMessageRight[self.listMessageRight.length - 1].messageBot.length - 47, self.listMessageRight[self.listMessageRight.length - 1].messageBot.length) == '<span class="blinking-cursor" style="">|</span>') {
              self.listMessageRight[self.listMessageRight.length - 1].messageBot = self.listMessageRight[self.listMessageRight.length - 1].messageBot.substring(0, self.listMessageRight[self.listMessageRight.length - 1].messageBot.length - 47);
            }
          }
          self.Text_RunRight();
        }
      }, self.configRight.typingSpeed);
    },

    Replace_NewLine(input) {
      try {
        if (input != null && input.length > 0 && (input[0] === '\n' || input[0] === '\r')) {
          input = input.slice(1, input.length);
        }
        if (input != null && input.length > 0 && (input[0] === '\n' || input[0] === '\r')) {
          input = input.slice(1, input.length);
        }
      } catch {
      }
      return input;
    },
    GetLogStreamLeft(_messageData) {
      var self = this;
      let catchData = {
        Prompt: "",
        Vector: "",
        ReplySQL: "",
        ReplyDataSelect: "",
        Memory: "",
        GPT_Model: {
          modelId: "",
          modelName: "",
          Provider: "",
          model: "",
          extension: "",
          description: "",
          promptTemplate: "",
          gender: "",
          vectordbName: "",
          productGroupID: "",
          topVDB: "",
          Cosine: "",
          productTopVDB: "",
          productCosine: "",
          internet: "",
          feedback: "",
          historyCount: "",
          historyMinute: "",
          temperature: "",
          topP: "",
          frequency_penalty: "",
          presence_penalty: "",
          stop: "",
          maxTokens: "",
          isStream: "",
          EndpointURL: ""
        },
        Text: "",
        TextVector: "",
        Private_Memory: ""
      };
      self.DataLogLeft = catchData;
      try {
        let _User_Id = { USER_CHANNEL: self.configLeft.User_Id, messageData: _messageData, KeyTopic: self.keyTopicLeft };
        self.$call.GetLogStream(_User_Id, (response) => {
          try {
            if (response.status == 0 && response.data.status == true) {
              let DataLog_Data = response.data.data;
              self.DataLog_Data = DataLog_Data;
              let replymsg = null;
              try {
                // Save TopicID and KeyTopic from response
                if (DataLog_Data.topicID) {
                  self.topicIDLeft = DataLog_Data.topicID;
                }
                if (DataLog_Data.keyTopic) {
                  self.keyTopicLeft = DataLog_Data.keyTopic;
                }
                replymsg = JSON.parse(DataLog_Data.replymsg);
                replymsg.Vector = self.Replace_NewLine(replymsg.Vector);
                replymsg.VectorCoise = self.Replace_NewLine(replymsg.VectorCoise);
                replymsg.Private_Memory = self.Replace_NewLine(replymsg.Private_Memory);
                if (replymsg == null) {
                  replymsg = catchData;
                }
              }
              catch {
                replymsg = {
                  Vector: "",
                  VectorCoise: "",
                  ReplySQL: "",
                  ReplyDataSelect: "",
                  Private_Memory: "",
                  FlowActionIntent: "",
                  GPT_Model: {
                    modelId: "",
                    modelName: "",
                    Provider: "",
                    model: "",
                    extension: "",
                    description: "",
                    promptTemplate: "",
                    gender: "",
                    vectordbName: "",
                    productGroupID: "",
                    topVDB: "",
                    Cosine: "",
                    productTopVDB: "",
                    productCosine: "",
                    internet: "",
                    feedback: "",
                    historyCount: "",
                    historyMinute: "",
                    temperature: "",
                    topP: "",
                    frequency_penalty: "",
                    presence_penalty: "",
                    stop: "",
                    maxTokens: "",
                    isStream: ""
                  }
                }
                console.log("replymsg E")
              }

              let Memory = null;
              try {
                let L_Memory = JSON.parse(DataLog_Data.shortmemory);
                if (L_Memory != null && L_Memory.length > 0) {
                  Memory = "";
                  for (let i = 0; i < L_Memory.length; i++) {
                    Memory += "" + (i + 1) + ". " + L_Memory[i].role + " : " + L_Memory[i].content + "\n";
                  }
                }
                else {
                  Memory = DataLog_Data.shortmemory;
                }
              }
              catch {
                Memory = "";
              }
              self.DataLogLeft = {
                Prompt: DataLog_Data.prompt,
                Vector: replymsg.Vector,
                ReplySQL: replymsg.ReplySQL,
                ReplyDataSelect: replymsg.ReplyDataSelect,
                Memory: Memory,
                Translate: replymsg.Translate,
                FlowActionIntent: replymsg.FlowActionIntent,
                GPT_Model: {
                  modelId: parseInt(self.configLeft.modelDisplay) != null ? parseInt(self.configLeft.modelDisplay) : '-',
                  modelName: replymsg.GPT_Model.ModelName,
                  Provider: replymsg.GPT_Model.Provider,
                  model: replymsg.GPT_Model.Model,
                  extension: replymsg.GPT_Model.Extension,
                  description: replymsg.GPT_Model.Description,
                  promptTemplate: replymsg.GPT_Model.promptTemplate,
                  gender: replymsg.GPT_Model.gender,
                  vectordbName: replymsg.GPT_Model.vectordbName,
                  productGroupID: replymsg.GPT_Model.productGroupID,
                  topVDB: replymsg.GPT_Model.TopVDB,
                  Cosine: replymsg.GPT_Model.Cosine,
                  productTopVDB: replymsg.GPT_Model.productTopVDB,
                  productCosine: replymsg.GPT_Model.productCosine,
                  internet: replymsg.GPT_Model.internet,
                  feedback: replymsg.GPT_Model.feedback,
                  historyCount: replymsg.GPT_Model.HistoryCount,
                  historyMinute: replymsg.GPT_Model.HistoryMinute,
                  temperature: replymsg.GPT_Model.temperature,
                  topP: replymsg.GPT_Model.topP,
                  frequency_penalty: replymsg.GPT_Model.frequency_penalty,
                  presence_penalty: replymsg.GPT_Model.presence_penalty,
                  stop: replymsg.GPT_Model.Stop,
                  maxTokens: replymsg.GPT_Model.max_tokens,
                  isStream: replymsg.GPT_Model.isStream,
                  EndpointURL: replymsg.GPT_Model.EndpointURL
                },
                Text: DataLog_Data.text,
                TextVector: replymsg.GPT_Model.TextVector,
                VectorCoise: replymsg.VectorCoise,
                Private_Memory: replymsg.Private_Memory

              };
            }
            else {
              self.DataLogLeft = catchData;
            }
          }
          catch {
            self.DataLogLeft = catchData;
          }
        }, () => {
          self.DataLogLeft = catchData;
        });
      }
      catch {
        self.Status_Error = true;
        // self.Text_Status = "ไม่พบ Auth";
      }
    },
    GetLogStreamRight(_messageData) {
      var self = this;
      let catchData = {
        Prompt: "",
        Vector: "",
        ReplySQL: "",
        ReplyDataSelect: "",
        Memory: "",
        GPT_Model: {
          modelId: "",
          modelName: "",
          Provider: "",
          model: "",
          extension: "",
          description: "",
          promptTemplate: "",
          gender: "",
          vectordbName: "",
          productGroupID: "",
          topVDB: "",
          Cosine: "",
          productTopVDB: "",
          productCosine: "",
          internet: "",
          feedback: "",
          historyCount: "",
          historyMinute: "",
          temperature: "",
          topP: "",
          frequency_penalty: "",
          presence_penalty: "",
          Stop: "",
          maxTokens: "",
          isStream: "",
          EndpointURL: ""
        },
        Text: "",
        TextVector: "",
        Private_Memory: ""
      };
      self.DataLogRight = catchData;
      try {
        let _User_Id = { USER_CHANNEL: self.configRight.User_Id, messageData: _messageData, KeyTopic: self.keyTopicRight };
        self.$call.GetLogStream(_User_Id, (response) => {
          try {
            if (response.status == 0 && response.data.status == true) {
              let DataLog_Data = response.data.data;
              self.DataLog_Data = DataLog_Data;
              let replymsg = null;
              try {
                // Save TopicID and KeyTopic from response
                if (DataLog_Data.topicID) {
                  self.topicIDRight = DataLog_Data.topicID;
                }
                if (DataLog_Data.keyTopic) {
                  self.keyTopicRight = DataLog_Data.keyTopic;
                }
                replymsg = JSON.parse(DataLog_Data.replymsg);
                replymsg.Vector = self.Replace_NewLine(replymsg.Vector);
                replymsg.VectorCoise = self.Replace_NewLine(replymsg.VectorCoise);
                replymsg.Private_Memory = self.Replace_NewLine(replymsg.Private_Memory);
                if (replymsg == null) {
                  replymsg = catchData;
                }
              }
              catch {
                replymsg = {
                  Vector: "",
                  VectorCoise: "",
                  Private_Memory: "",
                  GPT_Model: {
                    modelId: "",
                    modelName: "",
                    Provider: "",
                    model: "",
                    extension: "",
                    description: "",
                    promptTemplate: "",
                    gender: "",
                    vectordbName: "",
                    productGroupID: "",
                    topVDB: "",
                    Cosine: "",
                    productTopVDB: "",
                    productCosine: "",
                    internet: "",
                    feedback: "",
                    historyCount: "",
                    historyMinute: "",
                    temperature: "",
                    topP: "",
                    frequency_penalty: "",
                    presence_penalty: "",
                    Stop: "",
                    maxTokens: "",
                    isStream: "",
                    EndpointURL: ""
                  }
                }
                console.log("replymsg E")
              }

              let Memory = null;
              try {
                let L_Memory = JSON.parse(DataLog_Data.shortmemory);
                if (L_Memory != null && L_Memory.length > 0) {
                  Memory = "";
                  for (let i = 0; i < L_Memory.length; i++) {
                    Memory += "" + (i + 1) + ". " + L_Memory[i].role + " : " + L_Memory[i].content + "\n";
                  }
                }
                else {
                  Memory = DataLog_Data.shortmemory;
                }
              }
              catch {
                Memory = "";
              }
              self.DataLogRight = {
                Prompt: DataLog_Data.prompt,
                Vector: replymsg.Vector,
                ReplySQL: replymsg.ReplySQL,
                ReplyDataSelect: replymsg.ReplyDataSelect,
                Memory: Memory,
                Translate: replymsg.Translate,
                FlowActionIntent: replymsg.FlowActionIntent,
                GPT_Model: {
                  modelId: parseInt(self.configRight.modelDisplay) != null ? parseInt(self.configRight.modelDisplay) : '-',
                  modelName: replymsg.GPT_Model.ModelName,
                  Provider: replymsg.GPT_Model.Provider,
                  model: replymsg.GPT_Model.Model,
                  extension: replymsg.GPT_Model.Extension,
                  description: replymsg.GPT_Model.Description,
                  promptTemplate: replymsg.GPT_Model.promptTemplate,
                  gender: replymsg.GPT_Model.gender,
                  vectordbName: replymsg.GPT_Model.vectordbName,
                  productGroupID: replymsg.GPT_Model.productGroupID,
                  topVDB: replymsg.GPT_Model.TopVDB,
                  Cosine: replymsg.GPT_Model.Cosine,
                  productTopVDB: replymsg.GPT_Model.productTopVDB,
                  productCosine: replymsg.GPT_Model.productCosine,
                  internet: replymsg.GPT_Model.internet,
                  feedback: replymsg.GPT_Model.feedback,
                  historyCount: replymsg.GPT_Model.HistoryCount,
                  historyMinute: replymsg.GPT_Model.HistoryMinute,
                  temperature: replymsg.GPT_Model.temperature,
                  topP: replymsg.GPT_Model.topP,
                  frequency_penalty: replymsg.GPT_Model.frequency_penalty,
                  presence_penalty: replymsg.GPT_Model.presence_penalty,
                  Stop: replymsg.GPT_Model.Stop,
                  maxTokens: replymsg.GPT_Model.max_tokens,
                  isStream: replymsg.GPT_Model.isStream,
                  EndpointURL: replymsg.GPT_Model.EndpointURL
                },
                Text: DataLog_Data.text,
                TextVector: replymsg.GPT_Model.TextVector,
                VectorCoise: replymsg.VectorCoise,
                Private_Memory: replymsg.Private_Memory

              };
            }
            else {
              self.DataLogRight = catchData;
            }
          }
          catch {
            self.DataLogRight = catchData;
          }
        }, () => {
          self.DataLogRight = catchData;
        });
      }
      catch {
        self.Status_Error = true;
        // self.Text_Status = "ไม่พบ Auth";
      }
    },
    StopMessage() {
      this.StopMessageLeft()
      this.StopMessageRight()
    },
    StopMessageLeft() {
      let self = this;
      if (self.listMessageLeft.length == 0 ||
        (self.listMessageLeft.length > 0 && (
          self.listMessageLeft[self.listMessageLeft.length - 1].status_Process == 'Stop' ||
          self.listMessageLeft[self.listMessageLeft.length - 1].status_Process == 'END' ||
          self.listMessageLeft[self.listMessageLeft.length - 1].status_Process == 'Error')
        )
      ) {
        return;
      }
      // stop Text_Run 
      if (self.TimeOutText_Run != null) {

        clearTimeout(self.TimeOutText_Run);
        self.TimeOutText_Run = null;
      }
      // stop voice
      if (self.TimeOutStop != null) {
        clearTimeout(self.TimeOutStop);
        self.TimeOutStop = null;
      }
      if (self.SpeechRecognizer != null) {

        self.listMessage.pop();

        self.SpeechRecognizer.stopContinuousRecognitionAsync();
      }
      // stop File
      if (self.Axios_ControllerAduio != null) {
        self.Axios_ControllerAduio.abort();
      }
      // strp Open ai
      if (self.Axios_Controller != null) {
        self.Axios_Controller.abort();
      }
      self.Stop_Flag_Left = true;
      if (self.listMessageLeft.length > 0 &&
        self.listMessageLeft[self.listMessageLeft.length - 1].messageBot.length < self.messageResLeft.length) {
        self.listMessageLeft[self.listMessageLeft.length - 1].messageBot = self.messageResLeft;
      }
      if (self.listMessageLeft.length > 0 &&
        self.listMessageLeft[self.listMessageLeft.length - 1].status_Process == 'END'
        && self.listMessageLeft[self.listMessageLeft.length - 1].messageBot != null
        && self.listMessageLeft[self.listMessageLeft.length - 1].messageBot.length < self.messageResLeft.length) {
        self.Count_messageResLeft = 0;
        self.StatusProLeft = true;
        self.messageRun = "";
        self.listMessageLeft[self.listMessageLeft.length - 1].messageBot = self.messageResLeft;
        self.messageResLeft = "";

        setTimeout(() => {
          self.CountScroll = self.MaxCountScroll;
          self.ChatRef_ScrollIntoView();
        }, 5);
        return;
      }
      if (self.listMessageLeft.length > 0) {
        self.listMessageLeft[self.listMessageLeft.length - 1].status_Process = "Stop";
      }
      self.listMessageLeft[self.listMessageLeft.length - 1].messageBot = self.listMessageLeft[self.listMessageLeft.length - 1].messageBot.replace('<span class="blinking-cursor" style="">|</span>', '');
      self.messageData = "";
      self.messageResLeft = "";
      self.Count_messageResLeft = 0;
      self.StatusProLeft = false;
    },

    StopMessageRight() {
      let self = this;
      if (self.listMessageRight.length == 0 ||
        (self.listMessageRight.length > 0 && (
          self.listMessageRight[self.listMessageRight.length - 1].status_Process == 'Stop' ||
          self.listMessageRight[self.listMessageRight.length - 1].status_Process == 'END' ||
          self.listMessageRight[self.listMessageRight.length - 1].status_Process == 'Error')
        )
      ) {
        return;
      }
      // stop Text_Run 
      if (self.TimeOutText_Run != null) {

        clearTimeout(self.TimeOutText_Run);
        self.TimeOutText_Run = null;
      }
      // stop voice
      if (self.TimeOutStop != null) {
        clearTimeout(self.TimeOutStop);
        self.TimeOutStop = null;
      }
      if (self.SpeechRecognizer != null) {

        self.listMessageRight.pop();

        self.SpeechRecognizer.stopContinuousRecognitionAsync();
      }
      // stop File
      if (self.Axios_ControllerAduio != null) {
        self.Axios_ControllerAduio.abort();
      }
      // strp Open ai
      if (self.Axios_Controller != null) {
        self.Axios_Controller.abort();
      }
      self.Stop_Flag_Right = true;
      if (self.listMessageRight.length > 0 &&
        self.listMessageRight[self.listMessageRight.length - 1].messageBot.length < self.messageResRight.length) {
        self.listMessageRight[self.listMessageRight.length - 1].messageBot = self.messageResRight;
      }
      if (self.listMessageRight.length > 0 &&
        self.listMessageRight[self.listMessageRight.length - 1].status_Process == 'END'
        && self.listMessageRight[self.listMessageRight.length - 1].messageBot != null
        && self.listMessageRight[self.listMessageRight.length - 1].messageBot.length < self.messageResRight.length) {
        self.Count_messageResRight = 0;
        self.StatusProRight = true;
        self.messageRunRight = "";
        self.listMessageRight[self.listMessageRight.length - 1].messageBot = self.messageResRight;
        self.messageResRight = "";

        setTimeout(() => {
          self.CountScroll = self.MaxCountScroll;
          self.ChatRef_ScrollIntoView();
        }, 5);
        return;
      }
      if (self.listMessageRight.length > 0) {
        self.listMessageRight[self.listMessageRight.length - 1].status_Process = "Stop";
      }
      self.listMessageRight[self.listMessageRight.length - 1].messageBot = self.listMessageRight[self.listMessageRight.length - 1].messageBot.replace('<span class="blinking-cursor" style="">|</span>', '');
      self.messageData = "";
      self.messageResRight = "";
      self.Count_messageResRight = 0;
      self.StatusProRight = false;
    },

    Shift_Enter_MessageData() {
      let self = this;
      self.point = self.$refs.RefMessageData.$refs.input.selectionStart;
      let _point = (self.$refs.RefMessageData.$refs.input.selectionStart - 1);
      self.$nextTick(() => {
        self.$refs.RefMessageData.$refs.input.selectionStart = _point + 2;
        self.$refs.RefMessageData.$refs.input.selectionEnd = _point + 2;
        if (self.$refs.RefMessageData.$refs.input &&
          self.$refs.RefMessageData.$refs.input.selectionStart >= self.messageData.length
        ) {
          const height = self.$refs.RefMessageData.$refs.input.scrollHeight

          // This has to be done ASAP, waiting for Vue
          // to update the DOM causes ugly layout jumping
          self.$refs.RefMessageData.$refs.input.scrollTop = height;
        }
      })
    },



    async GetlistDDGPTModelIsPublish() {
      let self = this;
      self.dialog = true;
      await self.$call.DDGPTModel_IsPublishByUser(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            if (self.$route.query.id) {
              self.listSqlExtract = dataResponse.data.filter(e => e.id != self.$route.query.id);
            } else {
              self.listSqlExtract = dataResponse.data;
            }

          } else {
            self.listSqlExtract = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    async GetDDGroupReplaceDB() {
      let self = this;
      self.dialog = true;
      await self.$call.GetDDGroupReplaceDB(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDGroupReplace = dataResponse.data;
          } else {
            self.DDGroupReplace = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    async GetDDLDataIntegration() {
      let self = this;
      self.dialog = true;
      await self.$call.GetDDLDataIntegration(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            self.listDataIntegration = dataResponse.data;
          } else {
            self.listDataIntegration = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    async GetModel() {
      let self = this;
      await self.$call.DDGPTModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.listDDModelDisplayName = dataResponse.data
          } else {
            self.listDDModelDisplayName = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    async GetIntentGroup() {
      let self = this;
      self.dialog = true;
      await self.$call.DDIntentGroup(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            self.listDDIntentGroup = dataResponse.data;
          } else {
            self.listDDIntentGroup = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    getItemModelNameText(item) {
      return `${item.modelDisplayID}: ${item.name}`;
    },
    async GetModelData() {
      let self = this;
      self.dialog = true;
      await self.$call.GetDDLModelData(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            self.listDDModel = dataResponse.data;
          } else {
            self.listDDModel = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    async GetProviderData() {
      let self = this;
      self.dialog = true;
      await self.$call.GetDDLProviderData(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            self.listDDProvider = dataResponse.data;
          } else {
            self.listDDProvider = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    async GetDDVectorName() {
      let self = this;
      self.dialog = true;
      await self.$call.GetDDVectorDBName(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDVector = dataResponse.data;
          } else {
            self.DDVector = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },

    async changeProvider(value) {
      let self = this;
      if (value == null || value == '') {
        self.DDModelShow = [];
        return 'Required.';
      } else {
        if (value == "Google" || value == "Anthropic") {
          self.DDModelShow = self.listDDModel.filter((e) => e.provider == value);
        }
        else {
          self.DDModelShow = self.listDDModel.filter((e) => e.provider == value || e.provider == "Azure");
        }
      }
    },
    async changeModel(value, side) {
      let self = this;
      if (value == null || value == '') {
        self.maxLengthChar = 0;
        return 'required.';
      } else {
        let ddm = self.listDDModel.find((e) => e.modelName == value);
        if (ddm) {
          if (value == 'gpt-35-turbo') {
            self.maxLengthChar = 4000;
          } else if (value == 'gpt-35-turbo-16k') {
            self.maxLengthChar = 8000;
          } else if (value == 'gpt-4') {
            self.maxLengthChar = 6000;
          } else {
            self.maxLengthChar = null;
          }
          self.configEdit.APIVersion = ddm.apiVersion;
          if (side == 'Left') {
            self.configLeft.APIVersion = ddm.apiVersion;
          } else {
            self.configRight.APIVersion = ddm.apiVersion;
          }
          // self.maxLengthChar = self.DDModel.find((e) => e.model == value).maxPrompt;
        } else {
          self.maxLengthChar = null;
        }
      }
    },
    numericKey: function (evt) {
      evt = (evt) ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();
      if (!/^\d*\.?\d*$/.test(expect) || parseFloat(expect) <= 0) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async GetByID(id, side) {
      let self = this;
      let userID = await self.GetUuidv4_Fun();
      self.dialog = true;
      await self.$call.GetGPTModelById(
        id,
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            let response = dataResponse.data;
            let resData = {

              // StatusforUpdate
              typeUpdate: true,
              modelIDGroup: response.modelIDGroup,

              // Default
              typeLLM: response.typeLLM == "Bot" ? 0 : response.typeLLM == "GuardRail" ? 1 : null,
              modelId: response.modelID,
              modelDisplay: response.modelDisplay,
              modelName: response.modelName,
              modelNameDisplay: response.modelNameDisplay,
              provider: response.provider,
              model: response.model,
              API_Key: response.apI_Key,
              EndPointURL: response.endPointURL,
              // GetGPTModelById
              extension: response.extension,
              description: response.description,
              gender: response.gender,
              versioning: response.versioning,
              typingSpeed: response.typingSpeed == null ? 40 : response.typingSpeed,
              maximumChatInput: response.maximumChatInput == null ? 200000 : response.maximumChatInput,
              isStream: response.isStream,
              // isBypass : response.isBypass,
              isFeedback: response.isFeedback,
              isPublish: response.isPublish,
              isAllowImage: response.isAllowImage,
              isAllowLLMChange: response.isAllowLLMChange,
              fileUploadLimit: response.fileUploadLimit,

              // Vector
              vectordbName: response.vectordbName == null ? [] : response.vectordbName,
              groupReplaceID: response.groupReplaceID == null ? [] : response.groupReplaceID,
              productGroupID: response.productGroupID == null ? [] : response.productGroupID,
              topVDB: response.topVDB,
              Cosine: response.cosine,
              productTopVDB: response.productTopVDB,
              productCosine: response.productCosine,
              LenChainMassage: response.lenChainMassage,
              TimeSecondChainMassage: response.timeSecondChainMassage,
              IsChainMassage: response.isChainMassage ?? false,

              // Memory History 
              historyCount: response.historyCount,
              historyMinute: response.historyMinute < 0 ? Math.abs(response.historyMinute) : response.historyMinute,
              Len_ShortMemory: response.len_ShortMemory ?? 200,
              IsLongTerm_Memory: response.provider == 'Google' ? false : (response.isLongTerm_Memory ?? false),
              // IsLongTerm_Memory : response.isLongTerm_Memory ,

              // Advanceresponse
              temperature: response.temperature,
              topP: response.top_p,
              frequencyPenalty: response.frequency_penalty,
              presencePenalty: response.presence_penalty,
              maxTokens: response.max_tokens,
              stop: response.stop,

              // Data Integration
              DataIntegrationID: response.dataIntegrationID,
              SqlModelID: response.sqlModelID,
              promptSqlNoData: response.promptSqlNoData,
              promptSqlNoData: response.promptSqlNoData,
              IntentGroupID: response.intentGroupID,
              promptTemplate: response.promptTemplate,
              flowGroupID: response.flowGroupID,

              //Line Config
              loadingBarFlag: response.loadingBarFlag,
              loadingBarDuration: response.loadingBarDuration,
              forbiddenWord: response.forbiddenWord == null ? [""] : [...JSON.parse(response.forbiddenWord), ""],
              isShowNameUserMonitor: response.isShowNameUserMonitor,
              monitorLineUserID: response.monitorLineUserID,
              monitorSocialID: response.monitorSocialID,

              //guardrail
              guardRailModelID: response.guardRailModelID,

              // Image generation
              modelType: response.modelType,
              styleImage: response.styleImage,
              resolution: response.resolution,
              resFormatImage: response.resFormatImage,
              quality: response.quality,

              //enableTime
              timeZone: response.timeZone,
              enableTime: response.timeZone ? true : false,
              reasoningEffort: response.reasoningEffort,
            }
            if (side == 'Left') {
              // self.$nextTick(async ()=>{
              self.leftCharacter = dataResponse.data.maximumChatInput;
              self.setMaxCharacter(dataResponse.data.maximumChatInput)
              self.configLeft = resData;
              self.configLeft.side = side;
              self.configLeft.User_Id = userID;
              await self.changeProvider(self.configLeft.provider);
              await self.changeModel(self.configLeft.model, side);
              // })
            } else if (side == 'Right') {

              // self.$nextTick(async ()=>{  
              self.rightCharacter = dataResponse.data.maximumChatInput;
              self.setMaxCharacter(dataResponse.data.maximumChatInput) 
              self.configRight = resData;
              self.configRight.side = side;
              self.configRight.User_Id = userID;
              await self.changeProvider(self.configRight.provider);
              await self.changeModel(self.configRight.model, side);
              // })
            }
            // await self.Edit(dataResponse.data);
          }
          // self.GetUuidv4();
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          // self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    setMaxCharacter(val){
      let self = this;
      if (self.leftCharacter > self.rightCharacter) {
        self.maxCharacter = self.leftCharacter;
      } else {
        self.maxCharacter = self.rightCharacter;
      }
    },
    isemitEvent(val) {
      let self = this;
      if (val == "SaveEdit") {
        self.SaveEdit();
      } else if (val == "Close") {
        self.CreateAndEditDialog = false;
        self.CreateDialogV = false;
        self.EditDialogV = false;
      }
    },
    SaveEdit() {
      let self = this;
      let modelData = Object.assign({}, self.configEdit);
      if (self.configEdit.side == 'Left') {
        if (modelData.modelName == null || modelData.modelName == '') {
          self.$swal.fire({
            icon: 'warning',
            title: self.$t('warning'),
            text: self.$t('warningModelName'),
            showConfirmButton: false,
            timer: 3000,
          });
          return;
        }
        else if (!modelData.provider) {
          self.$swal.fire({
            icon: 'warning',
            title: self.$t('warning'),
            text: self.$t('warningProvider'),
            showConfirmButton: false,
            timer: 3000,
          });
          return;
        }
        else if (!modelData.model) {
          self.$swal.fire({
            icon: 'warning',
            title: self.$t('warning'),
            text: self.$t('warningModel'),
            showConfirmButton: false,
            timer: 3000,
          });
          return;
        }
        else if (modelData.isPublish == null) {
          self.$swal.fire({
            icon: 'warning',
            title: self.$t('warning'),
            text: self.$t('warningPublish'),
            showConfirmButton: false,
            timer: 3000,
          });
          return;
        }
        else if (
          modelData.temperature == null ||
          modelData.temperature < 0 ||
          modelData.temperature > 1 ||
          modelData.temperature === '') {
          self.$swal.fire({
            icon: 'warning',
            title: self.$t('warning'),
            text: self.$t('warningTemperature'),
            showConfirmButton: false,
            timer: 3000,
          });
          return;
        }
        else if (
          modelData.topP == null ||
          modelData.topP < 0 ||
          modelData.topP > 1 ||
          modelData.topP === '') {
          self.$swal.fire({
            icon: 'warning',
            title: self.$t('warning'),
            text: self.$t('warningTopP'),
            showConfirmButton: false,
            timer: 3000,
          });
          return;
        }
        else if ((modelData.topVDB == null && modelData.vectordbName.length > 0)) {
          self.$swal.fire({
            icon: 'warning',
            title: self.$t('warning'),
            text: self.$t('warningTopVDB'),
            showConfirmButton: false,
            timer: 3000,
          });
          return;
        }else if ((modelData.productTopVDB == null && modelData.productGroupID.length > 0)) {
          self.$swal.fire({
            icon: 'warning',
            title: self.$t('warning'),
            text: self.$t('warningTopVDB'),
            showConfirmButton: false,
            timer: 3000,
          });
          return;
        }
        else if ((modelData.APIVersion == '' || modelData.APIVersion == null) && modelData.provider != 'Google') {
          self.$swal.fire({
            icon: 'warning',
            title: self.$t('warning'),
            text: self.$t('warningAPIVersion'),
            showConfirmButton: false,
            timer: 3000,
          });
          return;
        }
        if (typeof self.validatePrompt(modelData.promptTemplate) == 'string') {
          self.$swal.fire({
            icon: 'warning',
            title: self.$t('warning'),
            text: 'Please Enter Correct Format!',
            showConfirmButton: false,
            timer: 1800,
          });
          return;
        }
        self.configLeft = Object.assign({}, modelData);
      }
      else if (self.configEdit.side == 'Right') {
        if (modelData.modelName == null || modelData.modelName == '') {
          self.$swal.fire({
            icon: 'warning',
            title: self.$t('warning'),
            text: self.$t('warningModelName'),
            showConfirmButton: false,
            timer: 3000,
          });
          return;
        }
        else if (!modelData.provider) {
          self.$swal.fire({
            icon: 'warning',
            title: self.$t('warning'),
            text: self.$t('warningProvider'),
            showConfirmButton: false,
            timer: 3000,
          });
          return;
        }
        else if (!modelData.model) {
          self.$swal.fire({
            icon: 'warning',
            title: self.$t('warning'),
            text: self.$t('warningModel'),
            showConfirmButton: false,
            timer: 3000,
          });
          return;
        }
        else if (modelData.isPublish == null) {
          self.$swal.fire({
            icon: 'warning',
            title: self.$t('warning'),
            text: self.$t('warningPublish'),
            showConfirmButton: false,
            timer: 3000,
          });
          return;
        }
        else if (
          modelData.temperature == null ||
          modelData.temperature < 0 ||
          modelData.temperature > 1 ||
          modelData.temperature === '') {
          self.$swal.fire({
            icon: 'warning',
            title: self.$t('warning'),
            text: self.$t('warningTemperature'),
            showConfirmButton: false,
            timer: 3000,
          });
          return;
        }
        else if (
          modelData.topP == null ||
          modelData.topP < 0 ||
          modelData.topP > 1 ||
          modelData.topP === '') {
          self.$swal.fire({
            icon: 'warning',
            title: self.$t('warning'),
            text: self.$t('warningTopP'),
            showConfirmButton: false,
            timer: 3000,
          });
          return;
        }
        else if ((modelData.topVDB == null && modelData.vectordbName.length > 0)) {
          self.$swal.fire({
            icon: 'warning',
            title: self.$t('warning'),
            text: self.$t('warningTopVDB'),
            showConfirmButton: false,
            timer: 3000,
          });
          return;
        }
        else if ((modelData.productTopVDB == null && modelData.productGroupID.length > 0)) {
          self.$swal.fire({
            icon: 'warning',
            title: self.$t('warning'),
            text: self.$t('warningTopVDB'),
            showConfirmButton: false,
            timer: 3000,
          });
          return;
        }
        else if ((modelData.APIVersion == '' || modelData.APIVersion == null) && modelData.provider != 'Google') {
          self.$swal.fire({
            icon: 'warning',
            title: self.$t('warning'),
            text: self.$t('warningAPIVersion'),
            showConfirmButton: false,
            timer: 3000,
          });
          return;
        }
        if (typeof self.validatePrompt(modelData.promptTemplate) == 'string') {
          self.$swal.fire({
            icon: 'warning',
            title: self.$t('warning'),
            text: 'Please Enter Correct Format!',
            showConfirmButton: false,
            timer: 1800,
          });
          return;
        }
        self.configRight = Object.assign({}, self.configEdit);
      }

      self.CreateAndEditDialog = false;
      self.CreateDialogV = false;
      self.EditDialogV = false;
    },
    CreateDialog(val) {
      let self = this;
      this.isPage = "Playground Create"
      self.CreateAndEditDialog = true;
      self.CreateDialogV = true;
      if (val == 'Left') {
        self.configEdit.side = val;
        self.configEdit = Object.assign({}, self.configLeft);
        self.configEdit.User_Id = self.GetUuidv4_Fun();
        self.configEdit.typeUpdate = false;
        self.configEdit.forbiddenWord = [""];
        self.configEdit.gender = "m";
      } else if (val == 'Right') {
        self.configEdit.side = val;
        self.configEdit = Object.assign({}, self.configRight);
        self.configEdit.User_Id = self.GetUuidv4_Fun();
        self.configEdit.typeUpdate = false;
        self.configEdit.forbiddenWord = [""];
        self.configEdit.gender = "m";
      }
    },
    EditDialog(val) {
      let self = this;
      this.isPage = "Playground Edit"
      self.CreateAndEditDialog = true;
      self.EditDialogV = true;
      if (val == 'Left') {
        self.configEdit.side = val;
        self.configEdit = Object.assign({}, self.configLeft);
      } else if (val == 'Right') {
        self.configEdit.side = val;
        self.configEdit = Object.assign({}, self.configRight);
      }
    },
    Save(side) {
      let self = this;
      let typeUpdateData = false;

      let modelData = {};
      const config = side === 'Left' ? self.configLeft : self.configRight;
      modelData = {
        typeLLM: config.typeLLM == 0 ? "Bot" : config.typeLLM == 1 ? "GuardRail" : null,
        modelId: config.modelId,
        modelName: config.modelName,
        provider: config.provider,
        model: config.model,
        APIVersion: config.APIVersion,
        extension: config.extension,
        description: config.description,
        promptTemplate: config.promptTemplate,
        gender: config.gender,
        vectordbName: config.vectordbName == null ? [] : config.vectordbName,
        groupReplaceID: config.groupReplaceID == null ? [] : config.groupReplaceID,
        productGroupID: config.productGroupID == null ? [] : config.productGroupID,
        topVDB: config.topVDB,
        productTopVDB: config.productTopVDB,
        productCosine: config.productCosine,
        internet: config.internet,
        feedback: config.feedback,
        historyCount: config.historyCount,
        historyMinute: config.historyMinute > 0 ? -config.historyMinute : config.historyMinute,
        temperature: config.temperature,
        topP: config.topP,
        frequencyPenalty: config.frequencyPenalty,
        presencePenalty: config.presencePenalty,
        stop: config.stop,
        maxTokens: config.maxTokens,
        isStream: config.isStream,
        isFeedback: config.isFeedback,
        isAllowImage: config.isAllowImage,
        fileUploadLimit: config.fileUploadLimit,
        versioning: config.versioning,
        isPublish: config.isPublish,
        modelIDGroup: config.modelIDGroup,
        modelDisplay: config.modelDisplay,
        Len_ShortMemory: config.Len_ShortMemory ?? 200,
        IsLongTerm_Memory: config.provider == 'Google' ? false : (config.IsLongTerm_Memory ?? false),
        IsChainMassage: config.IsChainMassage ?? false,
        LenChainMassage: config.LenChainMassage,
        TimeSecondChainMassage: config.TimeSecondChainMassage,
        Cosine: config.Cosine,
        DataIntegrationID: config.DataIntegrationID,
        SqlModelID: config.SqlModelID,
        promptSqlNoData: config.promptSqlNoData,
        IntentGroupID: config.IntentGroupID,
        typingSpeed: parseInt(config.typingSpeed),
        maximumChatInput: config.maximumChatInput == null ? 200000 : parseInt(config.maximumChatInput),
        loadingBarFlag: config.loadingBarFlag,
        loadingBarDuration: config.loadingBarDuration,
        isShowNameUserMonitor: config.isShowNameUserMonitor,
        monitorLineUserID: config.monitorLineUserID,
        monitorSocialID: config.monitorSocialID,
        modelType: config.modelType,
        styleImage: config.styleImage,
        resolution: config.resolution,
        resFormatImage: config.resFormatImage,
        jsonRequest: config.jsonRequest,
        quality: config.quality,
        forbiddenWord: JSON.stringify(config.forbiddenWord.filter(word => word != '')),
        timeZone: config.enableTime ? config.timeZone : null,
        reasoningEffort: config.reasoningEffort,
        isAllowLLMChange: config.isAllowLLMChange,
        guardRailModelID: config.typeLLM == 0 ? config.guardRailModelID : null,
        flowGroupID: config.flowGroupID,
      };

      typeUpdateData = config.typeUpdate;
      if (modelData.modelName == null || modelData.modelName == '') {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningModelName'),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
      else if (!modelData.provider) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningProvider'),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
      else if (!modelData.model) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningModel'),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
      else if (modelData.isPublish == null) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningPublish'),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
      else if (modelData.temperature == null ||
        config.temperature < 0 ||
        config.temperature > 1 ||
        config.temperature === '') {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningTemperature'),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
      else if (modelData.topP == null ||
        config.topP < 0 ||
        config.topP > 1 ||
        config.topP === '') {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningTopP'),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
      else if ((modelData.topVDB == null && modelData.vectordbName.length > 0)) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningTopVDB'),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
      else if ((modelData.productTopVDB == null && modelData.productGroupID.length > 0)) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningTopVDB'),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
      else if ((modelData.APIVersion == '' || modelData.APIVersion == null) && modelData.provider != 'Google') {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningAPIVersion'),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
      if (typeof self.validatePrompt(modelData.promptTemplate) == 'string') {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: 'Please Enter Correct Format!',
          showConfirmButton: false,
          timer: 1800,
        });
        return;
      }
      self.dialog = true;
      try {
        modelData.frequencyPenalty = modelData.frequencyPenalty != "" ? modelData.frequencyPenalty : null;
        modelData.presencePenalty = modelData.presencePenalty != "" ? modelData.presencePenalty : null;
        modelData.topVDB = modelData.topVDB != "" ? modelData.topVDB : null;
        modelData.productTopVDB = modelData.productTopVDB != "" ? modelData.productTopVDB : null;
        modelData.IsLongTerm_Memory = modelData.provider == 'Google' ? false : (modelData.IsLongTerm_Memory ?? false);
        modelData.typingSpeed = parseInt(modelData.typingSpeed);
        modelData.maximumChatInput = parseInt(modelData.maximumChatInput);
        if (typeUpdateData == false) {
          self.$call.AddGPTModel(
            modelData,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: 'success',
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.GetModel();
                self.savechange(dataResponse.data, side);
              }
              if (dataResponse.status == 1 && dataResponse.data.is_exist) {
                self.$swal.fire({
                  icon: 'error',
                  title: 'Model Display is exist',
                  showConfirmButton: false,
                  timer: 1800,
                });
              }
              self.dialog = false;
              self.dialogSave = false;
            },
            (errorResource) => {
              self.dialog = false;
              self.dialogSave = false;
              console.error(errorResource);
            }
          );
        } else {
          self.$call.AddGPTModel(
            modelData,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: 'success',
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.GetModel();
              }
              if (dataResponse.status == 1 && dataResponse.data.is_exist) {
                self.$swal.fire({
                  icon: 'error',
                  title: 'Model ID Display publish. Is exist',
                  showConfirmButton: false,
                  timer: 1800,
                });
              }
              self.dialog = false;
              self.dialogSave = false;
            },
            (errorResource) => {
              self.dialog = false;
              self.dialogSave = false;
              console.error(errorResource);
            }
          );
        }
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    checkValidate() {
      if (this.configEdit.vectordbName != null && this.configEdit.vectordbName != '') {
        if (this.configEdit.topVDB == '' || this.configEdit.topVDB == null) {
          return "Required.";
        } else if (parseInt(this.configEdit.topVDB) == 0) {
          return "Required.";
        }
      }
      if (this.configEdit.productGroupID != null && this.configEdit.productGroupID != '') {
        if (this.configEdit.productTopVDB == '' || this.configEdit.productTopVDB == null) {
          return "Required.";
        } else if (parseInt(this.configEdit.productTopVDB) == 0) {
          return "Required.";
        }
      }
      return true;
    },
    isNumber: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46 && charCode !== 45) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isNumberpositive: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    validatePrompt(inputValue) {
      if (!inputValue) {
        return true;
      }
      if (this.maxLengthChar == null) {
        return true
      } else {
        return inputValue.length <= this.maxLengthChar || 'กรุณากรอกข้อมูลตัวอักษรไม่เป็น ' + this.convertNumberToStringFormat(this.maxLengthChar);
      }
    },
    convertNumberToStringFormat(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    ClearModel(val) {
      let self = this;
      let clearData = {
        // StatusforUpdate
        typeUpdate: true,

        // Default
        typeLLM: 0,
        modelDisplay: null,
        modelNameDisplay: null,
        modelName: "",
        provider: "",
        model: "",
        extension: null,
        description: null,
        gender: "m",
        versioning: 1,
        typingSpeed: 40,
        maximumChatInput: 200000,
        isStream: true,
        IsBypass: null,
        isFeedback: null,
        isPublish: true,
        isAllowImage: null,
        fileUploadLimit: null,

        // Vector
        vectordbName: [],
        groupReplaceID: [],
        productGroupID: [],
        topVDB: null,
        Cosine: null,
        productTopVDB: null,
        productCosine: null,
        LenChainMassage: null,
        TimeSecondChainMassage: null,
        IsChainMassage: null,

        // Memory History 
        historyCount: 2,
        historyMinute: -10,
        Len_ShortMemory: 200,
        IsLongTerm_Memory: false,

        // Advance
        temperature: 0,
        topP: 0,
        frequency_penalty: null,
        presence_penalty: null,
        maxTokens: null,
        stop: null,

        // Line Config
        loadingBarFlag: false,
        loadingBarDuration: 0,
        forbiddenWord: [""],
        isShowNameUserMonitor: false,
        monitorLineUserID: null,
        monitorSocialID: null,

        // Data Integration
        DataIntegrationID: null,
        SqlModelID: null,
        promptSqlNoData: null,
        IntentGroupID: null,
        promptTemplate: "",
        
        //enableTime
        enableTime: null,
        timeZone: null,
      }
      if (val == 'Left') {
        self.configLeft = clearData;
        self.configLeft.side = val;
        self.configLeft.User_Id = self.GetUuidv4_Fun();
        self.listMessageLeft = [];
        // Reset topic for Left chat
        self.topicIDLeft = null;
        self.keyTopicLeft = null;

        self.maxCharacter = self.rightCharacter;
        self.leftCharacter = 0;
      } else {
        self.configRight = clearData;
        self.configRight.side = val;
        self.configRight.User_Id = self.GetUuidv4_Fun();
        self.listMessageRight = [];
        // Reset topic for Right chat
        self.topicIDRight = null;
        self.keyTopicRight = null;

        self.maxCharacter = self.leftCharacter;
        self.rightCharacter = 0;
      }

      
      if (self.rightCharacter == 0 && self.leftCharacter == 0 && self.maxCharacter == 0) {
        self.maxCharacter = 200000;
      }

      // else if(self.listMessageRight.length == 0){
      //   self.maxCharacter = self.leftCharacter;
      // }else if(self.listMessageLeft.length == 0 && self.listMessageRight.length == 0){
      //   self.leftCharacter = 0;
      //   self.rightCharacter = 0;
      //   self.maxCharacter = 200000;
      // }

    },
    validatePrompt(inputValue) {
      if (!inputValue) {
        return true;
      }
      if (this.maxLengthChar == null) {
        return true
      } else {
        return inputValue.length <= this.maxLengthChar || 'กรุณากรอกข้อมูลตัวอักษรไม่เป็น ' + this.convertNumberToStringFormat(this.maxLengthChar);
      }
    },
    validateInput0_1(inputValue) {
      // ตรวจสอบว่าข้อมูลที่ป้อนเข้ามาเป็นตัวเลขที่อยู่ระหว่าง 0 ถึง 1 ที่มีทศนิยม 2 ตำ๝หน่ง
      const value = parseFloat(inputValue);
      if (isNaN(value)) return 'Required.';
      return (value >= 0 && value <= 1 && this.isTwoDecimalPlaces(value)) || 'กรุณาป้อนตัวเลขระหว่าง 0 ถึง 1 ที่มีทศนิยม 2 ตำแหน่ง';
    },
    validateInput0_2(inputValue) {
      // ตรวจสอบว่าข้อมูลที่ป้อนเข้ามาเป็นตัวเลขที่อยู่ระหว่าง 0 ถึง 2 ที่มีทศนิยม 2 ตำ๝หน่ง
      const value = parseFloat(inputValue);
      if (isNaN(value)) return true;
      return (value >= 0 && value <= 2 && this.isTwoDecimalPlaces(value)) || 'กรุณาป้อนตัวเลขระหว่าง 0 ถึง 1 ที่มีทศนิยม 2 ตำแหน่ง';
    },
    isTwoDecimalPlaces(number) {
      const regex = /^\d+(\.\d{1,2})?$/;
      return regex.test(number.toString());
    },



  },
};
</script>
<style scoped>
.card2 {
  border-radius: 10px !important;
  /* margin-bottom: 2rem; */
  padding-top: 1rem;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
  display: flex;

  justify-content: space-between;
  align-items: stretch;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: stretch;
  height: 100%;
  padding: 15px;
}

:deep(.custom-textarea .v-input__control .v-input__slot .v-text-field__slot textarea) {
  margin-top: 12px !important;
}


::-webkit-scrollbar {
  height: 7px !important;
  width: 5px !important;
}

::-webkit-scrollbar-thumb {
  border-radius: 3px !important;
}

@keyframes fade-in {
  from {
    opacity: 0;
    transform: translate(-50%, 20px);
  }

  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}

@keyframes fade-out {
  from {
    opacity: 1;
    transform: translate(-50%, 0);
  }

  to {
    opacity: 0;
    transform: translate(-50%, 20px);
  }
}

/* Custom Chat Textarea Styles */
.custom-chat-textarea {
  /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important; */
  border-radius: 16px !important;
  transition: all 0.3s ease !important;
}

.custom-chat-textarea:hover {
  box-shadow: 0 6px 20px rgba(255, 255, 255, 0.12) !important;
}

.custom-chat-textarea :deep(.v-field) {
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%) !important;
  border-radius: 16px !important;
  transition: all 0.3s ease !important;
  min-height: 56px !important;
}
.custom-chat-textarea :deep(.v-field__input) {
  padding: 16px 20px !important;
  font-size: 14px !important;
  line-height: 1.5 !important;
  color: #334155 !important;
}

.custom-chat-textarea :deep(.v-field__input::placeholder) {
  color: #94a3b8 !important;
  font-style: italic !important;
}

.custom-chat-textarea :deep(.v-field__prepend-inner) {
  padding-left: 4px !important;
}

.custom-chat-textarea :deep(.v-field__append-inner) {
  padding-right: 4px !important;
}

/* Button Styles */
.send-button {
  background: linear-gradient(135deg, var(--v-theme-primary) 0%, var(--v-theme-primary-darken-1) 100%) !important;
  box-shadow: 0 2px 8px rgba(var(--v-theme-primary-rgb), 0.3) !important;
  transition: all 0.2s ease !important;
}

.send-button:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(var(--v-theme-primary-rgb), 0.4) !important;
}

.stop-button {
  background: transparent !important;
  transition: all 0.2s ease !important;
}

.stop-button:hover {
  transform: translateY(-1px) !important;
}

.clear-button {
  transition: all 0.2s ease !important;
}

.clear-button:hover {
  background: rgba(113, 113, 122, 0.1) !important;
  transform: scale(1.05) !important;
}

/* Animation for loading states */
@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

.v-btn:disabled {
  animation: pulse 2s infinite;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .custom-chat-textarea :deep(.v-field__input) {
    padding: 12px 16px !important;
    font-size: 16px !important; /* Prevent zoom on iOS */
  }
  
  .custom-chat-textarea :deep(.v-field) {
    min-height: 48px !important;
  }
}

.v-theme--dark .custom-chat-textarea :deep(.v-field__input) {
  color: #e2e8f0 !important;
}

.v-theme--dark .custom-chat-textarea :deep(.v-field__input::placeholder) {
  color: #64748b !important;
}

/* Focus ring enhancement */
.custom-chat-textarea :deep(.v-field--focused) {
  transform: translateY(-1px) !important;
}

/* Character counter styling */
.custom-chat-textarea :deep(.v-counter) {
  font-size: 11px !important;
  color: #64748b !important;
  margin-top: 4px !important;
}

/* Modern Log Toggle Button Styles */
.log-toggle-button {
  backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  border-radius: 12px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative !important;
  overflow: hidden !important;
}

.log-toggle-button:hover {
  transform: translateY(-1px) scale(1.05) !important;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15) !important;
  border-color: rgba(var(--v-theme-primary-rgb), 0.3) !important;
}


.log-toggle-button .v-icon {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.log-toggle-button:hover .v-icon {
  transform: scale(1.1) !important;
}

.modern-number-field {
  transition: all 0.3s ease !important;
}

.modern-number-field :deep(.v-field) {
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%) !important;
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05) !important;
}
.modern-number-field :deep(.v-field__input) {
  padding: 12px 16px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #334155 !important;
  text-align: center !important;
}

.modern-number-field :deep(.v-field__input input) {
  text-align: center !important;
}

.modern-number-field :deep(.v-label) {
  font-size: 12px !important;
  font-weight: 600 !important;
  color: #64748b !important;
  letter-spacing: 0.5px !important;
}

/* Modern Label Styles */
.modern-label {
  font-size: 13px !important;
  font-weight: 600 !important;
  color: #475569 !important;
  letter-spacing: 0.5px !important;
  margin-bottom: 8px !important;
  display: block !important;
}

/* Modern Config Field Styles */
.modern-config-field {
  transition: all 0.3s ease !important;
}

.modern-config-field :deep(.v-field) {
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%) !important;
  border: 2px solid rgba(148, 163, 184, 0.15) !important;
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04) !important;
}

.modern-config-field:hover :deep(.v-field) {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08) !important;
  transform: translateY(-1px) !important;
}

.modern-config-field :deep(.v-field__input) {
  padding: 12px 16px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #334155 !important;
}

.modern-config-field :deep(.v-label) {
  font-size: 12px !important;
  font-weight: 600 !important;
  color: #64748b !important;
}

.modern-config-field :deep(.v-field--focused .v-label) {
  color: var(--v-theme-primary) !important;
}

/* Modern Textarea Styles */
.modern-textarea {
  transition: all 0.3s ease !important;
}

.modern-textarea :deep(.v-field) {
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%) !important;
  border: 2px solid rgba(148, 163, 184, 0.15) !important;
  border-radius: 16px !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
}

.modern-textarea:hover :deep(.v-field) {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
  transform: translateY(-1px) !important;
}
.modern-textarea :deep(.v-field__input) {
  padding: 16px 20px !important;
  font-size: 14px !important;
  line-height: 1.6 !important;
  color: #334155 !important;
  font-family: 'SF Mono', 'Monaco', 'Menlo', 'Ubuntu Mono', monospace !important;
}

.modern-textarea :deep(.v-label) {
  font-size: 13px !important;
  font-weight: 600 !important;
  color: #64748b !important;
  letter-spacing: 0.5px !important;
}

.modern-textarea :deep(.v-counter) {
  font-size: 11px !important;
  color: #94a3b8 !important;
  margin-top: 8px !important;
}

/* Modern Parameter Field Styles */
.modern-parameter-field {
  transition: all 0.3s ease !important;
}

.modern-parameter-field :deep(.v-field) {
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%) !important;
  border: 2px solid rgba(148, 163, 184, 0.12) !important;
  border-radius: 10px !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05) !important;
}

.modern-parameter-field:hover :deep(.v-field) {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08) !important;
  transform: translateY(-0.5px) !important;
}
.modern-parameter-field :deep(.v-field__input) {
  padding: 10px 14px !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #334155 !important;
  text-align: center !important;
}

.modern-parameter-field :deep(.v-field__input input) {
  text-align: center !important;
}

.modern-parameter-field :deep(.v-label) {
  font-size: 11px !important;
  font-weight: 600 !important;
  color: #64748b !important;
  letter-spacing: 0.3px !important;
}
.modern-parameter-field :deep(.v-field--disabled .v-label) {
  color: #94a3b8 !important;
}

.modern-parameter-field :deep(.v-field__prepend-inner) {
  padding-left: 6px !important;
  align-items: center !important;
}

.modern-parameter-field :deep(.v-field__append-inner) {
  padding-right: 6px !important;
  align-items: center !important;
}

/* Enhanced tooltips */
.modern-parameter-field .v-tooltip,
.modern-config-field .v-tooltip,
.modern-textarea .v-tooltip {
  font-size: 12px !important;
  background: rgba(0, 0, 0, 0.85) !important;
  backdrop-filter: blur(4px) !important;
  border-radius: 8px !important;
  max-width: 250px !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .modern-config-field :deep(.v-field__input),
  .modern-parameter-field :deep(.v-field__input) {
    padding: 10px 12px !important;
    font-size: 16px !important; /* Prevent zoom on iOS */
  }
  
  .modern-textarea :deep(.v-field__input) {
    padding: 14px 16px !important;
    font-size: 16px !important;
  }
}



/* disable button remove hover*/
.v-btn:disabled {
  pointer-events: none !important;
  opacity: 0.6 !important;
  transition: none !important;
}

.v-btn:disabled:hover {
  transform: none !important;
  box-shadow: none !important;
  background-color: inherit !important;
  color: inherit !important;
}
</style>